/** @format */

const tr = {
  subscription: "Abonelik",
  startSubscription: "Abonelik başlat",
  notHaveSub: "Aktif aboneliğin bulunmuyor.",
  youCanStartSub: "Aylık $49.99'a ile abonelik başlatarak etkinliklerini yönetmeye başlayabilirsiniz.",
  eventLinks: {
    title: "Bağlantılar",
    webApp: "Katılımcı web uygulaması",
    iosApp: "Katılımcı mobil uygulaması (IOS)",
    androidApp: "Katılımcı mobil uygulaması (Android)"
  },
  datetime: {
    setTime: "Saat belirleyiniz.",
    setDate: "Tarih belirleyniz."
  },
  eventPageTitle: {
    eventHome: "Anasayfa",
    aboutEvent: "Etkinlik Bilgileri",
    dashboard: "Genel bakış",
    search: "Kayıt arama",
    participants: "Katılımcılar",
    segmentation: "Segmentasyon",
    paymentsAndConfirmation: "Satışlar & Onaylar",
    registrationForms: "Kayıt formu",
    speakers: "Konuşmacılar",
    eventProgram: "Etkinlik programı",
    sponsors: "Sponsorlar",
    expo: "Stant alanları",
    networking: "Networking odaları",
    album: "Albüm",
    documentsAndFiles: "Dosyalar & Dökümanlar",
    faq: "Soru kütüphanesi",
    maps: "Haritalar",
    liveSessions: "Canlı oturumlar",
    automatedMessages: "Otomatik iletiler",
    certificates: "Sertifikalar",
    cardDesign: "Kart tasarımları",
    controlPoint: "Kontrol noktaları",
    promotions: "Promosyonlar",
    events: "Etkinlikler",
    organisation: "Kuruluş",
    organisationOverview: "Genel bakış",
    organisationTeam: "Takım",
    organisationProfile: "Profil",
    organisationIntegrations: "Entegrasyonlar",
    organisationBilling: "Faturalandırma"
  },
  eventCopy: {
    copyEvent: "Etkinliği Kopyala",
    eventTitle: "Etkinlik Adı",
    eventCopyType: "Kopyalamak istediğiniz kayıtları seçin",
    eventCopyTitle: "{0} Kopyalanıyor",
    selectAll: "Tümünü seç",
    eventArchive: "Etkinliği Arşivle",
    unarchive: "Arşivden çıkar"
  },
  myOwnEvents: {
    title: "Yönettiğim etkinlikler",
    event: "Etkinlik",
    dateVanue: "Tarih / Mekan"
  },
  validation: {
    plsFillThisField: "Lütfen bu alanı doldurunuz.",
    plsCheckThisField: "Lütfen hatalı alanları kontrol edin."
  },
  placeholder: {
    search: "Ara"
  },
  dotDay: ".Gün",
  dotSaloon: ".Salon",
  minMinutes: "dk",
  buttonGeneral: {
    searchFilter: "Ara / Filtrele",
    show: "Görüntüleme",
    delete: "Sil",
    edit: "Düzenle",
    remove: "Kaldır",
    add: "Ekle",
    refresh: "Yenile",
    notPublished: "Henüz hiç yayınlanmamış.",
    loading: "Yükleniyor..."
  },

  confirmation: {
    couponCode: "Kupon kodu",
    couponCodeMsg: "Mevcut seçimlerinizde kullanabileceğiniz bir kodunuz var ise kodunuzu girdikten sonra uygulaya basınız.",
    button: {
      apply: "Uygula",
      remove: "Kaldır"
    },
    selectCode: "Kodu buraya giriniz"
  },
  abstract: {
    authorSettings: {
      firstNameTitle: "Ad",
      lastNameTitle: "Soyad",
      emailTitle: "E-Posta",
      phoneTitle: "Telefon",
      institutionTitle: "Kurum",
      countryTitle: "Ülke",
      stateTitle: "Mahalle",
      cityTitle: "Şehir"
    }
  },
  summaryComponent: {
    free: "Ücretsiz",
    "individual": "Bireysel",

    address: "Adres",
    identity: "TC NO",
    "payment-information": "Ödeme bilgileri",
    "payment-id": "Ödeme ID",
    date: "Tarih",
    "payment-type": "Ödeme türü",
    "bank-transfer": "Banka transferi",
    "registration-form": "Kayıt formu",
    "event-registration-form": "Etkinlik kayıt formu",
    "coupon-code": "Kupon kodu",
    amount: "Tutar",
    situation: "Durum",
    "waiting-for-approval": "Onay bekliyor",
    "payment-pending": "Ödeme bekliyor",
    approved: "Onaylandı",
    denied: "Reddedildi",
    "transaction-wait-msg": "Kayıt işleminiz tamamlanmıştır. İşleminiz onaylandığında tarafınıza bilgilendirme e-postası gönderilecektir.",
    "transaction-information": "İşlem bilgileri",
    edit: "Düzenle",
    "performer-transaction-name": "İşlemi gerçekleştiren",
    "phone-number": "Telefon",
    "e-mail": "E-posta",
    "invoice-receipt-info": "Fatura / Makbuz bilgileri",
    type: "Tür",
    institutional: "Kurumsal",
    "official-title": "Resmi unvan",
    "tax-no": "Vergi Numarası",
    "tax-administration": "Vergi dairesi",
    address: "Adres",
    records: "Kayıtlar",
    voucher: "Voucher",
    "registration-information": "Kayıt bilgileri",
    companions: "Refakatçiler",
    "additional-service": "Ek hizmetler",
    abstract: "Bildiriler",
    "transaction-note": "İşlem notu",
    service: "Hizmetler",
    "product-service": "Ürün / Hizmet",
    "unit-price": "Br. Fiyat",
    quantity: "Miktar",
    subtotal: "Ara toplam",
    discounts: "İndirimler",
    taxes: "Vergiler",
    total: "Genel toplam",
    "bank-information": "Banka bilgileri",
    "bank-information-no-msg": "Banka bilgileri mevcut değil."
  },
  auth: {
    errorList: {
      badGateway: "Sunucu Bakımda",
      badGatewayDesc: "Yaşamış olduğunuz geçici kesintiden dolayı özür dileriz. Sistem şu an bakım aşamasında olup, en kısa sürede kullanıma tekrar açılacaktır. Bize <a href='mailto:support@holacon.com'>support@holacon.com</a> üzerinden ulaşabilirsiniz. Anlayışınız için teşekkür ederiz."
    },
    forgotPassword: {
      resend: "Tekrar gönder",
      title: "Şifremi unuttum",
      forgotDesc: "Şifre yenileme işlemi için hesabınızın bağlı olduğu e-posta adresini giriniz. Şifre sıfırlama yönergeleri bu e-posta adresine iletilecektir.",
      forgotDescEnterCode: "Lütfen e-posta adresinizde belirtilen kodun doğruluğunu kontrol edin ve şifre ile şifre tekrar alanlarını doldurunuz.",
      email: "E-posta",
      resetKey: "Sıfırlama kodu",
      password: "Şifre",
      repassword: "Şifre (tekrar)",
      reset: "Sıfırla"
    },
    login: {
      login: "Giriş Yap",
      email: "E-posta",
      password: "Şifre",
      placeholderEmail: "Örn : ornek@ornek.com",
      placeholderPassword: "Hesabın şifresi",
      forgotPassword: "Şifremi Unuttum",
      existAccount: "Henüz bir hesabınız yok mu?",
      createAccount: "Buradan hesap oluşturabilirsiniz"
    },
    register: {
      register: "Kayıt Ol",
      registerText: "Yönetici arayüzüne kayıt olmak için gerekli alanları doldurunuz.",
      firstName: "Ad",
      lastName: "Soyad",
      email: "E-posta",
      password: "Şifre",
      repassword: "Şifre (Tekrar)",
      userAgreement: "Kullanıcı Sözleşmesi",
      gdprAgreement: "KVKK Aydınlatma metnini",
      onlineInterview: "Online görüşme açık rıza onayı.",
      distancePolicy: "Mesafeli Satış Sözleşmesini",
      subscriptionPolicy: "Abonelik sözleşmesini",
      privacyPolicy: "Gizlilik Sözleşmesini",
      readApprove: "okudum onaylıyorum.",
      existAccount: "Hesabınız var mı?",
      invitationCode: "Davetiye Kodu",
      invitationCodeText: "Eğer davetiye kodunuz yoksa bu alanı boş bırakabilirsiniz.",
      cancel: "İptal",
      accept: "Kabul Et",
      agreement: {
        userTitle: "Kullanıcı Sözleşmesi"
      }
    }
  },
  event: {
    helpful: {
      title: "Yardımcı özellikler"
    },
    participantManagament: {
      title: "Katılımcı yönetimi"
    },
    menu: {
      eventstart: {
        title: "Başlangıç"
      },

      eventhome: {
        title: "Etkinlik bilgileri",
        searchterms: ["etkinlik bilgileri", "etkinlik logosu", "etkinlik kapak foto", "etkinlik hakkinda", "kayit ekrani", "kayit banner", "alt etkinlik", "online odeme", "sanal pos", "havale", "eft", "sosyal medya", "voucher", "uygulama modulleri", "mobil uygulama", "modul", "iletisim bilgileri", "ayarlar", "otomatik check-in", "kayit ekrani aktif et", "networking ozellikleri", "para birimi", "adres", "etkinlik konum", "etkinlik rengi", "etkinlik yayinla", "etkinlik yayindan kaldir"]
      },

      reports: {
        title: "Raporlar & İstatistikler",
        searchterms: ["raporlar", "giris kayitlari", "giris raporlari", "checkin", "check-in raporlari", "katilim raporlari", "satis raporlari", "rapor", "dashboard"]
      },

      salesregistrations: {
        title: "Kayıtlar & Satışlar"
      },

      registrationsearch: {
        title: "Kayıt arama",
        searchterms: ["kart yazdir", "checkin yap", "check-in yap", "kayit sorgula", "kayit ara"]
      },

      participants: {
        title: "Katılımcı listesi",
        searchterms: ["katilimci listesi", "katilimci ara", "katilimci sorgula", "voucher gonder", "sms gonder", "vekil ekle", "kayit duzenle", "kayit sil", "katilimci engelle", "kayit aktar", "toplu checkin", "toplu check-in", "toplu kayit sil", "toplu katilimci sil", "toplu voucher gonder", "toplu sms gonder", "kayit listesi", "kayit ekle", "katilimci ekle", "kayit olustur", "katilimci olustur"]
      },

      registrationmanagement: {
        title: "Kayıt yönetimi",
        searchterms: []
      },

      registrationforms: {
        title: "Kayıt formu",
        searchterms: ["online kayit formu", "kayit formu", "kayit formu alan", "ozel kayit formu", "kayif formu ozellestirme", "online kayit", "etkinlik kayit formu", "kayit form verisi", "kayit formu input"]
      },
      additionalProduct: {
        title: "Ürünler",
        searchterms: ["online kayit formu", "kayit formu", "kayit formu alan", "ozel kayit formu", "kayif formu ozellestirme", "online kayit", "etkinlik kayit formu", "kayit form verisi", "kayit formu input"]
      },

      registrationgroups: {
        title: "Gruplar",
        searchterms: ["gruplar", "katilimci gruplari", "kayit gruplari", "etiket gruplari"]
      },

      registrationtags: {
        title: "Segmentasyon",
        searchterms: ["etiketler", "katilimci etiketleri", "kayit etiketleri", "katilimci siniflandirma", "kayit siniflandirma", "siniflandirma"]
      },

      registrationpackages: {
        title: "Satış paketleri",
        searchterms: ["satis paketleri", "kayit paketleri", "paketler", "etkinlik kayit", "satis ve kayit paketleri", "kayit tipleri", "kayit"]
      },

      couponcodes: {
        title: "Kupon kodları",
        searchterms: ["indirim kuponlari", "kupon kodları", "kupon", "kupon uretme", "kupon kodu", "kupon kodu uretme", "ucretsiz kayit kodu", "indirim", "indirim kodu", "kayit linki", "ozel kayit linki", "personel kayit linki", "kod listesi"]
      },

      salesconfirmations: {
        title: "Satışlar & Onaylar",
        searchterms: ["satislar", "akreditasyon", "odemeler", "kayitlar", "online kayitlar", "online odemeler", "online odeme kayitlari", "kayit onaylama", "kayit onaylari", "onay verme", "paket satislari", "etkinlik satislari", "kayit akreditasyon", "online akreditasyon", "online kayitlar"]
      },

      subeventregistrations: {
        title: "Alt etkinlikler",
        searchterms: ["alt etkinlik", "alt etkinlik kayit", "program kayit", "kayit"]
      },

      eventstore: {
        title: "Alt etkinlikler / aktiviteler",
        searchterms: ["alt etkinlik", "alt etkinlik kayit", "program kayit", "kayit", "urunler", "urun ekle", "urun duzenle", "urun olustur", "urun kategori", "urun kategorisi", "urun kategorisi ekle", "urun kategorisi olustur", "urun kategorisi duzenle", "urun fiyatlari", "urun satislari", "urun satis listesi", "urun satis raporu", "urun satis raporlari", "etkinlik urunleri", "etkinlik urun satis"]
      },

      accomodation: {
        title: "Konaklama & Transfer",
        searchterms: [
          "otel",
          "oda",
          "oda tipi",
          "konaklama",
          "otel ekle",
          "otel olustur",
          "otel duzenle",
          "oda ekle",
          "oda olustur",
          "oda duzenle",
          "konaklama listesi",
          "konaklama raporu",
          "oda tipi ekle",
          "oda tipi duzenle",
          "oda tipi olustur",
          "transfer",
          "ozel transfer",
          "vip transfer",
          "transfer raporu",
          "transferler",
          "transfer listesi",
          "sofor",
          "sofor bilgileri",
          "sofor duzenle",
          "rota",
          "rotalar",
          "rota olustur",
          "rota ekle",
          "rota duzenle",
          "alim noktalari",
          "transfer araclari",
          "transfer araci ekle",
          "transfer araci olustur",
          "transfer araci duzenle"
        ]
      },

      abstract: {
        title: "Abstract yönetimi",
        searchterms: ["abstract", "abstract modulu", "abstract listesi", "abstract formu", "abstract formlari", "abstract elemeler", "juri", "abstract juri", "degerlendirici", "abstract degerlendirici", "juri ekle", "degerlendirici ekle", "abstract tarihleri", "degerlendirme tarihleri", "abstract elemeleri", "elemeler"]
      },

      contentsmoderation: {
        title: "İçerikler & Moderasyon",
        contentmanagement: {
          session: "Oturum"
        }
      },

      cms: {
        title: "İçerik yönetimi",
        searchterms: []
      },

      speakers: {
        title: "Konuşmacılar",
        searchterms: ["konusmacilar", "konusmaci listesi", "konusmaci ekle", "konusmaci duzenle", "konusmaci"]
      },

      program: {
        title: "Etkinlik programı",
        searchterms: ["etkinlik programi", "program", "akis", "konferans programi", "etkinlik akisi", "kongre programi", "etkinlik gunleri", "etkinlik salonlari", "konferans salonlari", "program hatirlatici", "program alarm", "program duyuru", "etkinlik programi olustur", "etkinlik programi ekle", "program olustur", "program ekle", "program duzenle", "etkinlik programi duzenle"]
      },

      sponsors: {
        title: "Sponsorlar",
        searchterms: ["sponsorlar", "sponsor kategorisi", "sponsor logo", "sponsor ekle", "sponsor duzenle", "sponsor kategori", "sponsor", "logo boyutu", "sponsor ekle", "sponsor olustur"]
      },

      areamap: {
        title: "Harita",
        searchterms: ["alan haritalari", "fuaye", "harita", "haritalar", "fuaye haritalari", "mekan haritalari", "yonlendirme", "alan haritasi ekle", "alan haritasi olustur", "mekan haritasi olustur", "mekan haritasi ekle", "mekan yonlendirme ekle", "mekan yonlendirme olustur", "harita olustur", "harita ekle", "fuaye haritasi olustur", "fuaye haritası ekle"]
      },

      exhibitors: {
        title: "Stant alanları",
        searchterms: ["stand", "stant", "stantlar", "standlar", "stand ekle", "stand duzenle", "stant ekle", "stant duzenle", "sanal stant", "sanal stand"]
      },

      documents: {
        title: "Dosyalar & Dokümanlar",
        searchterms: ["belgeler", "dosyalar", "dosyalar ve belgeler", "sunum ekle", "brosur ekle", "dosya ekle", "sunum dosyalari", "dosya kategori"]
      },

      faq: {
        title: "Soru kütüphanesi",
        searchterms: ["soru kutuphanesi", "sik sorulan sorular", "sss", "faq", "katilimci bilgilendirme", "etkinlik bilgilendiirme", "bilgilendirme icerikleri", "sss ekle", "sss olustur", "faq ekle", "faq olustur", "soru kutuphanesi ekle", "soru kutuphanesi olustur", "sik sorulan sorular olustur", "sik sorulan sorular ekle"]
      },

      moderation: {
        title: "Moderasyon",
        searchterms: []
      },

      reviews: {
        title: "Oturum değerlendirmeleri",
        searchterms: ["oturum degerlendirme", "degerlendirmeler", "icerik degerlendirme", "oturum yorumlar", "oturum puanlar", "oturum yildizlar", "icerik puanlar", "icerik yorumlar", "icerik yildizlar", "program degerlendirme", "program yorumlar", "program yildizlar", "program puanlar"]
      },

      socialhub: {
        title: "Sosyal hub",
        searchterms: ["sosyal medya", "sosyal hub", "paylasim", "paylasim hub", "yorum", "sosyal moderasyon", "paylasim moderasyon", "duyurular", "duyuru yap", "duyuru paylas", "duyuru", "sosyal paylasim", "gonderi paylas", "gonderi yorumlari"]
      },

      surveys: {
        title: "Anketler",
        searchterms: ["anket", "anketler", "etkinlik anketleri", "anket rapor", "anket olustur", "anket ekle", "anket paylas", "anket baslat"]
      },

      polls: {
        title: "Canlı oylama",
        searchterms: ["canli oylama", "oylama", "polls", "keypad", "oylama rapor", "oylama baslat", "oylama paylas", "oylama ekle", "oylama olustur"]
      },

      questions: {
        title: "Konuşmacıya sor",
        searchterms: ["konusmaciya sor", "soru sistemi", "online soru sor", "canli soru sor", "konusmaciya soru sor", "soru konusu", "online soru baslat", "canli soru baslat", "canli sorular"]
      },

      networkingrooms: {
        title: "Networking odaları",
        searchterms: ["networking alanlari", "sanal networking", "networking odalari", "canli networking", "live networking", "goruntulu gorusme", "canli gorusme", "networking masalari", "networking alani ekle", "networking olustur", "networking odasi ekle", "networking odasi olustur", "canli korusme odasi ekle", "canli gorusme odasi olustur", "canli gorusme ekle", "canli gorusme olustur", "networking ekle", "networking olustur", "networking"]
      },

      album: {
        title: "Albüm"
      },

      livesessions: {
        title: "Canlı oturumlar",
        searchterms: ["canli yayin sistemi", "live event", "virtual event", "sanal event", "sanal etkinlik", "live etkinlik", "canli etkinlik", "canli oturum", "sanal oturum", "live event experience", "canli oturum ekle", "sanal oturum ekle", "live oturum ekle", "live program ekle", "canli yayin ekle", "canli yayin kayit", "canli yayin olustur"]
      },

      modules: {
        title: "Modüller",
        searchterms: []
      },

      toolshelpers: {
        title: "Yardımcı uygulamalar",
        searchterms: []
      },
      recordSales: {
        participants: "Katılımcı listesi",
        searchterms: []
      },
      rsvps: {
        title: "Lcv & E-davetiye",
        searchterms: [
          "davetiye",
          "edavetiye",
          "e-davetiye",
          "lcv",
          "e-lcv",
          "elcv",
          "alici grubu",
          "alici listesi",
          "davetiye gonder",
          "davetiye taslaklari",
          "davetiye olustur",
          "davetiye ekle",
          "davetiye duzenle",
          "davetiye taslak olustur",
          "davetiye taslak ekle",
          "davetiye taslak duzenle",
          "davetiye alici grubu",
          "davetiye alici listesi",
          "davetli listesi aktar",
          "davetiye durumu",
          "davetiye raporu",
          "edavetiye gonder",
          "edavetiye taslaklari",
          "edavetiye olustur",
          "edavetiye ekle",
          "edavetiye duzenle",
          "edavetiye taslak olustur",
          "edavetiye taslak ekle",
          "edavetiye taslak duzenle",
          "edavetiye alici grubu",
          "edavetiye alici listesi",
          "edavetiye listesi aktar",
          "edavetiye durumu",
          "edavetiye raporu",
          "e-davetiye gonder",
          "e-davetiye taslaklari",
          "e-davetiye olustur",
          "e-davetiye ekle",
          "e-davetiye duzenle",
          "e-davetiye taslak olustur",
          "e-davetiye taslak ekle",
          "e-davetiye taslak duzenle",
          "e-davetiye alici grubu",
          "e-davetiye alici listesi",
          "e-davetiye listesi aktar",
          "e-davetiye durumu",
          "e-davetiye raporu",
          "lcv aramalari",
          "lcv yap",
          "lcv listesi",
          "lcv lsitesi aktar",
          "lcv durumu",
          "lcv raporu",
          "elcv aramalari",
          "elcv yap",
          "elcv listesi",
          "elcv listesi aktar",
          "elcv durumu",
          "elcv raporu",
          "e-lcv aramalari",
          "e-lcv yap",
          "e-lcv listesi",
          "e-lcv listesi aktar",
          "e-lcv durumu",
          "e-lcv raporu"
        ]
      },

      certificastes: {
        title: "Dijital sertifika",
        searchterms: [
          "sertifika",
          "sertifikalar",
          "dijital sertifika",
          "sanal sertifika",
          "sertifika olustur",
          "alici grubu",
          "sertifika alici grubu",
          "alici grubu olustur",
          "alici grubu duzenle",
          "alici grubu ekle",
          "sertifika alici grubu olustur",
          "sertifika alici grubu duzenle",
          "sertifika alici grubu ekle",
          "sertifika alicilar",
          "sertifika tasarla",
          "sertifika tasarimi",
          "sertifika tasarimi ekle",
          "sertifika tasarimi olustur",
          "sertifika tasarimi duzenle",
          "sertifika tasarimlari",
          "sertifika gonder",
          "sertifika dogrula",
          "sertifika dogrulayici"
        ]
      },

      tableplanner: {
        title: "Oturma düzeni planlayıcı",
        searchterms: ["oturma duzeni", "masa duzeni", "oturma planlayici", "masa planlayici", "masa numarasi", "oturma duzeni ekle", "oturma duzei olustur", "oturma duzeni dozenle", "masa duzeni ekle", "masa duzeni olustur", "masa duzeni duzenle", "masa numarasi olustur", "masa ekle", "masa olustur", "sandalye ekle", "sandalye olustur", "masa tipi", "masa tipi ekle", "masa tipi olustur", "masa tipi duzenle"]
      },

      tweetwall: {
        title: "Tweet wall",
        searchterms: ["twitwall", "socialwall", "twitter", "tweetwall", "twit wall", "tweet wall", "social wall", "socialwaal", "sosyal wall", "sosyal duvar", "twit", "tweet"]
      },

      onsiteutilities: {
        title: "Onsite & Araçlar",
        searchterms: []
      },

      promotions: {
        title: "Promosyonlar",
        searchterms: ["promosyonlar", "promosyon listesi", "promosyon ekle", "promosyon duzenle", "promosyon olustur", "promosyon dagit", "promosyon stok", "promosyon durum", "promosyon sistemi", "promosyon raporu"]
      },

      controlpoints: {
        title: "Kontrol noktaları",
        searchterms: [
          "kontrol noktalari",
          "giris kontrol",
          "katilim kontrol",
          "giris cikis kontrol",
          "giris raporu",
          "giris listesi",
          "giris kisitlamasi",
          "katilim kisitlamasi",
          "oturum kisitlamasi",
          "gecis kisitlamasi",
          "gecis raporlari",
          "gecis listesi",
          "gecis kontrol",
          "herkes gecebilir",
          "etiket kisitlamasi",
          "etiket gecis kisitlamasi",
          "katilimci gecis kisitlamasi",
          "katilimci giris kisitlamasi",
          "alt etkinlik giris kisitlamasi",
          "alt etkinlik gecis kontrolu",
          "live event giris kontrolu",
          "online event giris kontrolu",
          "canli yayin giris kontrolu",
          "canli etkinlik giris kontrolu",
          "canli event giris kontrolu",
          "alt etkinlik gecis kontrolu",
          "live event gecis kontrolu",
          "online event gecis kontrolu",
          "canli yayin gecis kontrolu",
          "canli etkinlik gecis kontrolu",
          "canli event gecis kontrolu",
          "alt etkinlik gecis kisitlamasi",
          "live event giris kisitlamasi",
          "online event giris kisitlamasi",
          "canli yayin giris kisitlamasi",
          "canli etkinlik giris kisitlamasi",
          "canli event giris kisitlamasi",
          "alt etkinlik gecis kisitlamasi",
          "live event gecis kisitlamasi",
          "online event gecis kisitlamasi",
          "canli yayin gecis kisitlamasi",
          "canli etkinlik gecis kisitlamasi",
          "canli event gecis kisitlamasi",
          "alt etkinlik gecis durum",
          "live event giris durum",
          "online event giris durum",
          "canli yayin giris durum",
          "canli etkinlik giris durum",
          "canli event giris durum",
          "alt etkinlik gecis durum",
          "live event gecis durum",
          "online event gecis durum",
          "canli yayin gecis durum",
          "canli etkinlik gecis durum",
          "canli event gecis durum",
          "alt etkinlik gecis rapor",
          "live event giris rapor",
          "online event giris rapor",
          "canli yayin giris rapor",
          "canli etkinlik giris rapor",
          "canli event giris rapor",
          "alt etkinlik gecis rapor",
          "live event gecis rapor",
          "online event gecis rapor",
          "canli yayin gecis rapor",
          "canli etkinlik gecis rapor",
          "canli event gecis rapor",
          "alt etkinlik gecis kayit",
          "live event giris kayit",
          "online event giris kayit",
          "canli yayin giris kayit",
          "canli etkinlik giris kayit",
          "canli event giris kayit",
          "alt etkinlik gecis kayit",
          "live event gecis kayit",
          "online event gecis kayit",
          "canli yayin gecis kayit",
          "canli etkinlik gecis kayit",
          "canli event gecis kayit"
        ]
      },

      controlequipments: {
        title: "Kontrol ekipmanları",
        searchterms: ["turnike", "tunike gecis kontrol", "turnike giris kontrol", "giris kayitlari", "giris raporlari", "gecis kayitlari", "gecis raporlari", "turnike giris raporlari", "turnike gecis kayitlari", "mobil kontrol", "mobil gecis kontrol", "mobil giris kontrol", "mobil giris raporlari", "mobil gecis kayitlari", "kontrolcu", "giris kontrolcu", "gecis kontrolcu", "mobil kontrol sarj durumu", "kontrolcu listesi", "giris kontrol listesi", "gecis kontrol listesi"]
      },

      badgedesigner: {
        title: "Kart tasarlayıcı",
        searchterms: [
          "kart baski",
          "kart baski tasarimi",
          "kart baski tasarimi olustur",
          "kart baski template olustur",
          "kart baski taslak olustur",
          "kart baski tasarimi ekle",
          "kart baski template ekle",
          "kart baski taslak ekle",
          "kart baski tasarimi duzenle",
          "kart baski template duzenle",
          "kart baski taslak duzenle",
          "yaka karti",
          "yaka karti baski",
          "yaka kart baski tasarimi",
          "yaka kart baski tasarimi olustur",
          "yaka kart baski template olustur",
          "yaka kart baski taslak olustur",
          "yaka kart baski tasarimi ekle",
          "yaka kart baski template ekle",
          "yaka kart baski taslak ekle",
          "yaka kart baski tasarimi duzenle",
          "yaka kart baski template duzenle",
          "yaka kart baski taslak duzenle"
        ]
      },

      messages: {
        title: "Otomatik iletiler",
        searchterms: []
      },

      eventusers: {
        title: "Kullanıcılar",
        searchterms: ["kullanicilar", "yoneticiler", "yetki grubu", "yetki gruplari", "yetkiler", "yetkilendirme", "davet etme", "kullanici daveti", "yonetici daveti", "takim arkadasi", "takim arkadasi davet et", "takim arkadasi yetkilendir", "kullanici yetkilendir", "kullanici ekle", "yonetici ekle", "kullanici sil", "kullanici engelle", "yonetici sil", "yonetici engelle"]
      }
    },

    components: {
      eventInfo: {
        about: {
          title: "Etkinlik hakkında",
          eventName: "Etkinlik adı",
          eventColor: "Renk",
          date: "Başlangıç & Bitiş tarihi",
          logo: {
            title: "Logo",
            description: "500 x 500 piksel",
            cancel: "Sil"
          },
          cover: {
            title: "Kapak fotoğrafı",
            description: "1120 x 500 piksel",
            cancel: "Sil"
          },
          aboutEvent: {
            title: "Etkinlik hakkında"
          }
        },
        location: {
          title: "Konum ve adres",
          country: "Ülke",
          city: "Şehir",
          address: "Adres",
          venueName: "Mekan Adı"
        },
        social: {
          title: "Sosyal medya",
          page: "website"
        },
        contact: {
          title: "İletişim",
          firmName: "Organizatör firma",
          contactNum: "İletişim tlefon numarası",
          contactMail: "İletişim e-posta adresi",
          address: "Adres"
        },
        settings: {
          title: "Genel ayarlar",
          currency: {
            title: "Para Birimi",
            description: "Seçilen para birimi etkinlik genelindeki tüm parasal işlem gerektiren yerler için kullanılacaktır."
          },
          autoCheckin: {
            title: "Otomatik Check-in Modu",
            description: "Yaka kartı, QR kod ya da Voucher'a sahip olan katılımcılar geçiş kontrol noktalarından direk geçiş yapabilirler. Bu seçenek aktif hale getirildiğinde, katılımcıların kodu ilk okutmasında check-inleri  sistem tarafından otomatik olarak yapılacaktır."
          },
          users: {
            part1: "Katılımcıları ",
            part2: " dakika sonra ilk giriş kontrolünde tekrar check-in yap."
          },
          networking: {
            title: "Networking Özellikleri",
            description: "Networkin özellikleri aktif edilmediğinde katılımcılar mobil uygulama üzerinden diğer katılımcıları görüntüleyemez, sosyal alanlarda içerik paylaşamazlar.",
            active: "Evet, Aktif Edilsin",
            inactive: "Hayır, Aktif Edilmesin"
          },
          displayRegister: {
            title: "Online Kayıt Ekranı",
            description: "Bu özelliği aktif hale getirdiğinizde, online kayıt ve satış paketleriniz yayına alınır ve kayıt ve satışlarını almaya başlayabilirsiniz.  Aktif olmadığı durumda kayıt ekranınız görüntülenemez ve kayıt alamazsınız."
          }
        },
        register: {
          title: "Online kayıt ekranı",
          ticketDisplay: "Bilet Ekranı Başlığı",
          upperBanner: "Üst Banner (1000x100 px ölçülerinde)",
          lowerBanner: "Alt Banner (1000x100 px ölçülerinde)",
          ticketDisplayDesc: "Bilet Ekranı Açıklama Yazısı",
          thirdPartyHead: "3. Parti Kod Yerleştirme (Head Etiketi)",
          thirdPartyBody: "3. Parti Kod Yerleştirme (Body Etiketi)"
        },
        payment: {
          title: "Ödeme ayarları",
          creditCard: {
            title: "Online Kredi Kartı ile Ödeme",
            register: "Online Ödemeli Kayıt:",
            selectPos: "Pos Seçin",
            posDesc: "Online kredi kartı ve banka kartı ile ödeme alabilmek için bu seçenek aktifleştirilmelidir.  Ödeme alabilmeniz için bankanıza Sanal POS başvurusunda bulunmalı ve başvurunuza onay almalısınız.",
            description: {
              title: "Holacon'da kullanılabilir tüm sanal POS'lar aşağıda listelenmiştir. Herhangi bir POS'u aktif etmek ve online satışlarınızda kullanmak için support@holacon.com adresinden bizimle iletişime geçebilirsiniz.",
              description: {
                title: "POS başvurusunda bulunurken",
                condition1: "Eğer POS aldığınız banka ya da ortak ödeme kuruluşu herhangi bir IP kısıtlaması yapıyor ise bankanızla iletişime geçiniz.",
                condition2: "Holacon üzerindeki satışlar 3Ds olarak yapılmaktadır. POS'unuzda 3Ds kullanımın aktif olduğunu teyit ediniz.",
                condition3: "(Terminal ID (ClientId), Api Kullanıcı Adı, Api Şifresi, StoreKey) bilgilerini başvuru sırasında tarafımıza iletmeniz gerekmektedir."
              }
            }
          },
          transfer: {
            title: "Havale ile Ödeme",
            register: "Havale İle Ödemeli Kayıt",
            description: "Bu seçeneği aktif hale getirerek etkinlik satışlarınızda banka havalesi ile ödeme alabilirsiniz. Sistem işlem esnasında bir havale kodu oluşturur ve katılımcıdan havale kodunu ödeme açıklamasına girmesi istenir.",
            info: {
              title: 'Aşağıda belirteceğiniz banka bilgileri, online ödeme ekranında "Havale İle Ödeme" seçeneğini işaretleyen katılımcılara gösterilir ve belirtilen banka bilgilerinden herhangi birine ödeme yapması istenir.',
              bankName: "Banka adı",
              iban: "IBAN",
              accountNo: "Hesap no",
              recipient: "Hesap adı",
              branchNo: "Şube kodu",
              swift: "Swift kodu"
            }
          }
        },
        subEvents: {
          title: "Alt etkinlikler",
          navbar: {
            filterRecord: "Alt etkinlik adına göre ara..."
          }
        },
        voucher: {
          title: "Voucher Taslakları",
          modalTitle: "Voucher Taslağı Ekle / Düzenle"
        },
        modules: {
          title: "Uygulama Modülleri",
          tableTitle: "Webview Modül Ekle/Düzenle",
          webview: "Webview Modüller"
        }
      },
      query: {
        normal: "Normal kayıt",
        press: "Basın",
        standard: "Standard Katılım",
        oneday: "Tek Gün Katılım",
        sebeventPackege: "Tek Sponsorlu Alt Etkinlik Paketi",
        student: "Öğrenci",
        titleOthers: "Diğer Kayıt Bilgileri",
        email: "E-Posta",
        phone: "Normal Telefon 2",
        dayRest: "Gün Kısıtlaması"
      },
      participants: {
        title: "Katılımcılar",
        navbar: {
          transfer: {
            title: "Aktarım",
            export: "Dışa aktar",
            import: "İçe aktar",
            createTask: "Taslak oluştur",
            exTask: "Örnek taslak",
            transferDraft: "aktarım taslağı",
            searchFilter: "Ara / Filtrele"
          },
          certificate: {
            title: "Sertifika",
            all: "Tümüne gönder"
          },
          filterRecord: "Kayıtları Filtrele",
          add: "Ekle",
          tags: "Katılımcı etiketleri",
          category: "Paket kategorileri"
        }
      },
      registerEvent: {
        groups: "Katılımcı grupları",
        registerSubevent: "Alt etkinlik kayıt",
        sales: "Satış paketleri",
        coupon: "İndirim kuponları",
        paymentApp: "Ödemeler & Onaylar"
      },
      sponsors: {
        main: "Ana Sponsorlar",
        co: "Co-Sponsorlar",
        services: "Hizmet Sponsorları",
        supports: "Destek Sponsorları",
        example: "Örnek kategori",
        add: "Kategori ekle"
      },
      moderation: {
        title: "Oturum Değerlendirmeleri",
        social: {
          pic: "Duyurunuza görsel yüklemek için tıklayınız."
        },
        vote: {
          title: "Ekle / Düzenle",
          which: "İlişkili oturum",
          votePassive: "Kapalı",
          voteActive: "Aktif",
          screenPassive: "Kapalı",
          screenActive: "Aktif"
        },
        askToSpeaker: {
          title: "Başlıklar",
          questionNumber: "Soru sayısı",
          newQuestions: "Yeni sorular",
          seeQuestions: "Soruları gör",
          openScreen: "Ekrana yansıt",
          yesGet: "Evet",
          noDont: "Hayır"
        }
      },
      liveEventExp: {
        title: "Canlı Yayın",
        nav: {
          scenes: {
            title: "Sahneler",
            designs: "Sahne tasarımları",
            addScene: "Sahne Ekle/Düzenle",
            topBanner: "Üst Banner Yükle",
            topBannerDesc: "1000x100 px (en maks 1000px, min 100px)",
            background: "Arkaplan Yükle",
            backgroundDesc: "1920x1200 px",
            bottomBanner: "Alt banner yükle",
            bottomBannerDesc: "1000x100 px (en maks 1000px, min 100px)"
          }
        }
      },
      rsvps: {
        menu: {
          tags: "Etiketler"
        }
      }
    },

    filter: {
      title: "Kayıtları Filtrele",

      search: "Arama",
      group: "Katılımcı grubu",
      tag: "Katılımcı etiketi",
      day: "Gün",
      stage: "Salon",
      allStages: "Tüm salonlar",
      registrationForm: "Kayıt formu",
      registrationPackets: "Paketler",
      paymentInfo: "Ödeme ve kayıt bilgileri",
      paymentID: "Ödeme ID",
      couponCode: "Kupon kodu",
      paymentStatus: "Ödeme durumu",
      paymentType: "Ödeme tipi",
      dayRestriction: "Gün kısıtlaması",
      subEvents: "Alt etkinlikler",
      filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
      voucherInfo: "Otomatik ileti bilgisi",
      shippingStatus: "Gönderim durumu",
      voucherType: "Voucher tipi",
      automatedMessageId: "Otomatik İleti",
      automatedMessageStatus: "Otomatik İleti Durumu",
      automatedMessageType: "Otomatik İleti Tipi",

      messageStatus: "İleti durumu",

      promotions: "Promosyonlar",
      participantNo: "Katılımcı NO",

      activationInfo: "Aktivasyon bilgisi",
      activationStatus: "Aktivasyon durumu",
      activationCode: "Aktivasyon kodu",

      checkinInfo: "Check-in bilgisi",
      checkinStatus: "Check-in durumu",

      all: "Tümü",
      checkedIn: "Check-in yapanlar",
      unchecked: "Check-in yapmayanlar",
      dates: "Tarih aralığı",

      cardPrintInfo: "Kart baskı bilgisi",
      createDateInfo: "Kayıt tarihi",
      cardPrintStatus: "Baskı durumu",
      cardPrinted: "Kart basılanlar",
      cardNonPrinted: "Kart basılmayanlar",
      minDate: "Minimum tarih",
      maxDate: "Maksimum tarih"
    },
    variables: {
      tr: "Türkçe",
      en: "İngilizce",
      yes: "Evet",
      no: "Hayır",
      new: "yeni",
      media: "medya",
      singular: "tekil",
      minutes: "dakika",
      like: "beğeni",
      comment: "yorum",
      waitApprovement: "Onay gerekli",
      autoApprovement: "Otomatik onay",
      name: "İsim",
      surname: "Soyisim",
      email: "E-Posta",
      phone: "Telefon",
      firmSchool: "Kurum/Üniversite",
      titleSection: "Ünvan/Bölüm",
      moreInfo: "Ek bilgi",
      invitationCode: "Davetiye kodu"
    },
    tags: {
      pending: "Beklemede",
      speakers: "Konuşmacılar",
      program: "Program",
      sponsors: "Sponsorlar",
      participants: "Katılımcılar",
      social: "Sosyal hub",
      album: "Fotoğraf albümü",
      surveys: "Anketler",
      voting: "Canlı oylama",
      askToSpeaker: "Konuşmacıya sor",
      areaMaps: "Alan haritaları",
      areaMap: "Alan haritası",
      library: "S.S.S",
      documents: "Dökümanlar",
      stand: "Stantlar",
      all: "Tümü",
      approved: "Onaylandı",
      canceled: "İptal Edildi",
      sponsorLogo: "Sponsor Logosu (min. 500x500 px)",
      stantCoverImg: "Stant kapak görseli",
      stantImg: "Stant görseli",
      editSponsor: "Sponsor Ekle / Düzenle",
      active: "Aktif",
      passive: "Pasif",
      sizeLogo: "Logo Boyutu",
      stants: "Stantlar",
      saloons: "Salonlar",
      links: "Linkler",
      description: "Açıklama",
      docs: "Dosyalar & Belgeler",
      editDocs: "Dosya & Belge Ekle / Düzenle",
      editQuest: "Soru Ekle / Düzenle",
      socialHub: "Sosyal Hub",
      editSurvey: "Anket Ekle / Düzenle",
      responsesSurvey: "Anket yanıtları",
      questions: "Sorular",
      secretSurvey: "Kapalı Anket",
      statisticsSurvey: "Anket istatistikleri",
      addQuestion: "Soru ekle",
      editLive: "Canlı Oylama Ekle/Düzenle",
      editSession: "Canlı oturum Ekle / Düzenle",
      whichSession: "Bağlı oturum",
      allSessions: "Tüm oturumlar",
      session: "Oturum",
      moderationAct: "Moderasyon aktif edilsin mi?",
      getQuest: "Yeni sorular silinsin",
      editLabel: "Etiket Ekle / Düzenle",
      addGroup: "Grup ekle",
      editGroup: "Grup Düzenle",
      addVimeo: "Vimeo canlı oturum Ekle / Düzenle",
      startEndDate: "Başlangıç - bitiş tarihi (Aralık seçiniz)",
      cloudArchiving: "Bulut Arşivleme",
      deactive_: "Pasif",
      active_: "Aktif",
      archiveVimeo: "Arşivleme işlemi vimeo üzerinden yapılmalıdır.",
      addParticipant: "Katılımcı ekle",
      editParticipant: "Katılımcı düzenle",
      editPrintDesign: "Baskı Tasarımı ekle / düzenle",
      accessType: "Erişim tipi",
      backgroundImg: "Arkaplan görseli",
      backgroundImgDesc: "1920x1200 px",
      certDesign: "Sertifika Tasarımları",
      participationCert: "Katılım Sertifikası",
      certTitle: "Sertifika başlığı",
      editGuest: "Katılımcı Ekle / Düzenle",
      editTask: "Taslak Ekle / Düzenle",
      guestLabel: "Katılımcı etiketi",
      guestLabels: "Katılımcı etiketleri",
      colorCode: "Renk kodu",
      currentPack: "Geçerli paketler",
      task: "Taslak",
      lcvTask: "LCV & Davetiye Taslakları",
      editGuestLabel: "Davetli etiketi Ekle / Düzenle",
      editParticipant_: "Katılımcı Ekle / Düzenle",
      editPromo: "Promosyon Ekle / Düzenle",
      editCheckpoint: "Kontrol noktası Ekle / Düzenle",
      addCheckpoint: "Kontrol noktası ekle",
      entryRecord: "Giriş kontrol kayıtları",
      height: "Yükseklik (mm)",
      width: "Genişlik (mm)",
      mt: "Üst boşluk (mm)",
      mb: "Alt boşluk (mm)",
      ml: "Sol boşluk (mm)",
      mr: "Sağ boşuk (mm)",
      mail: "Kullanıcı E-Posta:",
      authNo: "Yetki sayısı",
      editPack: "Paket kategorisi Ekle / Düzenle",
      editStand: "Stant Ekle / Düzenle",
      standHalls: "Stant salonları",
      halls: "Salonlar",
      editCustom: "Özel alan Ekle / Düzenle",
      editSubEvent: "Alt etkinlik Ekle / Düzenle",
      addSubEvent: "Alt etkinlik ekle",
      addNewProduct: "Ürün Ekle / Düzenle",
      stockQuantity: "Stok adedi",
      editVoucher: "Voucher taslağı Ekle / Düzenle",
      addProxy: "Vekil Ekle"
    },
    buttons: {
      update: "Güncelle",
      save: "Kaydet",
      logout: "Çıkış yap",
      clear: "Temizle",
      published: "Yayınlandı",
      notPublished: "Yayınlanmadı",
      deleteAccount: "Hesabı sil",
      addAccount: "Banka hesabı ekle",
      active: "Aktif",
      inactive: "Pasif",
      go: "Git",
      remove: "Kaldır",
      close: "Kapat",
      displayOptions: "Görüntüleme seçenekleri",
      all: "Tümü",
      selectAll: "Tümünü seç",
      unselectAll: "Seçimi bırak",
      closeDetailed: "Kapat",
      addDay: "Gün ekle",
      editDay: "Gün Ekle / Düzenle",
      editStage: "Salon Ekle / Düzenle",
      editProgram: "Program Ekle / Düzenle",
      embed: "Web sitesine yerleştirin",
      showSpeakers: "Konuşmacıları göster",
      hideSpeakers: "Konuşmacıları gizle",
      announcement: "Duyuru paylaş",
      goLiveVote: "Canlı Oylama Ekranı",
      addAnswer: "Cevap ekle",
      edit: "Düzenle",
      downloadReport: "Rapor İndir",
      showAnswers: "Verilen Yanıtları Gör",
      showNotifications: "Hatırlatma Bildirimini Göster",
      copy: "Kopyala",
      addNew: "Yeni Ekle",
      refresh: "Yenile",
      helpdesk: "Yardım Masası",
      details: "Detaylar",
      reset: "Sıfırla",
      openDetailed: "Detaylı aramayı aç",
      closeDetailed: "Detaylı aramayı kapat ",
      cancel: "Vazgeç",
      hide: "Gizle",
      show: "Göster",
      addStage: "Yeni salon ekle",
      editCat: "Kategori düzenle",
      addSponsor: "Sponsor ekle",
      addCategory: "Kategori Ekle / Düzenle",
      addSpeaker: "Konuşmacı Ekle / Düzenle",
      delete: "Sil",
      checkinList: "Check-in listesi",
      addLink: "Yeni link ekle",
      goLiveVoting: "Canlı oylama ekranı",
      select_: "Seç",
      selected: "Seçildi",
      changeBackground: "Arkaplanı değiştir",
      designCert: "Yeni sertifika tasarla",
      addText: "Metin ekle",
      addImg: "Görsel ekle",
      var: "Değişkenler",
      back: "Geri",
      tasks: "Taslaklar",
      authGroup: "Yetki grubu",
      authGroups: "Yetki grupları",
      authorize: "Yetkilendir",
      filter: "Filtrele",
      view: "Görüntüle",
      seeAbstractDetails: "Abstract detaylarını gör",
      undoChanges: "Değişiklikleri geri al",
      sendAgain: "Tekrar gönder",
      registerLink: "Kayıt Linki"
    },

    textbox: {
      search: "Ara...",
      search_: "Arama...",
      searchPID: "Katılımcı bilgisine göre arayın...",
      searchCC: "Kupon koduna göre arayın...",
      maxCheckinDate: "Maksimum check-in tarihi",
      minCheckinDate: "Minimum check-in tarihi",
      select: "Seçiniz",
      selectTag: "Etiket seçimi",
      filterPack: "Pakete göre filtrele",
      selectPack: "Paket seçin",
      selectSub: "Alt etkinlik seçin",
      filterAreaType: "Alan tipine göre filtrele",
      filterGrp: "Gruba göre arama yapın...",
      filterLabel: "Ara...",
      toDelete: "Kaydı silmek istediğinizden emin misiniz?",
      sendNotify: "Tüm katılımcılara hatırlatıcı iletilecek, emin misiniz?",
      payType: "Ödeme tipi seçin",
      payStat: "Ödeme durumu seçin",
      expLib: "ÖRN: Wi-fi şifresi nedir?",
      speakerFilter: "Konuşmacı adı, firma ve ünvan bilgilerine göre arama yapabilirsiniz...",
      libSearch: "Soru başlığına ya da içeriğine göre arama...",
      programrateSearch: "Değerlendirmeye göre arama...",
      expVIP: "ÖRN: VIP katılımcılar",
      searchForParticipant: "Katılımcılar içerisinde arayın...",
      datePickerStart: "Başlangıç tarih & aaat",
      datePickerEnd: "Bitiş tarih & saat",
      datePickerStart_: "Başlangıç Tarih",
      datePickerEnd_: "Bitiş tarih",
      selectStatus: "Durum seçimi",
      selectTask: "Taslak seçiniz",
      selectPromo: "Promosyon seçin",
      searchPromo: "Promosyon adına göre arama yapabilirsiniz...",
      selectAuth: "Yetki grubu seçin",
      use: "Giriş işlemlerinde kullanılacaktır...",
      selectLang: "Dil seçimi",
      proxy: "Vekil ekleme sebebinizi belirtiniz.",
      selectVoucher: "Voucher tipi seçiniz",
      selectVtemp: "Voucher taslağı seçiniz",
      certNote: "Etkinliğimize göstermiş olduğunuz ilgi ve katılımlarınızdan dolayı bu sertifikayı almaya hak kazandınız. Başarılarınızın devamını dileriz.",
      certAppeal: "Sayın %participant.name% %participant.surname% ",
      selectPromotion: "Promosyon seçiniz"
    },

    table: {
      title: "Başlık",
      title_: "Ünvan",
      firstname: "Ad",
      lastname: "Soyad",
      fullname: "Ad & Soyad",
      participantNO: "Katılımcı no",
      certNO: "Sertifika no",
      checkpoint: "Kontrol noktası",
      stock: "Stok",
      confirmationRequired: "Onay gerekli",
      recordActive: "Kayıf aktif",
      language: "Dil",
      processes: "İşlemler",
      link: "Link",
      justParticipants: "Yalnızca katılımcılar görsün",
      participantID: "Katılımcı ID",
      activationCode: "Aktivasyon kodu",
      required: "Zorunlu",
      onAir: "Yayında",
      type: "Tip",
      packages: "Tanımlı paketler",
      color: "Renk",
      publishApp: "Uygulamada yayınlansın mı?",
      cardPrint: "Kart basılsın",
      registerDate: "Kayıt Tarihi",
      subEvent: "Alt etkinlik",
      company: "Kurum",
      queue: "Sıra",
      day: "Tek Gün",
      comment: "Yorum",
      qr: "QR Kod",
      statistics: "İstatistikler",
      responses: "Yanıtlar",
      edit: "Düzenle",
      try: "Test et",
      delete: "Sil",
      sequence: "Sıra NO",
      privacy: "Gizlilik",
      group: "Grup",
      label: "Etiket",
      price: "Fiyat",
      kdv: "KDV",
      download: "İndir",
      salesStock: "Satış / Stok",
      package: "Paket",
      prefix: "Ön Ek",
      suffix: "Arka Ek",
      code: "Kod",
      remaining: "Kalan",
      showCodes: "Kodları görüntüle",
      payAmount: "Ödeme tutarı",
      details: "Detaylar",
      abort: "Ödemeyi iptal et",
      approve: "Onayla",
      cancelRec: "Kaydı iptal et",
      speaker: "Konuşmacı",
      passive: "Pasif",
      active: "Aktif",
      content: "İçerik",
      gallery: "Galeri",
      participant: "Katılımcı",
      confirmAss: "Onayla",
      rejectAss: "Reddet",
      participating: "Katılım",
      comments: "Yanıtlar",
      startEnd: "Başlangıç/bitiş",
      totalTime: "Toplam süre",
      totalStock: "Toplam stok",
      status: "Durum",
      broadcastRecords: "Yayın kayıtları",
      totalPerson: "Kişi sayısı",
      personInfo: "Kişi bilgisi",
      invitationCode: "Davetiye kodu",
      send: "Gönder",
      firmSchool: "Firma / Okul",
      titleDepartment: "Ünvan / Bölüm",
      additionalInfo: "Ek bilgiler",
      transfer: "Gönderim",
      chargeStatus: "Şarj durumu",
      distributed: "Dağıtılan",
      distPromotions: "Dağıtılan promosyonlar",
      promotion: "Promosyon",
      piece: "Adet",
      date: "Tarih",
      entryRecords: "Giriş kayıtları",
      seatingPllaner: "Oturma düzeni planlayıcı",
      pass: "Geçiş İzni",
      controller: "Kontrolcü",
      controlType: "Kontrol tipi",
      place: "Mekan",
      heightWidth: "Genişlik / Yükseklik",
      margin: "Kenar Boşluğu(sol,üst,sağ,alt)",
      customText: "Metin özelleştirmesi",
      userNo: "Kullanıcı sayısı",
      editAuth: "Yetki grubu ekle/düzenle",
      user: "Kullanıcı",
      fastlogin: "Hızlı giriş",
      messagetype: "Mesaj türü",
      clickforfastlogin: "Hızlı giriş yapmak için tıklayın"
    }
  },

  redirects: {
    redirect1: {
      title: "Etkinlik günlerini tanımlayın",
      description: "Etkinlik programı oluşturmak, kayıt ve satış paketlerini yönetmek ve etkinliğinizi yayınlayabilmek için başlangıç ve bitiş saatlerini belirtmelisiniz."
    },
    redirect2: {
      title: "Katılımcı grupları oluşturun",
      description: "Katılımcı grupları, birden fazla kategoride sınıflandırılmış katılımcıları tek grup altında göstermek için kullanılır. Örn; Öğrenci, basın, standart katılımcı vb. Her etiketin mutlaka bağlı olduğu bir grup olmalıdır."
    },
    redirect3: {
      title: "Katılımcı etiketleri oluşturun",
      description: "Etiketler, giriş kontrol, paket satış, kayıt, alt etkinlik kayıt, oturma düzeni vb. tüm fonksiyonları yönetmenize ve raporlamanıza olanak sağlar."
    },
    redirect4: {
      title: "Kayıt / satış paketleri oluşturun",
      description: "Etkinliğinizin için kayıt almak ya da bilet satışı gerçekleştirmek için en az bir paket oluşturmanız ve yayınlamanız gerekmektedir. Bu paketler sayesinde katılımcıların hangi kategoride etkinliğinize kayıt olacaklarını, ne kadar ücret ödeyeceklerini ve hangi katılım haklarına sahip olacaklarını belirleyebilirsiniz."
    },
    redirect5: {
      title: "Online kayıt formu oluşturun",
      description:
        "Kayıt ve satış paketlerinizi oluşturmadan önce en az bir kayıt formu oluşturmanız gerekmektedir. Kayıt formlarınızı dilediğiniz gibi özelleştirebilir, soru ve alan ekleyebilirsiniz.  Hiçbir alan eklenmediğinde sistem sabit değer olarak sadece isim ve soy isim talep eder.  Yapacağınız özelleştirmeler sayesinde daha fazla veri elde edebilir, benzersiz kayıtlar alabilirsiniz. Birden fazla kayıt formu oluşturabilir ve oluşturduğunuz kayıt formlarını dilediğiniz kayıt ve satış paketine tanımlayabilirsiniz."
    },
    redirect6: {
      title: "Kontrol noktaları tanımlayın",
      description: "Kontrol noktaları etkinlik için raporlama ve geçiş kontrollerinde kullanılan, katılımcı etiket ve gruplarına göre katılımcılara giriş yetkisi tanımlamaya olanak sağlayan alanlardır. Alt etkinlikler, programlar, canlı yayınlar, networking alanları ve onsite giriş kontrolleri bu kontrol noktaları sayesinde gerçekleştirilir."
    },
    redirect7: {
      title: "İçeriklerinizi düzenleyin",
      description: "Etkinlik içeriklerinin anlaşılır ve kaliteli olması katılımcılar için cezbedici bir kolaylık sağlar."
    },
    redirect8: {
      title: "Canlı oturum oluşturun",
      description: "Canlı oturumlar Live Event Experience platformunda yayınlanacak sanal oturumlardır.  Katılımcılar kayıt hakları dahilinde online olarak bu oturumlara katılabilirler."
    }
  },

  information: {
    module: "Bu modül henüz kullanıma hazır değil.",
    moduleDesc: "Bu modül şu an test aşamasındadır. En kısa zamanda kullanımınıza sunulacaktır.",
    sureToBack: "Geri dönmek istediğinize emin misiniz?",
    export: "Kayıtları dışarı aktarmak istediğinize emin misiniz?",
    warn: "Uyarı"
  },

  exp: {
    participant: "ÖRN: Taştan",
    participant_: "ÖRN: Özkan"
  },

  reports: {
    totalParticipants: "Toplam katılımcı",
    blockedParticipants: "Engellenen katılımcı",
    surrogateParticipant: "Vekil eklenen katılımcı",
    totalSale: "Toplam satış adedii",
    totalCheckin: "Toplam check-in",
    totalCardPrinted: "Toplam kart baskı",
    sentVoucherMail: "Gönderilen voucher (e-posta)",
    sentVoucherSms: "Gönderilen voucher (SMS)",
    totalCouponGroup: "Toplam kupon kodu grubu",
    totalCouponPiece: "Toplam Kupon kodu adedi",
    couponUsed: "Kullanılan kupon kodu",
    couponUnused: "Kullanılmayan kupon kodu",

    activationAnalysis: "Aktivasyon Analizi",
    waitingAct: "Aktivasyon bekliyor",
    canceledAct: "Aktivasyon iptal edildi",
    activated: "Aktivasyon yapıldı",

    totalParticipantsPack: "Paketlere göre katılımcı sayıları",

    attendanceChartByTags: "Etiketlere göre katılım grafiği",

    accessControlByLoc: "Mekanlara göre giriş kontrol",
    venue: "Mekan",
    totalEntry: "Toplam check-in",
    singleEntry: "Tekil check-in",

    accessControlByLive: "Canlı oturumlara göre giriş kontrol",
    session: "Oturum"
  },

  enums: {
    currency: {
      other: "Diğer"
    },

    status: {
      waitApprove: "Onay bekliyor",
      approved: "Onaylandı",
      rejected: "Reddedildi",
      canceled: "İptal edildi",
      autoApprove: "Otomatik onaylansın",
      waitForApprove: "Onay beklesin",
      sent: "Gönderildi",
      delivered: "Teslim edildi",
      clicked: "Linke tıklandı",
      spam: "Spam",
      registered: "Kayıt edildi",
      opened: "Açıldı",
      failed: "Başarısız oldu"
    },

    discountType: {
      discountPercentage: "Yüzde indirim",
      certainAmount: "Belirli bir tutarda indirim"
    },

    accessTypes: {
      all: "Tüm etiketler",
      certain: "Belirli etiketler",
      onlyRegistrants: "Sadece kayıt yaptıranlar"
    },

    voucherSendStatus: {
      transmitted: "İletildi",
      read: "Okundu",
      failed: "İletilemedi",
      complaint: "Şikayet aldı",
      noMail: "E-Posta adresi yok",
      noPhone: "Telefon numarası yok",
      error: "Hata oluştu",
      unknownError: "Bilinmeyen hata"
    },

    voucherTaskStatus: {
      duringShipping: "Gönderim sırasında",
      complete: "Gönderim tamamlandı",
      error: "Hata oluştu",
      notesreferences: "Voucher gönderilmeyenler",
      mail: "E-posta gönderimi",
      sms: "SMS gönderimi"
    },

    paymentType: {
      free: "Ücretsiz katılım",
      online: "Online ödemeli katılım",
      transfer: "Havale ile ödemeli katılım"
    },

    activationStatus: {
      wait: "Aktivasyon bekliyor",
      activated: "Aktivasyon yapıldı",
      canceled: "Aktivasyon iptal edildi"
    },

    inputTypes: {
      uniqueMail: "Benzersiz e-posta",
      uniquePhone: "Benzersiz cep telefonu",
      company: "Firma adı",
      title: "Ünvan",
      school: "Okul",
      department: "Bölüm",
      sex: "Cinsiyet",
      country: "Ülke",
      city: "Şehir",
      IdPassNO: "Kimlik/Pasaport No",
      studentNo: "Öğrenci numarası",
      lang: "Dil",
      birth: "Doğum tarihi",
      profession: "Meslek",
      expert: "Uzmanlık",
      text: "Metin",
      multilineText: "Çok satırlı metin",
      mail: "E-posta",
      phone: "Telefon numarası",
      figure: "Rakam",
      singlesreferences: "Tekli seçim",
      multiChoice: "Çoklu seçim",
      invitationCode: "Davet kodu"
    },

    invoiceType: {
      corpBilling: "Kurumsal fatura",
      individualBilling: "Bireysel fatura"
    },

    galleryType: {
      photo: "Fotoğraf"
    },

    usageType: {
      eventCreated: "Etkinlik oluşturuldu.",
      participantAdded: "Yeni katılımcı eklendi.",
      participantsAdded: "Toplu katılımcı eklendi.",
      participantRegistered: "Katılımcı kayıt oldu.",
      eventAired: "Etkinlik yayınlandı.",
      smsActivation: "SMS aktivasyonu",
      voucherSent: "Voucher gönderildi.",
      invitationSent: "Davetiye gönderildi.",
      cardPrinted: "Kart yazdırıldı.",
      checkinDone: "Check-in yapıldı.",
      inputControl: "Giriş kontrolü",
      promo: "Promosyon",
      report: "Rapor",
      voucherSms: "Voucher SMS olarak gönderildi",
      liveSessionsCreated: "Canlı oturum oluşturuldu.",
      twoPerson: "2 Kişilik Networking odası oluşturuldu.",
      fourPerson: "4 Kişilik Networking odası oluşturuldu.",
      sixPerson: "6 Kişilik Networking odası oluşturuldu.",
      liveParticipation: "Canlı oturum katılımı",
      enterNetworking: "Networking odası girişi",
      liveSessionArchive: "Canlı oturum arşivi indirme",
      manuel: "Manuel tanımlama",
      invitationAdded: "E-davetiye listesine kişi eklendi.",
      invitationSent: "E-davetiye gönderildi.",
      couponUsed: "Kupon kodu kullanıldı.",
      giftUsed: "Hediye çeki kullanıldı.",
      loanPurchased: "Kredi satın alındı.",
      certSent: "Sertifika gönderildi."
    },

    printMode: {
      dontCustom: "Özelleştirme Yapma",
      allCaps: "TÜMÜ BÜYÜK HARF",
      allLower: "tümü küçük harf",
      firstCaps: "İlk Harfler Büyük"
    },

    questionType: {
      textInput: "Metin girişi",
      single: "Tekli seçim",
      multiple: "Çoklu seçim"
    },

    accessLogType: {
      mobilLive: "Mobil / Canlı",
      tourniquet: "Turnike"
    },

    accessLogStatus: {
      granted: "İzin verildi",
      disallowed: "İzin verilmedi"
    },

    rsvpStatus: {
      joining: "Katılıyor",
      disagree: "Katılmıyor",
      maybe: "Belki katılıyor",
      callAgain: "Tekrar aranacak",
      infoMistaken: "Bilgiler hatalı",
      receiveComplaint: "Şikayet aldı",
      invalidMail: "Geçersiz e-posta"
    }
  },

  options: {
    seeAll: "Tümünü gör",
    stand: "Stant",
    date: "Tarih",
    selectAll: "Tümünü seç",
    bio: "Biyografi",
    female: "Kadın",
    male: "Erkek",
    other: "Diğer",
    confirmation: "Bu arşivi indirebilmek için hesabınızdan tek seferlik {n} kredi düşülecektir. Onaylıyor musunuz?",
    checkin: "Seçmiş olduğunuz katılımcıların tümü için check-in yapılacaktır. Onaylıyor musunuz?",
    bulkCheckin: "Toplu check-in",
    participantDetails: "Katılımcı detayları",
    download: "İndir",
    delete: "Sil"
  },

  routes: {
    speakers: "Konuşmacılar",
    eventSch: "Etkinlik programı",
    sponsors: "Sponsorlar",
    areaMaps: "Alan haritaları",
    docs: "Dökümanlar",
    library: "Soru kütüphanesi"
  },

  message: {
    refreshActivationCode: "Aktivasyon kodu kopyalandı.",
    authority: "Bu işlem için gerekli yetkiye sahip değilsiniz.",
    vote: "Oylamada aynı yanıttan birden fazla bulunamaz.",
    fill: "Lütfen tüm alanları doldurunuz.",
    vimeo: "1 adet vimeo yayını eklemelisiniz.",
    waitCheck: "Katılımcılar check-in yapılırken lütfen bekleyin...",
    delete: "Toplu silme işlemi için hesap şifrenizi girmeniz gerekmektedir.",
    batch: "Toplu işlem yapıyorsunuz.",
    waitDeletion: "Katılımcılar silinirken lütfen bekleyin...",
    wrongPass: "Girmiş olduğunuz şifre yanlış.",
    export: "Kayıtları dışarı aktarmak istediğinize emin misiniz ?",
    warn: "Uyarı",
    sureDel: "Seçmiş olduğunuz kayıtlar taşınacaktır. Onaylıyor musunuz?",
    batchDel: "Toplu Sil",
    moveRecords: "Seçmiş olduğunuz kayıtlar taşınacaktır. Onaylıyor musunuz?",
    markOk: "Seçmiş olduğunuz kayıtlar katılıyor olarak işaretlenecektir. Onaylıyor musunuz?",
    markAttend: "Katılıyor olarak işaretle",
    markNot: "Seçmiş olduğunuz kayıtlar katılmıyor olarak işaretlenecektir. Onaylıyor musunuz?",
    sureExport: "Kayıtları dışarı aktarmak istediğinize emin misiniz ?",
    sureCreate: "Aktarım dosyası oluşturmak istediğinize emin misiniz ?",
    sureDelCert: "Sertifikayı silmek istediğinizden emin misiniz?",
    bannedParticipant: "Bu katılımcı organizatör tarafından engellenmiştir.",
    sureRemoveBan: "Engel kaldırılacaktır; onaylıyor musunuz?",
    sureBanned: "Bu katılımcı engellenecektir; onaylıyor musunuz?",
    ban: "Engelle",
    removeBan: "Engeli kaldır",
    codeRenewed: "Aktivasyon kodu yenilenecektir; onaylıyor musunuz?",
    deactivated: "Aktivasyon kodu henüz aktif edilmemiş.",
    sureCheckin: "Checkin yapılacaktır; onaylıyor musunuz?",
    check_in: "Check-in",
    addedProxy: "Bu katılımcıya vekil eklenmiştir.",
    viewProxy: "Vekil görüntüle",
    sendV: "Voucher gönder",
    sureCancel: "Ödemeyi iptal etmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
    subeventRecords: "Alt etkinlik kayıtları",
    otoSave: "Otomatik kayıt",
    onlinePays: "Online ödemeler",
    records: "Kayıtlar",
    onsiteProcess: "Onsite işlemler",
    cardPrint: "Kart baskı işlemleri",
    sureToDel: "Bu işlemi silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
    promotion: "Promosyon işlemleri",
    transDate: "İşlem tarihi",
    voucher: "Voucher İşlemleri",
    deliveryStat: "Gönderim durumu",
    certs: "Sertifikalar",
    shippingDate: "Gönderim tarihi",
    download: "İndirilme sayısı",
    visited: "Ziyaret sayısı",
    cert: "Sertifika",
    payDetails: "Ödeme detayları",
    creditPack: "Kredi paketleri",
    proxyReason: "Vekil ekleme sebebi",
    printCard_: "Kart bastır",
    cardTask: "Kart taslağı",
    selectCardTask: "Kart taslağı seçiniz",
    paymentFailed: "Ödeme başarısız oldu",
    paymentSuccess: "Ödeme başarıyla tamamlandı",
    alert: "Bu katılımcıya daha önce {n} adet kart yazdırılmıştır. Tekrar yazdırma yapabilmek için lütfen sebep belirtin.",
    printAndCheckin: "Bastır ve check-in yap",
    print: "Bastır",
    voucherSend: "{count} kişiye voucher gönderilecektir.",
    voucherTemp: "Voucher taslağı",
    printerID: "Yazıcı ID",
    noStageDesing: "Henüz bir sahne tasarımı yok",
    manageScenes: "Sahneleri yönet",
    copiedLink: "Link kopyalandı",
    copiedCode: "Kod kopyalandı",
    copied: "Kopyalandı",
    scenes: "Sahneler"
  },

  search: {
    proxy: "Bu katılımcıya vekil atandığı için kart yazdırma ve check-in işlemleri yapılamaz.",
    blocked: "Bu katılımcı engellendiği için kart yazdırma ve check-in işlemleri yapılamaz.",
    payment: "This attendee's payment has not yet been confirmed. Please confirm the registration or contact the organizer.",
    cancel: "Bu katılımcının ödeme kaydı iptal edilmiş. Lütfen yetkili kişi ile iletişime geçin.",
    notToday: "Bu katılımcının kaydı farklı bir gün için geçerli olduğu için, kart yazdırma ve check-in işlemleri yapılamaz."
  },

  detail: "İşlem detayı",
  addNew: "-- Yeni ekle --",
  discountType: "İndirim tipi",
  discountPerc: "İndirim yüzdesi",
  discountAmount: "İndirim miktarı",
  downloads: "İndirilme sayısı",
  authDesc: "Kuponların yönetimi için yeni bir yetkili tanımladığınızda, kuponların gönderimi ve kullanımı için bu kişiye hatırlatma e-postası iletilir.",
  defineAuth: "Yetkili tanımla",
  authSurname: "Yetkili Soyad",
  authName: "Yetkili Ad",
  authMail: "Yetkili e-posta",
  myAccount: "Hesabım",
  notifications: "Bildirimler",
  companyInfo: "Firma bilgileri",
  summary: "Kullanım özeti",
  loadCredit: "Kredi yükle",
  history: "İşlem geçmişi",
  soon: "Yakında",
  signOut: "Çıkış yap",
  badge: "Rozet",
  startDate: "Başlangıç tarihi",
  endDate: "Bitiş tarihi",
  enterText: "Metni buraya giriniz...",
  enterPhone: "Telefon numaranızı giriniz",
  secretPack: "Gizli paket",
  acreditationPack: "Akreditasyon paketi",
  invitationRequire: "Davetiye kodu zorunlu",
  resetFilter: "Filtreyi sıfırla",
  createNew: "Yeni kayıt oluştur",
  active: "Aktif",
  inactive: "Pasif",
  justThesePacks: "Sadece şu paketler için tanımla",
  require: "Zorunlu mu?",
  includeSearch: "Tablo ve aramalara dahil et",
  type: "Tip",
  editGroup: "Grup Ekle / Düzenle",
  editPack: "Satış paketi Ekle / Düzenle",
  category: "Kategori",
  tag: "Etiket",
  price: "Fiyat",
  taxRate: "Vergi oranı",
  packDesc: "Paket açıklaması",
  oneDay: "Tek gün kısıtlaması",
  autoSubEvent: "Otomatik alt etkinlik kayıt",
  secret: "Gizli paket",
  secretPackDesc: "Gizli paket olarak tanımladığınız paketler kayıt ekranında listelenmez. Bu paketler için sadece link paylaşımı yapabilirsiniz, Örneğin sponsorlarınıza özel olarak üreteceğiniz kayıt linkleri vb.",
  acreditaionMode: "Akreditasyon modu",
  acreditationDesc: "Akreditasyon modu aktif edildiğinde, gelen ücretsiz kayıtlar önce onaya düşer. Pasif olması durumunda kayıtlar otomatik onaylanır. Ücretli paketlerde akreditasyon modu otomatik aktifleştirilir.",
  invitationCode: "Davetiye kodu zorunlu",
  invitationDesc: "E-davetiyeyi zorunlu kıldığınız paketlerde sadece seçtiğiniz davetlilere özel kayıt alabilirsiniz. Bunun için, e-davetiye & LCV menüsünden özel kodlar oluşturabilir ve gönderebilirsiniz. Katılımcılar kayıt yaptırırken bu kodu  girmeleri gerekir.",
  editCoupon: "Kupon Ekle / Düzenle",
  prefix: "Ön ek",
  suffix: "Arka ek",
  numberCpn: "Üretilecek kupon adeti",
  usageLimit: "Her bir kod için kullanım limiti",
  pack: "Paket",
  exHlcn: "ÖRN: HLCN",
  ex2020: "ÖRN: 2020",
  customerInfo: "Müşteri bilgileri",
  phone: "Telefon numarası",
  mail: "E-Posta adresi",
  bill: "Fatura bilgisi",
  summary: "Özet",
  paymentType: "Ödeme tipi",
  transferCode: "Havale kodu",
  decimatedTotal: "Ara toplam",
  discounts: "İndirimler",
  taxes: "Vergiler",
  total: "Toplam",
  general: "Genel bilgi",
  daySelection: "Gün seçimi",
  noRestriction: "Gün kısıtlaması yok",
  addSubEvent: "Alt etkinlik kaydı ekle",
  subEvent: "Alt etkinlik",
  selectedParticipants: "Seçili katılımcılar",
  participantList: "Katılımcı listesi",
  searchPart: "Katılımcılar içinde arayın...",
  selectTag: "Etiket seçimi",
  select: "Seç,",
  exOzk: "ÖRN: Özkan Taştan",
  ex1: "ÖRN: 1",
  exSup: "ÖRN: support@holacon.com",
  exGir: "ÖRN: Girişimci",
  exFcb: "ÖRN: https://www.facebook.com/holacon",
  exTwt: "ÖRN: https://www.twitter.com/holacon",
  exLnk: "ÖRN: https://www.linkedin.com/holacon",
  exIns: "ÖRN: https://www.instagram.com/holacon",
  exPint: "ÖRN: https://www.pinterest.com/holacon",
  exGoogle: "ÖRN: https://plus.google.com/holacon",
  exDribble: "ÖRN: https://www.dribble.com/holacon",
  exIs: "ÖRN: İş Bankası",
  exIban: "ÖRN: TR89 3704 0044 0532 0130 00",
  exFull: "ÖRN: Ahmet Yılmaz",
  exRndm: "ÖRN: 123456",
  exRndm2: "ÖRN: 753",
  exHolacon: "ÖRN: Holacon",
  exHol: "ÖRN: https://www.holacon.com",
  accountInfo: "Hesap güvenliğiniz için şifrenizi 6 ayda bir sıfırlamanızı öneririz.",
  neverUpdated: "Hesap şifrenizi henüz güncellemediniz.",
  sendNotification: "Tüm katılımcılara bildirim gönderilecektir; onaylıyor musunuz?",
  reminder: "Hatırlatıcı gönder",
  progType: "Program tipi",
  startTime: "Başlangıç saati",
  endTime: "Bitiş saati",
  addSpeaker: "Konuşmacı ekle",
  accountInformation: "Hesap",
  appSettings: "Ayarlar",
  phone1: "Telefon numaranız",
  passSettings: "Şifre",
  password: "Mevcut şifreniz",
  newPass: "Yeni şifreniz",
  newPass_: "Yeni şifreniz (Tekrar)",
  name: "Adınız",
  surname: "Soyadınız",
  searchWithinP: "Konuşmacılar içinde arayın...",
  drag: "Sıralamak için sürükle ve bırak",
  addDay: "Gün ekle",
  addSaloon: "Salon ekle",
  selectedSpeakers: "Seçilen konuşmacılar",
  speakerList: "Konuşmacı listesi",
  searchEventName: "Etkinlik adına göre arayın...",
  createNewEvent: "Yeni etkinlik oluştur",
  create: "OLUŞTUR",
  enterEventName: "Etkinlik adını girin",
  menu: "Menü",
  addTag: "Etiket ekle",
  important: "Önemli bilgilendirme",
  usage: "Kullanım hakları etkinlik özelindedir. Bu etkinlikte kullanmadığınız haklarınız bir sonraki etkinliğinize devredilemez ya da iadesi talep edilemez.",
  remaining: "kalan",
  editAreaMap: "Alan haritası Ekle / Düzenle",
  mainUser: "Ana kullanıcı",
  evaStat: "Değerlendirme durumu",
  sureInvCode: "Davetiye kodunu yenilemek istediğinize emin misiniz?",
  note: "İşlem notunuz",
  submit: "Gönder",
  addNetArea: "Networking alanı Ekle / Düzenle",
  activeIt: "Aktifleştir",
  packPrice: "PAKET FİYATI",
  selectedPack: "Seçilen paket",
  totalUpper: "TOPLAM",
  backToPackSel: "Paket seçimine geri dön",
  popular: "Popüler",
  pay: "ÖDE",
  credit: "Kredi",
  buy: "Satın al",
  doYouNeedCredit: "Daha fazla krediye mi ihtiyacınız var?",
  live: "CANLI",
  waiting: "BEKLİYOR",
  editSubject: "Konu Ekle / Düzenle",
  question: "Soru",
  like: "Beğeni",
  date: "Kayıt tarihi",
  stat_: "Durum",
  sureToDel_: "Bu gönderiyi silmek istediğinizden emin misiniz?",
  generalInf: "Genel bilgiler",
  event_: "Etkinlik",
  code: "aktivasyon kodu",
  printCard_: "Kart yazdır",
  addVimeo: "Vimeo yayını ekle",
  payInf: "Ödeme & kayıt bilgileri",
  editMedia: "Medya Ekle / Düzenle",
  mediaType: "Medya tipi",
  gallery: "Galeri görseli",
  social: "Sosyal medya hesapları",
  three: "3D Görsel",
  speaker: "Konuşmacı",
  progDetail: "Program detayı",
  selected: "Seçilen",
  cancelSelection: "Seçimi iptal et",
  officialTitle: "Resmi ünvan",
  firmNo: "Firma NO",
  billType: "Fatura Tipi",
  taxAd: "Vergi dairesi",
  taxTC: "Vergi No & TC No",
  address: "Açık adres",
  legal: "Tüzel",
  person: "Şahıs",
  couponQ: "Kupon kodları mail adresinize iletilecektir. Onaylıyor musunuz?",
  export: "Dışar aktar",
  sureToDelR: "Kayıtlar oluşturulduktan 1 ay sonra silinecektir.",
  regLink: "Kayıt linki",
  codesC: "Kupon kodları",
  tooltipSee: "Bu kodu kullanan katılımcıları gör.",
  usage_: "Kullanım",
  invitationArea: "Davetiye kod alanı",
  registerButton: "Hemen kayıt ol butonu",
  buttonAddress: "Kayıt ol butonu adresi",
  lcvButtons: "LCV butonları",
  bottomBannerURL: "Alt görsel URL",
  preview: "Önizleme",
  subImg: "Alt görsel",
  removeImg: "Görseli kaldır",
  topImgUrl: "Üst görsel URL",
  emailTitle: "E-posta başlığı",
  topImg: "Üst görsel",
  selectLang: "Dil seçin",
  batchDel: "Toplu silme işlemi yapılamadı",
  move: "Taşı",
  temp: "Taslak",
  voucherBoth: "Voucher (SMS & E-Posta)",
  announcementText: "Duyuru metni",
  secretDesc: "Anketler listesinde görünmez. Katılımcı sadece mobil uygulama üzerinden kare kodunu okutarak ankete erişebilir.",
  exWall: "ÖRN: Konuşmacı ismi, panel adı, özel konu başlığı vb.",
  tableName: "Masa ismi",
  operant: "İşlemi gerçekleştiren",
  viewReg: "Kayıt ekranını görüntüle",
  dayRestrict: "Gün kısıtlaması",
  lastCheckin: "Son check-in tarihi",
  noRecord: "Kayıt bulunamadı.",
  sureToDo: "Bu işlemi yapmak istediğinize emin misiniz?",
  sureToDelS: "Bu sahneyi silmek istediğinize emin misiniz?",
  reInvite: "Tekrar davetiye gönderilecektir. Onaylıyor musunuz?",
  archiveSess: "Oturum arşivi",
  downloadArch: "Arşivi indirmek için tıklayın",
  createReport: "Rapor oluşturulup mail adresinize iletilecektir. Onaylıyor musunuz?",
  reminderAll: "Tüm katılımcılara hatırlatma bildirimi gönderilecektir. Onaylıyor musunuz?",
  sendReminder: "Hatırlatma bildirimi gönder",
  sureToApprove: "Bu değerlendirmeyi onaylamak istediğinizden emin misiniz?",
  sureToReject: "Bu değerlendirmeyi reddetmek istediğinizden emin misiniz?",
  voucherSend: "{number} kişiye voucher gönderilecektir",
  delComment: "Bu yorumu silmek istediğinize emin misiniz?",
  cancelReg: "Kaydı iptal etmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
  checkins: "Check-in işlemleri",
  autoCheckin: "Otomatik check-in",
  serviceStat: "Servis durumu",
  importExcel: "Excel'den içeri aktar",
  start: "Aktarımı başlat",
  prescription: "Zaman aşımı",
  sendCert: "Sertifika gönder",
  system: "Sistem",
  addOption: "Seçenek ekle",
  optionList: "Seçenekler",
  noInfo: "Katılımcı bilgisi bulunamadı",
  sureToDellR: "Kayıtlar oluşturulma tarihinden itibaren 1 ay sonra silenecektir.",
  size: "Boyut",
  duration: "Süre",
  addedBr: "Eklenen yayınlar",
  onlyPart: "Yalnızca katılımcılar görsün",
  justPart: "Yalnızca katılımcılar",
  open: "Herkese açık",
  addPack: "Paket ekle",
  editHall: "Seçilen salonu düzenle",
  standGallery: "Stant galerisi",
  file: "Dosya",
  answers: "Oylamaya verilen yanıtlar",
  answer: "Yanıt",
  activeEvents: "AKTİF ETKİNLİKLER",
  reject: "Reddet",
  loading: "Depolama Sunucusuna Yükleniyor",
  failed_: "Depolama Sunucusuna Yüklenemedi",
  uploaded: "Depolama Sunucusuna Yüklendi",
  notRecorded: "Kaydedilmedi",
  recording: "Kaydediliyor",
  mailTitle: "E-Posta başlığı",
  mailLang: "E-Posta dili",
  mailContent: "E-Posta içeriği",
  certSettings: "Sertifika ayarları",
  vertical: "Dikey",
  horizontal: "Yatay",
  partInfo: "Katılımcı bilgisi",
  noComment: "Henüz hiçbir katılımcı bu gönderiye yorum yapmadı.",
  partRight: "Etkinlik katılımcı hakkı",
  surveyUsage: "Anket kullanımı",
  liveVotingUsage: "Canlı oylama kullanımı",
  listPartTag: "Bu etikete ait katılımcıları listele",
  noLike: "Henüz hiçbir katılımcı bu gönderiyi beğenmedi.",
  listPartGroup: "Bu gruba ait katılımcıları listele",
  reason: "Kayıp Kart, Yazıcı Hatası, Sorunlu Etiket, Hatalı Kayıt, Bilgi Güncelleme",
  closed: "Online kayıt kapalıdır.",
  comments: "Yorumlar",
  likes: "Beğeniler",
  login: "Giriş Yap",
  loginDesc: "Yönetici arayüzünde oturum açmak için, yönetici girişi için özel oluşturulan ve e-postanıza gönderilerin kullanıcı bilgileriniz ile giriş yapınız.",
  forgotPass: "Şifremi unuttum",
  deleteSelected: "Seçilenleri Sil",
  checkinSelected: "Seçilenleri check-in yap",
  checkinDate: "Check-in tarihi",
  writeQuestion: "Sorunuzu buraya yazınız",
  addCat: "Kategori ekle",
  incVat: "KDV dahil",
  checkpoint_: "Kontrol noktası bilgisi",
  enterCCode: "Kupon kodunu buraya giriniz...",
  editText: "Bu yazıyı düzenleyiniz",
  watchBroadcast: "Yayını izle",
  no_data: "Hiç veri yok",
  newModule: "Yeni modül ekle",
  checkpoint_selection: "Kontrol noktası seçimi",
  register: "Kayıt ol",
  register_text: "Yönetici arayüzünde oturum açmak için hesap kaydınızı tamamlayınız.",
  share_announcement: {
    preview: "Duyuru önizlemesi",
    soon: "Birazdan",
    text: "Duyuru metnini buraya giriniz..."
  },
  forgotPassword: {
    text: "Şifrenizi mi unuttunuz?",
    text2: "Şifrenizi  'şifremi unuttum' e-postası aracılığıyla değiştirebilirsiniz.",
    button: "Şifremi Sıfırla",
    resend: "Tekrar Gönder",
    confirm: "Tamamla",
    resetCode: "Sıfırlama Kodu",
    newPassword: "Yeni Şifre",
    newPassword2: "Yeni Şifre(Tekrar)"
  },
  paymentCancelInfo: "Bu ödemeye ait {n} adet katılım kaydı iptal edilecektir. Bu işlem geri alınamaz.",
  authorityGroup: {
    reports: "Raporlar",
    eventRegistration: "Etkinlik Kaydı",
    selectAuthorizations: "Yetkileri seçiniz."
  },
  registerInput: {
    password: "Hesap Şifresi...",
    password2: "Hesap Şifresi(Tekrar)..."
  },
  organisation: {
    subscriptionAlert: "Herhangi bir aktif aboneliğiniz bulunmamaktadır. Yeni bir abonelik başlatmak için lütfen faturalandırma ekranını ziyaret edin.",

    overview: {
      title: "Genel Bakış",
      createEvent: "Etkinlik oluştur",
      welcome: "Hoşgeldiniz",
      underReview: "Hesabınız inceleniyor",
      underReviewMsg: "Kuruluş hesabınız onay aşamasındadır. Verilen bilgilerin doğruluğunun onaylanması halinde hesabınız aktif edilecektir.",
      accountConfirm: "Hesabınız aktif",
      accountConfirmMsg: "Kuruluş hesabınız onaylandı. Yeni etkinlikler oluşturabilirsiniz.",
      createNewEvent: "Yeni bir etkinlik oluşturmak için",
      createNewEventClick: "tıklayınız",
      creditCardAttention: "İlgilenmeniz gerekli",
      creditCardAttentionMsg: "Kuruluşunuza bağlı aktif bir kredi kartı bulunmuyor, işlemlerinizin kesintiye uğramaması adına lütfen aktif bir kredi kartı ekleyiniz.",
      addcreditCard: "Kredi kartı eklemek için",
      addcreditCardClick: "tıklayınız",
      notConnectCreditCardAttention: "İlgilenmeniz gerekli",
      notConnectCreditCardAttentionMsg: "Kuruluşunuza bağlı kredi kartları ile işlem gerçekleştiremiyoruz, işlemlerinize devam edebilmek için lütfen aktif bir kredi kartı ekleyiniz.",
      notConnectAddcreditCard: "Kredi kartı eklemek için",
      notConnectAddcreditCardClick: "tıklayınız.",
      whiteLabel: "White-label servis durumu",
      whiteLabelStatus: "White-label hizmetleriniz aktif",
      planPayment: "<b>{0} USD / aylık.</b>",
      planPayment2: "<b>{0} USD / lifetime.</b>",
      upgrade: "Yükselt",
      hideInPackage: "Pakette olmayanları gizle",
      showInPackage: "Pakette olmayanları göster",
      cancel: "Vazgeç",
      create: "Oluştur",
      events: "Etkinlikler",
      unlimited: "sınırsız",
      participant: "Katılımcı kayıt kredisi",
      registrationCapacity: "Katılımcı kayıt limiti",
      upToXMembers: "en fazla {0} kullanıcı",
      upToXRegistrations: "en fazla {0} kayıt",
      upToXMinutes: "en fazla {0} dakika",
      upToXMonths: "en fazla {0} ay",

      upgradeCardTitle: "Premium'a geçin ve limitleri kaldırın",
      upgradeCardBody: "Holacon'un ihtiyaçlarınıza ve her boyuttaki etkinliğinize uyacak bir planı var. Aylık $49.99'a aboneliğinizi başlatın ve etkinliklerinizi yönetmeye başlayın!",
      upgradeCardButton: "Premium'a yükselt",
      upgradeCardLifetimeInfo: "Aşağıdaki kodu kullanarak size özel <b>ömür boyu % {0} indirimli</b> bir şekilde kullanın.",
       startSubFirst: "Ek paket alabilmek için öncelikle abonelik başlatmalısınız.",
      abstract: "Abstract",
      liveBroadcast: "Canlı yayın",
      storage: "Canlı yayın depolama",
      teamMember: "Takım üyesi",
      rate: "oranında kullanıldı"
    },
    event: {
      event: "etkinlik",
      title: "Etkinlik",
      filter: "Filtrele / Ara",
      placeholder: "Ara...",
      events: "Etkinlikler",
      createEvent: "Etkinlik oluştur",
      cancel: "Vazgeç",
      create: "Oluştur",
      dateVenue: "Tarih / Mekan",
      showArchive: "Arşivlenenleri göster"
    },
    team: {
      title: "Takım",
      authorize: "Yetkilendir",
      authorizeMsg: "Yetkilendirmek istediğiniz kullanıcının <b>e-posta</b> adresini girdikten sonra yetkilendirmek istediğiniz <b>etkinlikleri</b> ve <b>yetki grubunu</b> seçip ardından <b>'Ekle'</b> butonuna basınız.",
      authorizeEmail: "E-posta",
      authorizeEvent: "Etkinlikler",
      authorizeGroup: "Yetki grubu",
      team: "Takım",
      addMember: "Ekle",
      addMemberNew: "Yeni bir takım üyesi ekle",
      mainUserAuthorize: "Ana kullanıcı yetkileri değiştirilemez.",
      coOwnerUserAuthorize: "Yönetici yetkileri değiştirilemez.",
      placeholderEvents: "Etkinlik Seçiniz",
      placeholderAuthorityGroup: "Yetki Grubu Seçiniz",
      update: "Güncelle",
      events: "etkinlik",
      authorityGroups: "Yetkili gruplar",
      addGroup: "Grup ekle",
      numberAuthorize: "yetki",
      numberAuthorizePerson: "kişi",
      edit: "Düzenle",
      delete: "Sil",
      waitingApproval: "Onay Bekliyor",
      teamMember: "Takım Üyesi",
      authority: "Yetki",
      status: "Durum"
    },
    profile: {
      title: "Profil",
      updateCoverPhoto: "Kapak fotografını güncelle (1120x500 boyutunda olmalıdır)",
      update: "Güncelle",
      updateMax: "500x500 boyutunda olmalıdır",
      cancel: "Vazgeç",
      updateProfile: "Profili güncelle",
      organisationName: "Kuruluş adı",
      about: "Hakkında",
      organizasyonType: "Kuruluş türü",
      email: "E-posta",
      mobile: "Cep telefonu",
      phone: "Telefon",
      address: "Adres"
    },
    integration: {
      title: "Entegrasyon",
      build: "Entegrasyon oluşturun",
      buildMsg: " Ürününüzü Holacon ile entegre etmeyi mi düşünüyorsunuz? Ürününüzü ekibimize iletin.",
      buildLink: "İletişime geçin",
      request: "Entegrasyon Önerin",
      requestMsg: "Aradığınız entegrasyonu bulamıyorsanız, bize bildirin, gelecekteki geliştirmelerimize ekleyelim.",
      requestLink: "İletişime geçin",
      requestAPI: "API Erişim Talebi",
      requestAPIMsg: "API kitaplığımıza erişmek istiyorsanız lütfen geliştirme ekibimizle iletişime geçin.",
      requestAPILink: "İletişime geçin",
      paymentMethods: "Ödeme yöntemleri",
      noDataPaymentMethod: "Herhangi bir ödeme yöntemi bulunmamaktadır. “Ekle” butonuna basıp ödeme yöntemi ekleyebilirsiniz.",
      add: "Ekle"
    },
    billing: {
      freePayment: "Ücretsiz",
      close: "Kapat",
      title: "Abonelik",
      plans: "Planlar",
      currentPlan1: "Kuruluşunuz şu anda",
      currentPlan2: "plan kullanıyor.",
      freePlan: "Ücretsiz plan",
      freePlanStart: "Şu anda ücretsiz abonelik kullanıyorsunuz.",
      freePlanStop: "Kullanımı durdurmak için ücretsiz aboneliğe geçebilirsiniz.",
      toFreeText1: "Ücretsiz aboneliğe geçmek için",
      toFreeBtn: "tıklayın",
      toFreeText2: "",
      viewPackage: "Paketleri incele",
      annualPurchases: "Yıllık satın alımlarda 2 ay tasarruf edin",
      month: "Ay",
      year: "Yıl",
      buy: "Satın Al",
      cancelCancelSubscriptionTitle: "Aboneliğinize devam etmek istiyor musunuz? ",
      cancelSubscriptionTitle: "Aboneliğinizi iptal etmek istiyor musunuz?",
      //  aylık yıllık paketler gelecek
      toCancelBtn: "Aboneliği sonlandır",

      toCancelToCancelText1: "Mevcut aboneliğiniz için iptal işlemi başlatılmış, süreci iptal etmek ve kullanmaya devam etmek için",
      toCancelToCancelBtn: "tıklayın",
      toCancelToCancelText2: "",
      enterprise: "Enterprise",
      currentPlanUsing: "Kuruluşunuz şu anda <b>{0}</b> plan kullanıyor.",
      specialOfferText1: "Ön tanımlı abonelik paketlerinden daha farklı bir ihtiyacınız mı var?",
      specialOfferText2: "Size özel hazırlayacağımız teklifden faydalanabilirsiniz. İletişime geçmek için",
      specialOfferBtn: "tıklayın",
      specialOfferText3: "",
      contactUs: "İletişime geç",
      changePlan: "Plan değiştir",
      registerCards: "Kayıtlı kartlar",
      primaryPaymentCard: "Kuruluşunuz şu anda birincil ödeme yöntemi olarak <b>{0}</b> kartını kullanıyor.",
      noPrimaryCard: "Kuruluşunuz için henüz tanımlı bir kart bulunmuyor.",
      primaryCard: "Birincil kart",
      makePrimary: "Birincil yap",
      incorrectOperation: "Hatalı İşlem",
      cardFamily: "Kart Ailesi",
      operation: "İşlemler",
      makePrimaryCard: "Birincil kart yap",
      cardNo: "Kart numaranız",

      paymentHistory: "Ödeme geçmişi",
      successPaymentText1: "Kuruluşunuz en son",
      successPaymentText2: "tarihinde başarılı ödeme işlemi gerçekleştirmiş.",
      noSuccessPayment: "Kuruluşunuz henüz başarılı bir ödeme gerçekleştirmemiş.",
      preparing: "Hazırlanıyor",

      paymentHistoryPayment: "Ödeme",
      paymentHistoryPlan: "Plan",
      paymentHistoryAmount: "Tutar",
      paymentHistorySituation: "Durum",
      paymentHistoryInvoice: "Fatura",

      invoiceReceipt: "Fatura / Makbuz bilgileri",
      noInvoice: "Kuruluşunuz için henüz fatura bilgileri belirtilmemiş.",
      invoiceUpdateDate: "Bilgileriniz en son <b>{0}</b> tarihinde güncellenmiş.",
      organizationType: "Kuruluş tipi",
      companyName: "Firma unvanı",
      nameSurname: "Ad soyad",
      taxOffice: "Vergi dairesi",
      idNo: "Kimlik no",
      taxNo: "Vergi no",
      country: "Ülke",
      city: "Şehir",
      zipCode: "Posta kodu",
      address: "Adres",
      save: "Kaydet",

      newCard: "Yeni Kart",
      cvv: "CVV",
      cancel: "Vazgeç",
      subscribe: "Abone ol",
      payYear: "Yıllık abonelik",
      payMonth: "Aylık abonelik",

      plan: "Plan",
      planMsg: "Planınızı yükseltmek için abonelik paketlerine göz atabilirsiniz.",
      planInfo: "Satın alacağınız <b>{0}</b> paketlerini kuruluşunuz bağlı tüm etkinliklerde kullanabilirsiniz.",
      planAttention: " Ücretsiz aboneliklerde ek paket satın alımı gerçekleştiremezsiniz. Ek paketlerden satın alabilmek için herhangi bir plana abone olmalısınız.",
      buy: "Satın Al",
      buyMsg: "Yeniden çekim denemesi için tıklayınız.",
      piece: "Adet",
      download: "İndir",
      subscriptionPackage: "Abonelik Paketi :",
      amount: "Tutar :",
      disconts: "İndirimler :",
      taxes: "Vergiler :",
      total: "Toplam :",
      cancel2: "İptal",
      accept: "Kabul et",
      alreadySubscribe: "Abonesiniz",
      beSubscribe: "Abone ol",
      ok: "Tamam",
      packageAdded: "Satın aldıgınız paket güncel planınıza eklenmiştir.",
      paymentSuccess: "Ödemeniz başarılıya alındı!",
      subscriptionUpdated: "Abonelik planınız güncellendi",
      paymentFailed: "Ödeme tamamlanamadı!",
      selectCard: "Lütfen ödeme yapmak istediğiniz kartı seçiniz.",
      approveContracts: "Sözleşmeleri onayladığınızdan emin olunuz.",
      editInfo: "Lütfen alt kısımdan fatura bilgilerinizi düzenleyiniz."
    }
  },
  homeMenu: {
    account: "Hesap",
    organization: "Kuruluş",
    createOrganization: "Kuruluş oluştur",
    statutory: "Yasal",
    terms: "Kullanım koşulları",
    privacyPolicies: "Gizlilik ilkeleri",
    gdprText: "KVKK aydınlatma metni",
    cookies: "Çerezlerin kullanımı",
    application: "Uygulama",
    recommendFriend: "Arkadaşına öner",
    sendFeedback: "Geri bildirim gönder",
    rateUs: "Bizi değerlendirin",
    help: "Yardım",
    checkHolacon: "Holacon'u incele",
    organizationName: "Kuruluş adı",
    eventType: "Etkinlik tipi",
    userExpMsg: "Kullanıcı deneyiminizi seçimleriniz doğrultusunda iyileştiriyoruz.",
    organizationType: "Organization Tipi",
    requiredBilling: "Faturalandırma işlemleri için gereklidir.",
    companyName: "Firma unvanı",
    nameSurname: "Ad soyad",
    taxOffice: "Vergi dairesi",
    taxNo: "Vergi no",
    idNo: "Kimlik no",
    requiredInvoice: "Fatura işlemleri için gereklidir",
    address: "Adres",
    country: "Ülke",
    city: "Şehir",
    questionFind: "Bizi nereden duydunuz?",
    cancel: "Vazgeç",
    create: "Oluştur",
    password: "Şifre",
    delete: "Sil",
    organizationDelete: "Lütfen kuruluş sahibi hesabın şifresini girin.",
    deleteOrganizationTitle: "Kuruluşu sil"
  },

  totalContent: "Toplam <b>{0}</b> içeriği görüntülemektesiniz.",
  contentManagement: {
    eventProgram: {
      event: "Etkinlik",
      ratings: "Değerlendirmeler",
      days: "Günler",
      saloons: "Salonlar",
      addProgram: "Program Ekle",

      filter: "Filtrele",
      filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",

      speaker: "Konuşmacı",

      allSaloons: "Tüm Salonlar",
      showSubEvent: "<b>{0}</b> alt etkinliğine bağlı programları görüntülemektesiniz.",
      review: "Değerlendirme",
      sendReminderNotification: "Hatırlatıcı bildirim gönder",
      avarage: "Ortalama",
      addProgram: "Program ekle",
      editProgram: "Program düzenle",

      components: {
        title: "Başlık",
        date: "Tarih",
        viewing: "Görüntüleme",
        placeholderPickDay: "Pick a day",
        delete: "Sil",
        cancel: "Vazgeç",
        deleteSureMsg: "Bugüne ait etkinlik programlarıda silenecektir. Devam etmek istediğinize emin misiniz?",
        close: "Kapat",
        addDay: "Gün ekle",
        color: "Renk",
        addSaloon: "Salon Ekle",
        save: "Kaydet",
        sendReminder: "Hatırlatıcı gönder",

        session: "Oturum",
        includesTitleContent: "Başlık ve detaylı bilgiler içerir.",
        subEvent: "Alt etkinlik",
        createSessionSubEvent: "Alt etkinlik için oturum oluşturur.",
        section: "Bölüm",
        sessionGroup: "Bir oturum grubunu kapsar.",
        break: "Mola",
        breakMsg: "Kahve, yemek arası vb. mola zamanlarını tanımlar.",

        subeventSelection: "Alt etkinlik seçimi",
        subEventPublishInfoMsg: "Oluşturacağınız gün bu kısımda seçeceğiniz gün seçimi içinde yayınlanır.",
        programTitleMsg: "Program akışınızda programınızın başlığı olarak yayınlanır.",
        saloonSelection: "Salon seçimi",
        defineSaloonMsg: "Programın gerçekleşeceği salonu tanımlar.",

        daySelection: "Gün seçimi",
        defineDayMsg: "Programın gerçekleşeceği günü tanımlar.",
        startTime: "Başlangıç saati",
        startTimeMsg: "Programın başlangıç saatini tanımlar.",
        endTime: "Bitiş saati",
        endTimeMsg: "Programın bitiş saatini tanımlar.",
        calculateTime: "Oturumun toplam süresi",
        calculateTimeMsg: "Programın gerçekleşeceği toplam süreyi hesaplar.",

        content: "İçerik",
        contentDetails: "Programın detaylı içeriği hakkında bilgiler girebilirsiniz.",
        badgeSelect: "Rozet seçimi",
        badgeSelectMsg: "Mola türünü görsel olarak betimlemek için kullanılır.",
        speakers: "Konuşmacılar",
        speakersMsg: "Program detaylarına konuşmacı ya da sunum ekleyebilirsiniz.",
        speakerPresenter: "Konuşmacı / Moderatör",
        timeMinutes: "Süre (dakika)",

        selectSpeaker: "Konuşmacı seçiniz.",
        searchSpeaker: "Konuşmacı arayın",
        selectMin: "Dakika seçiniz",
        chooseStartTime: "Başlangıç saati seçiniz",
        addNotice: "Bildiri ekle",
        addSpeaker: "Konuşmacı ekle",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklik yapabilirsiniz.",
        viewingMsg: "Bu seçeneği kapattığınızda, katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
        useTags: "Etiketleri kullan",
        useTagsMsg: "Özel entegrasyonlarda içerikle ilgili özelleştirmeler yapabilmek için data etiketlerini kullanabilirsiniz.",
        tags: "Etiketler",
        reminderNotificationMsg: "Katılımcılara oturum hatırlatma bildirimi gönderilecek.",
        specifyTime: "Saat belirtiniz",
        chooseTime: "Saat seçiniz",
        noSpeakerMsg: "Henüz hiç konuşmacı eklenmemiş."
      }
    },
    speakers: {
      addSpeaker: "Konuşmacı ekle",
      editSpeaker: "Konuşmacı düzenle",
      filter: "Filtrele",
      filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
      speaker: "Konuşmacı",
      viewing: "Yayınla",
      searchFilter: "Ara / Filtrele",

      speakerAddUpdate: {
        nameSurname: "Ad & Soyad",
        NamaSurnameMsg: "Konuşmacı adı soyadı yazılır. Katılımcılar görüntüleyebilir.",
        title: "Ünvan",
        company: "Şirket",
        email: "E-posta",
        emailMsg: "E-posta bilgisi katılımcılar ile paylaşılmaz.",
        bio: "Biyografi",
        pic: "Resim",
        orderNo: "Sıra numarası",
        picMsg: "Lütfen 500x500 ölçülerinde bir fotoğraf yükleyiniz.",
        presentations: "Sunumlar",
        presentationsMsg: "Farklı konularda birden fazla sunum konusu girebilirsiniz.",
        addPresentations: "Sunum ekle",
        links: "Bağlantılar",
        linkMsg: "Konuşmacıya ait sosyal medya hesapları, web sitesi gibi bağlantılar ekleyebilirsiniz. Bu bağlantılar konuşmacı profilinde görüntülenebilir.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklik yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Bu seçeneği kapattığınızda, katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
        useTags: "Etiketleri kullan",
        useTagsMsg: "Özel entegrasyonlarda içerikle ilgili özel işlemler yapabilmek için data etiketlerini kullanabilirsiniz.",
        presentationTitle: "Sunum başlığı",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet",
        incorrectFields: "{0} hatalı alan bulunmaktadır"
      }
    },
    sponsors: {
      addCategory: "Kategori ekle",
      editCategory: "Kategori düzenle",
      addSponsor: "Sponsor ekle",
      editSponsor: "Sponsor düzenle",
      sponsorAddUpdateAndCategoryAddUpdate: {
        pic: "Görsel",
        picMsg: "Lütfen 500x500 ölçülerinde bir fotoğraf yükleyiniz.",
        title: "Başlık",
        titleMsg: "Gireceğiniz başlık sponsor adı olarak yayınlanır.",
        titleMsgCat: "Gireceğiniz başlık kategori adı olarak yayınlanır.",
        link: "Link",
        linkMsg: "Sponsor görseline tıklandığında girmiş olduğunuz bağlantıya yönlendirilecektir. ",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklik yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Görüntüleme seçeneğini kapattığınızda mobil uygulama ve diğer dijital platformlar üzerinde bu içerik katılımcılar tarafından görüntülenemezler.",
        useTags: "Etiketleri kullan",
        useTagsMsg: "Özel entegrasyonlarda içerikle ilgili özel işlemler yapabilmek için data etiketlerini kullanabilirsiniz.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet",
        uploadText: "Dosyayı buraya bırakın veya <em>yüklemek için tıklayın</em>",
        imageSize: "Görsel boyutu",
        imageSizeMsg: "Kategori altında gruplandırılacak olan sponsor görsellerinin boyutunu belirler."
      }
    },
    stands: {
      filter: "Filtrele",
      filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
      searchFilter: "Ara / Filtrele",
      placeholderStand: "Stant ara...",

      stand: "Stant",
      broadcast: "Görüntüleme",
      addStand: "Stant ekle",
      editStand: "Stant düzenle",
      standAddUpdate: {
        title: "Başlık",
        titleMsg: "Belirteceğiniz başlık stand adı olarak yayınlanır.",
        saloon: "Salon",
        updateHallList: "Salon listesini güncelle",
        //TODO Kemal beye soralım
        saloonMsg: "Stant yerinin bulunduğu salonu tanımlar.",
        orderNo: "Sıra numarası",
        logo: "Logo",
        logoMsg: "Lütfen 500x500 boyutunda görsel yükleyiniz.",
        cover: "Kapak fotoğrafı",
        coverMsg: "Lütfen 1120x500 boyutunda görsel yükleyiniz.",
        content: "İçerik",
        contentDetails: "Gireceğiniz içerik stant hakkında detaylı bilgiler olarak yayınlanır.",

        contact: {
          contact: "İletişim",
          contactMsg: "Bu stant  için farklı iletişim kanalları ekleyebilirsiniz.",
          addressInformation: "Adres bilgileri",
          addressHeader: "Adres başlığı",
          addressHeaderMsg: "Adres bilgilerinizi tanımlayacağınız bir başlık giriniz.",
          openAdres: "Açık adres",
          country: "Ülke",
          city: "Şehir",
          mapLocation: "Harita Konumu",
          searchLocation: "Konum arama",
          searchLocationMsg: "Katılımcıların şirket konumuna kolaylıkla erişmesini sağlayabilirsiniz.",
          chooseLocation: "Konum belirleme",
          chooseLocationMsg: "Belirleyeceğiniz konum ziyaretçilerin şirket adresine harita üzerindeki konumdan kolayca erişebilmesini sağlar.",
          social: "Sosyal medya linkleri",
          mobilePhone: "Cep telefonu",
          phoneNumber: "Telefon numarası",
          email: "E-posta"
        },
        links: {
          links: "Linkler",
          linkMsg: "Bu stant alanı için web sitesi v.b yönlendirebileceğiniz farklı bağlantılar ekleyebilirsiniz.",
          title: "Başlık",
          url: "Url",
          view: "Görüntüleme",
          addLink: "Link Ekle",
          newLink: "Yeni Link",
          noLinkMessage: "Link bağlantı bilgileri mevcut değil."
        },
        gallery: {
          gallery: "Galeri",
          galleryMsg: "Ziyaretçiler için özel görseller, fotoğraflar ve Youtube videoları ekleyebilirsiniz.",
          media: "Medya",
          view: "Görüntüleme",
          youtubeVideo: "Youtube videosu",
          photo: "Fotoğraf",
          addMedia: "Medya Ekle",
          editMedia: "Medya Düzenle",
          noGalleryMessage: "Galeri bilgileri mevcut değil.",
          mediaComponent: {
            img: "Görsel",
            youtubeVideo: "Youtube videosu",
            title: "Başlık",
            titleMsg: "Gireceğiniz başlık ilgili medya içeriğinin adı olarak yayınlanır.",
            // img: "Görsel",
            imgMsg: "Lütfen 800x600 boyutlarında bir görsel yükleyiniz.",
            youtubeVideoUrl: "Youtube Url",
            youtubeVideoUrlMsg: "Lütfen Youtube paylaşım kısmından aldığınız video URL'ini buraya girin",
            preview: "Önizleme",
            settings: "Ayarlar",
            settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
            view: "Görüntüleme",
            viewMsg: "Görüntüleme seçeneğini kapattığınızda mobil uygulama ve diğer dijital platformlar üzerinde bu içerik katılımcılar tarafından görüntülenemezler.",
            close: "Kapat",
            delete: "Sil",
            save: "Kaydet"
          }
        },
        authorities: {
          authorities: "Yetkililer",
          authoritiesMsg: "Ziyaretçilerin yerinde ve online etkinliklerde stant temsilcileri ile iletişime geçmelerini sağlayabilirsiniz.",
          add: "Ekle",
          selectAuth: "Yetkili seçiniz",
          authorized: "Yetkili",
          task: "Görev",
          view: "Görüntüleme"
        },
        checkinQuestions: {
          checkinQuestions: "Ziyaretçi anketleri",
          checkinQuestionsMsg: "Stant ziyaretçilerine QR kod aracılığı ile yanıtlayabilecekleri, özel soru setlerinden oluşan anket ve formlar hazırlayabilir ve bilgi toplayabilirsiniz."
        },
        settings: {
          settings: "Ayarlar",
          settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
          checkIn: "Check-in yöntemi",
          checkInMsg: "Etkinlik türüne (online, onsite, hybrid) göre stant ziyaretçilerinizin check-in işlemlerini dijital olarak gerçekleştirebilir ya da sahada mobil cihazlar aracılığı ile yaka kartını okutarak gerçekleştirebilirsiniz.",
          view: "Görüntüleme",
          viewMsg: "Bu seçeneği kapattığınızda, katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
          useTags: "Etiketleri kullan",
          useTagsMsg: "Özel entegrasyonlarda içerikle ilgili özelleştirmeler yapabilmek için data etiketlerini kullanabilirsiniz."
        },
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet",
        incorrectFields: "{0} hatalı alan bulunmaktadır."
      },
      standSaloon: {
        title: "Başlık",
        color: "Renk",
        view: "Görüntüleme",
        close: "Kapat",
        addSaloon: "Salon ekle",
        editSaloon: "Salon düzenle",
        saloonStandAddUpdate: {
          title: "Başlık",
          titleMsg: "Belirteceğiniz başlık salon adı olarak yayınlanır.",
          color: "Renk",
          colorMsg: "Salonu görsel olarak ayrıştırabilmek için lütfen bir renk belirleyin.",
          settings: "Ayarlar",
          settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
          view: "Görüntüleme",
          viewMsg: "Görüntüleme seçeneğini kapattığınızda mobil uygulama ve diğer dijital platformlar üzerinde bu içerik katılımcılar tarafından görüntülenemezler.",
          close: "Kapat",
          delete: "Sil",
          save: "Kaydet"
        }
      },
      standCheckin: {
        close: "Kapat",
        download: "İndir"
      }
    },
    networking: {
      addRoom: "Oda ekle",
      room: "Oda",
      view: "Görüntüleme",
      people: "Kişilik",
      addNetworkRoom: "Networking odası ekle",
      editNetworkRoom: "Networking odası düzenle",
      networkingAddUpdate: {
        title: "Başlık",
        titleMsg: "Belirteceğiniz başlık oda adı olarak yayınlanır.",
        numberOfPeople: "Kişi sayısı",
        numberOfPeopleMsg: "Oda için bir katılımcı limiti belirler.",
        cover: "Kapak fotoğrafı",
        coverMsg: "1120 x 500 ölçülerinde görsel yüklemeniz önerilir.",
        backgroundImage: "Arka plan görseli",
        backgroundImageMsg: "1920 x 1200 ölçülerinde görsel yüklemeniz önerilir.",
        authorities: {
          authorities: "Yetkililer",
          authoritiesMsg: "Bu oda için farklı görevlere sahip yetkili atayabilirsiniz.",
          add: "Ekle",
          selectAuth: "Yetkili seçiniz",
          authorized: "Yetkili",
          task: "Görev",
          view: "Görüntüleme",
          alreadyHas: "Eklemek istediğiniz katılımcı zaten yetkili listesinde."
        },
        settings: {
          settings: "Ayarlar",
          settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
          view: "Görüntüleme",
          viewMsg: "Görüntüleme seçeneğini kapattığınızda mobil uygulama ve diğer dijital platformlar üzerinde bu içerik katılımcılar tarafından görüntülenemezler."
        },
        oneError: "1 Hatalı alan bulunmaktadır",
        control: "Geçiş kontrol otomasyonu",
        controlMsg: "Dijital kontrol noktaları ile giriş kontrol işlemlerini yapabilir, giriş kayıtlarını tutabilirsiniz.",
        controlPoints: "Kontrol noktası",
        controlPointsMsg: "Bu networking odası için tanımlanmış bir kontrolcü bulunmuyor. Bir kontrolcü tanımlamak için “Kontrol noktaları” kısmından yeni bir kontrolcü oluşturarak networking odasını tanımlayabilirsiniz.",
        controlPointsGo: "Kontrol noktalarına git",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      }
    },
    eventAlbum: {
      gallery: {
        gallery: "Albüm",
        addMediaForAlbum: "Albüm için bir medya ekleyin",
        photo: "Fotoğraf",
        addMedia: "Medya ekle",
        editMedia: "Medya düzenle",
        mediaComponent: {
          img: "Görsel",
          youtubeVideo: "Youtube videosu",
          title: "Başlık",
          titleMsg: "Belirteceğiniz başlık medya adı olarak yayınlanır.",
          // img: "Görsel",
          imgMsg: "Lütfen minimum 800x600 boyutlarında bir görsel yükleyiniz",
          youtubeVideoUrl: "Youtube Url",
          youtubeVideoUrlMsg: "Lütfen Youtube paylaşım kısmından alınan video URL'ini giriniz",
          preview: "Önizleme",
          settings: "Ayarlar",
          settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
          view: "Görüntüleme",
          viewMsg: "Bu seçeneği kapattığınızda, katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
          close: "Kapat",
          delete: "Sil",
          save: "Kaydet"
        }
      }
    },
    files: {
      addFolder: "Klasör ekle",
      editFolder: "Klasör düzenle",
      downloadDocument: "Dosyayı indir",
      editDocument: "Dosyayı düzenle",
      deleteDocument: "Dosyayı sil",
      addDocument: "Dosya ekle",
      fileAddUpdate: {
        file: "Dosya",
        fileMsg: 'Maksimum 15 MB boyutunda ve ".doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx, .gif, .txt, .jpg, .png" uzantılı dosyalar yükleyiniz.',
        title: "Başlık",
        titleMsg: "Belirteceğiniz başlık dosya adı olarak yayınlanır.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Bu seçeneği kapattığınızda, katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez",
        useTags: "Etiketleri kullan",
        useTagsMsg: "Özel entegrasyonlarda içerikle ilgili özelleştirmeler yapabilmek için data etiketlerini kullanabilirsiniz.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet",
        reason: "Sebep"
      },
      fileCategoryAddUpdate: {
        title: "Başlık",
        titleMsg: "Belirteceğiniz başlık dosya adı olarak yayınlanır.",
        color: "Renk",
        colorMsg: "Belirteceğiniz renk klasör rengi olarak yayınlanır.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Görüntüleme seçeneğini kapattığınızda mobil uygulama ve diğer dijital platformlar üzerinde bu içerik katılımcılar tarafından görüntülenemezler.",
        useTags: "Etiketleri kullan",
        useTagsMsg: "Özel entegrasyonlarda içerikle ilgili özel işlemler yapabilmek için data etiketlerini kullanabilirsiniz.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      }
    },
    quaestionLibrary: {
      addQuestion: "Soru ekle",
      editQuestion: "Soru düzenle",
      filter: "Filtrele",
      filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
      searchFilter: "Ara / Filtrele",
      question: "Soru",
      view: "Görüntüleme",
      quaestionLibraryAddUpdate: {
        title: "Soru",
        titleMsg: "Lütfen soru metnini buraya yazın.",
        answer: "Cevap",
        answerMsg: "Belirteceğiniz metin yukarıda girdiğiniz soruya verilen cevap olarak yayınlanır.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Görüntüleme seçeneğini kapattığınızda mobil uygulama ve diğer dijital platformlar üzerinde bu içerik katılımcılar tarafından görüntülenemezler.",
        useTags: "Etiketleri kullan",
        useTagsMsg: "Özel entegrasyonlarda içerikle ilgili özel işlemler yapabilmek için data etiketlerini kullanabilirsiniz.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      }
    },
    areaMap: {
      addMap: "Harita ekle",
      editMap: "Harita düzenle",
      filter: "Filtrele",
      filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
      searchFilter: "Ara / Filtrele",
      map: "Harita",
      view: "Görüntüleme",
      areaMapAddUpdate: {
        img: "Görsel",
        imgMsg: "Minimum 800 x 600 ölçülerinde bir görsel yüklemeniz önerilir.",
        title: "Başlık",
        titleMsg: "Belirteceğiniz başlık harita adı olarak yayınlanır.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Görüntüleme seçeneğini kapattığınızda mobil uygulama ve diğer dijital platformlar üzerinde bu içerik katılımcılar tarafından görüntülenemezler.",
        useTags: "Etiketleri kullan",
        useTagsMsg: "Özel entegrasyonlarda içerikle ilgili özelleştirmeler yapabilmek için data etiketlerini kullanabilirsiniz.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      }
    }
  },
  eventInfo: {
    logo: {
      description: "500 x 500 Logo yükle"
    },
    cover: {
      description: "1120 x 500 Kapak resmi yükle"
    },
    about: {
      title: "Etkinlik hakkında",
      informations: "Bilgiler",
      informationsMsg: "Etkinliğiniz ile ilgili temel bilgileri tanımlayınız.",
      eventName: "Etkinlik adı",
      eventNameMsg: "Etkinlik adını tanımlar.",
      color: "Renk",
      colorMsg: "Etkinliğinizin kurumsal rengini belirleyiniz. Uygulamalar tanımlı renge göre uyarlanır.",
      language: "Diller",
      languageMsg: "Etkinlik dillerini tanımlar.",
      timezone: "Zaman dilimi",
      timezoneMsg: "Etkinliğin gerçekleşeceği bölgenin zaman dilimini tanımlar. Zaman dilimi dışındaki katılımcıların etkinlik tarih ve saatlerini doğru algılamasını sağlar.",
      date: "Tarih",
      dateMsg: "Etkinliğinizin gerçekleşeceği başlangıç ve bitiş tarih ve saatlerini giriniz.",
      stardDate: "Başlangıç tarihi",
      stardDateMsg: "Etkinliğin başlangıç tarihini tanımlar.",
      startTime: "Başlangıç saati",
      startTimeMsg: "Etkinliğin ilk gününün başlangıç saatini tanımlar.",
      endDate: "Bitiş tarihi",
      endDateMsg: "Etkinliğin bitiş tarihini tanımlar.",
      endTime: "Bitiş saati",
      endTimeMsg: "Etkinliğin son gününün bitiş saatini tanımlar.",
      localization: "Yerelleştirme",
      localizationMsg: "Etkinliğin gerçekleşeceği bölgenin ve katılımcı kitlesinin yerel koşullarına göre yerelleştirme ayarlarını yapınız.",
      dateFormat: "Tarih formatı",
      dateFormatMsg: "Uygulamalarda belirttiğiniz tarih formatına göre yayınlanır.",
      timeFormat: "Saat formatı",
      timeFormatMsg: "Etkinliğin gerçekleşeceği bölgenin saat dilimine göre ayarlayınız. Bu bölge dışındaki katılımcıların etkinlik tarih ve saatlerini kendi bölgelerine göre uyarlamasını sağlar.",
      content: "İçerik",
      contentMsg: "Katılımcılarınızın etkinliğiniz hakkında daha fazla bilgi edinmesi için detaylı bilgiler girin.",
      eventType: "Etkinlik türü",
      eventTypeMsg: "Hibrit, online ya da saha etkinlik türlerinden birini seçiniz.",
      category: "Kategori",
      categoryMsg: "Etkinliğinizin kapsam ve içeriğine uygun bir kategori belirtin.",
      about: "Hakkında",
      aboutMsg: "Katılımcılarınızla etkinliğinizi tanıtan detaylı bilgiler paylaşın.",
      save: "Kaydet"
    },
    location: {
      title: "Konum, İletişim, Sosyal",
      addressTitle: "Adres",
      addressTitleMsg: "Açık adres bilgilerinizi girerek katılımcılarınızın kolay ve zahmetsiz bir şekilde etkinlik mekanına gelmelerini sağlayabilirsiniz.",
      venue: "Mekan",
      venueMsg: "Etkinliğin gerçekleşeceği mekanın adını ve diğer bilgilerini giriniz.",
      address: "Adres",
      addressMsg: "Etkinliğin gerçekleşeceği konumun açık adres bilgilerini giriniz.",
      country: "Ülke",
      countryMsg: "Etkinliğin gerçekleşeceği ülke bilgisini giriniz.",
      city: "Şehir",
      cityMsg: "Etkinliğin gerçekleşeceği şehir bilgisini giriniz.",
      location: "Konum",
      locationMsg: "Etkinlik mekanınızın konum bilgilerini girerek katılımcılarınızın navigasyon erişimine yardımcı olabilirsiniz.",
      mapLocation: "Konum",
      mapLocationMsg: "Etkinliğin gerçekleşeceği mekanın harita konum bilgisini tanımlar. Katılımcılar bu bilgi sayesinde navigasyon uygulamaları üzerinden kolayca rota oluşturabilir."
    },
    contact: {
      contact: "İletişim",
      contactMsg: "Katılımcılarınızın size kolaylıkla ulaşabilmesi için iletişim bilgilerinizi girin."
    },
    social: {
      social: "Sosyal",
      socialMsg: "Sosyal medya hesaplarınızda etkinliğiniz ile ilgili etkileşimleri artırmak ve daha fazla kişiye erişmek için sosyal medya hesaplarınızı ekleyebilirsiniz."
    },

    settings: {
      title: "Ayarlar",
      settings: "Ayarlar",
      settingsMsg: "Temel ayarlarda değişiklik yaparak Holacon'u etkinlik içeriğine ve akışına uyarlayabilirsiniz.",
      autoCheckin: {
        title: "Otomatik Check-in",
        description: "QR Kod, Voucher ya da Yaka Kartı bulunan katılımcılar bunları kullanarak geçiş kontrol noktalarından direk geçiş yapabilirler. Bu seçenek aktifleştirildiğinde katılımcıların kodlarını ilk okutma esnasında sistem otomatik olarak check-in işlemlerini gerçekleştirir."
      },
      interaction: {
        interaction: "Etkileşim",
        interactionMsg: "Etkileşim ayarlarında dilediğiniz değişiklikleri yaparak Holacon’u etkinliğinizin içerik, konsept ve akışına göre uyarlayabilirsiniz.",
        restrictSession: "Oturum değerlendirmelerini kısıtla",
        restrictSessionMsg: "Oturum değerlendirmelerini kısıtladığınızda katılımcılarınızın yaptığı değerlendirmeler diğer katılımcılar tarafından görüntülenemez.",
        profileView: "Profil görüntülemeyi kapat",
        profileViewMsg: "Profil görüntüleme özelliğini kapattığınızda, katılımcılar uygulamaların içerisinde birbirlerinin profil bilgilerine erişemezler."
      },
      save: "Kaydet"
    },

    modules: {
      title: "Modüller",
      modules: "Modüller",
      modulesMsg: "Uygulama modülleri üzerinde etkinliğinizin konsept ve içeriğine göre düzenlemeler yapabilir, uyarlayabilir ve Webview modüller ekleyebilirsiniz.",
      addModule: "Modül Ekle",
      module: "Modül",
      view: "Görüntüleme",
      publishMsg: "{0} modülünü katılımcı uygulamaları için özelleştir ve yayınla.",
      save: "Kaydet",
      moduleSettings: "Modül ayarları",
      eventModuleUpdate: {
        en: "English",
        tr: "Türkçe",
        title: "Başlık",
        titleMsg: "Modülün adını tanımlar.",
        url: "Url",
        urlMsg: "Modülün erişeceği URL'i tanımlar.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Bu seçeneği kapattığınızda katılımcılar, uygulamalar ve diğer dijital platformlarda bu modülü görüntüleyemez.",
        openInApp: "Uygulama içinde aç",
        openInAppMsg: "Seçeneği aktif ettiğinizde eklediğiniz bağlantı uygulama içerisinde açılacaktır.",
        onlyAttendees: "Sadece katılımcılar erişebilir",
        onlyAttendeesMsg: "Bu seçeneği aktif ettiğinizde etkinlik kaydı olmayan ziyaretçiler bu modülü uygulamalar üzerinde görüntüleyemezler.",
        close: "Kapat",
        delete: "Sil",
        save: "Onayla",
        type: "Tip",
        text: "Metin",
        textMsg: "Modülün içeriğini tanımlar.",
        tag: "Etiketler",
        tagMsg: "Sadece bu etikete sahip katılımcılar bu modülü görüntüleyebilir."
      }
    },

    widgets: {
      title: "Hazır widget'lar",
      widgets: "Widget'lar",
      widgetsMsg: "Hazır widget'ları kullanarak web sitesi ve benzeri dijital mecralarda içeriklerinizi gömülü JS kodları ile yayınlayabilirsiniz.",
      registration: "Kayıt formu",
      registrationMsg: "Etkinlik kayıt formunuzu özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz.",
      program: "Program",
      programMsg: "Etkinlik programınızı özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz.",
      speakers: "Konuşmacılar",
      speakersMsg: "Etkinlik konuşmacılarınızı özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz. ",
      sponsor: "Sponsorlar",
      sponsorMsg: "Etkinlik sponsorlarınızı özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz.",
      foyer: "Fuaye",
      foyerMsg: "Etkinlik fuaye alanlarınızı özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz.",
      album: "Albüm",
      albumMsg: "Etkinlik albümünüzü özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz.",
      faq: "Sık sorulan sorular",
      faqMsg: "Etkinliğinizin sık sorulan sorularını özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz.",
      social: "Sosyal hub",
      socialMsg: "Etkinliğin sosyal hub'ını özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz.",
      vote: "Oylama",
      voteMsg: "Etkinlik canlı oylama ekranlarını özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz.",
      poll: "Anket",
      pollMsg: "Etkinlik anketlerinizi özelleştirerek dilediğiniz dijital kanallarda yayınlayabilirsiniz",
      soon: "Yakında",
      save: "Kaydet"
    }
  },
  onsiteUtilities: {
    digitalCertificate: {
      create: "Sertifika tasarımı oluştur",
      certificateName: "Sertifikanız için bir isim belirleyiniz.",
      certificateNamePlaceholder: "Sertifika adı",
      expriryDate: "Sertifilarınız için son geçerlilik tarihi belirleyerek sertifikalarınızın belirli bir tarihe kadar geçerli olmasını sağlayabilirsiniz.",
      expriryDatePlaceholder: "Son geçerlilik tarihi",
      save: "Kaydet",
      cancel: "Vazgeç",
      saveSure: "Değişiklikler kaydedilecektir emin misiniz?"
    },
    cardDesigner: {
      createCardDesign: "Kart tasarımı oluştur",
      editCardDesign: "Kart tasarımı düzenle",
      cardDesigns: "Kart tasarımları",
      card: "Kart",
      view: "Görüntüleme",
      addUpdate: {
        title: "Başlık",
        titleMsg: "Baskı tasarımını belirleyecek bir isim giriniz.",
        variable: "Değişkenler",
        variableMsg: "Baskı tasarımının içerisine yerleştireceğiniz değişkenler, baskı esnasında katılımcı bilgilerine göre otomatik doldurulmasını sağlar.",
        addBg: "Arka plan ekle",
        editBg: "Arka planı sil",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Görüntüleme seçeneğini kapattığınızda mobil uygulama ve diğer dijital platformlar üzerinde bu içerik katılımcılar tarafından görüntülenemezler.",
        printBg: "Arka planı bas",
        printBgMsg: "Eklediğiniz arka planın yazıcıya imaj olarak gönderilmesini sağlar. Aksi taktirde arka plan sadece kılavuz olarak kullanılır.",
        textCustomization: "Metin özelleştirme",
        textCustomizationMsg: 'Büyük / küçük harf düzeni göz önünde bulundurulmaz. Örn; küçük "i" harfi büyük "İ" harfi olarak  yazıldığında baskıya "İ" olarak gönderilir.',
        textCustomizationMsg2: "Metin formatındaki değişkenleri belirli bir standarda uyarlar.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      }
    },
    controlPoints: {
      createControlPoint: "Kontrol noktası oluştur",
      editControlPoint: "Kontrol noktası düzenle",
      title: "Başlık",
      controlType: "Kontrol Tipi",
      view: "Görüntüleme",
      seatingArrangement: "Oturma Düzeni",
      allTags: "Tüm etiketler",
      selectedTags: "Seçili etiketler",
      selectedTitle1: "Seçili alt etkinlik kaydı olanlar",
      selectedTitle2: "Seçili canlı oturumlara girebilirler.",
      selectedTitle3: "Seçili networking odalarına girebilirler.",
      vanueAddUpdate: {
        title: "Başlık",
        titleMsg: "Kontrolcüye bir isim verin.",
        controllerType: "Kontrolcü türü",
        controllerTypeMsg: 'Seçeceğiniz kontrolcü türüne göre ilgili platformlarda geçiş kontrol tanımlayabilirsiniz.  Örn;  "Dijital kontrol" sadece canlı oturumlar ve networking odaları gibi alanları kontrol eder.',
        controlType: "Kontrol tipi",
        controlTypeMsg: "Geçiş kontrol için katılımcı ve katılım türü kısıtlamalarının yapılmasını sağlar.",
        message1: "Bu gruba ait etiket bulunamadı.",
        message2: "Seçilen canlı oturumlara girebilir",
        message3: "Seçilen canlı networking odalarına girebilir",
        assignedCheckpoint: "Daha önce kontrol noktası atanmış",
        note: "Not",
        noteMsg: "Kontrol noktası ile ilgili bilgi metni, kontrol eden kişi tarafından görüntülenebilir.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Bu seçeneği kapattığınızda katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
        timeRestriction: "Saat kısıtlaması",
        timeRestrictionMsg: "Bu kontrol noktasını belirli saatler arasında çalışacak şekilde ayarlayabilirsiniz. Seçeneği aktif ettiğinizde kontrolcü ilgili saat aralığı dışında geçiş izni vermeyecektir.",
        startTime: "Başlangıç saati",
        endTime: "Bitiş saati",
        specifyTime: "Saat belirtiniz",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      },
      accessLogs: {
        close: "Kapat",
        download: "İndir"
      }
    },
    promotions: {
      close: "Kapat",
      download: "İndir",
      reset: "Sıfırla",
      searchFilter: "Ara / Filtrele",
      filter: "Filtrele",
      filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
      searchPlaceholder: "Ara...",
      attendee: "Katılımcı",
      promotions: "Promosyonlar",
      authorized: "Yetkili",
      quantity: "Adet",
      addPromotion: "Promosyon ekle",
      editPromotion: "Promosyon düzenle",
      title: "Başlık",
      stockDistributed: "Dağıtılan / Stok",
      remainder: "Kalan",
      view: "Görüntüleme",

      promotionAddUpdate: {
        title: "Başlık",
        titleMsg: "Promosyon grubunu isimlendirmek için bir başlık belirleyiniz.",

        stock: "Stok",
        stockMsg: "Stok adedinizi giriniz. Stok adedi ürünün kaç adet dağıtılacağını belirler.",
        note: "Not",
        noteMsg: "Promosyon ile ilgili bilgilendirme metni promosyonu dağıtan görevli tarafından görüntülenebilir.",

        limitations: "Kısıtlamalar",
        limitationsMsg: "Promosyonun sadece belirli segmentteki katılımcılara dağıtılmasını sağlar.",
        limitationsNotFound: "Bu gruba ait etiket bulunamadı.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Bu seçeneği kapattığınızda katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",

        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      }
    }
  },
  automatedMessages: {
    submissionHistory: "Gönderim geçmişi",
    addNewDraft: "Yeni taslak ekle",
    noDataThisCategory: "Bu kategoriye ait veri bulunamadı.",
    addVoucher: "Voucher ekle",
    editVoucher: "{0} düzenleniyor",
    scheduleReminder: "Program hatırlatıcı",
    automaticMessageRecords: "Otomatik ileti kayıtları",
    edit: "{0} düzenle"
  },
  liveSessions: {
    live: "Canlı",
    waiting: "Bekliyor",
    cloudDesc: "Yayını kaydetmek için “Aktif” olmalıdır. Canlı yayın arşivleme özelliği ek ücrete tabidir. Satın aldığınız plan kapsamında olması gerekir. Bu ayarı yayın başladıktan sonra güncelleyemezsiniz.",
    activationDesc: "Canlı yayın aktif edildiğinde katılımcılar oturuma katılabilir ve yayını izleyebilirler.",
    liveActive: "Canlı yayın aktif edilsin mi?",
    important: "Önemli Bilgilendirme",
    importantDesc:
      "Etkinlik anında katılımcılarınıza daha iyi bir etkinlik deneyimi sunabilmek için, konuşmacılarınızın internet bağlantısı için Ethernet kablosu kullanmasını tavsiye ederiz. Wi-fi üzerinden yapılan bağlantılar anlık internet problemlerine ve gecikmelere sebep olabilir. Kurum içi özel internet kullanan konuşmacılar için herhangi bir erişim problemi olmaması açısından bağlantı izinleri ve  kontrollerinin önceden yapılmasını tavsiye ederiz. Konuşmacılar için önerilen tarayıcı Chrome güncel sürümdür.",
    importantDesc_: "Apple cihazlarından konuşmacı olarak yayın yapabilmek için Safari güncel sürüm kullanımı zorunludur.",
    statusDesc: "Pasif oturumlar konuşmacılar ve katılımcılar tarafından görüntülenemezler.",
    vimeoSesions: "Vimeo Yayınları",
    electedSpeaker: "Konuşmacı olarak seçilenler",
    rtmpTitle: "RTMP üzerinden yayın aktarımı",
    rtmpDesc: "Özel bir yayın kaynağından aktarım yapmak için odaya özel birr RTMP adresi kullanabilirsiniz. URL'i kullanabilmek için odaya konuşmacı eklememeniz gerekmektedir.",
    rtmpMessage: "RTMP Yayın adresi kopyalandı.",
    rtmpCopy: "Kopyalamak için tıklayın",
    searchFilter: "Ara / Filtrele",
    filter: "Filtrele",
    filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
    searchPlaceholder: "Ara / Filtrele",

    broadcastRecordings: "Yayın kayıtları",
    addSession: "Oturum ekle",
    liveSession: "Canlı oturum",
    startEnd: "Başlangıç / Bitiş",
    duration: "Süre",
    speakersForBroadcast: "Bu canlı oturum için tanımlanan konuşmacılar.",
    speaker: "Konuşmacı",
    liveSessionManagament: "Canlı oturum yönetimi",
    createLiveSession: "Canlı oturum oluştur",
    createLiveStream: {
      placeholderChooseHour: "Saat belirtiniz",
      placeholderChooseDate: "Tarih seçiniz",
      holaconMsg: "Kolay, pratik ve yüksek kaliteli yayınlar için Holacon'un hazır yayın altyapısını kullanın!",
      rtmpMsg: "Yolobox, OBS, StreamYard, ReStream.io vb. kaynaklardan aktarın.",
      vimeoMsg: "Vimeo, YouTube vb. kaynakları ekleyin.",
      zoomMsg: "Hazır Zoom entegrasyounu kullanın.",
      soon: "Çok yakında!",
      title: "Başlık",
      titleMsg: "Bu yayın odası için bir başlık giriniz.",
      startDate: "Başlangıç tarihi",
      startDateMsg: "Bu yayın için bir başlangıç tarihi girin.",
      startTime: "Başlangıç saati",
      startTimeMsg: "Bu yayın için bir başlangıç saati girin.",
      endDate: "Bitiş tarihi",
      endDateMsg: "Bu yayın için bir bitiş tarihi girin.",
      endTime: "Bitiş saati",
      endTimeMsg: "Bu yayın için bir bitiş saati girin.",
      coverImg: "Kapak resmi",
      coverImgMsg: "1120 piksel en ve 500 piksel yüksekliğinde bir görsel yükleyiniz.",
      close: "Kapat",
      save: "Kaydet"
    },
    editLiveStream: {
      placeholderAddSpeaker: "Konuşmacı ekleyin...",
      placeholderNameDesign: "Tasarımınıza bir isim verin.",
      server: "Sunucu",
      serverKey: "Yayın anahtarı",
      information: "Bilgiler",
      speakers: "Konuşmacılar",
      broadcastTitle: "Yayın",
      scenesTitle: "Sahneler",
      settingsTitle: "Ayarlar",
      info: {
        placeholderChooseHour: "Saat belirtiniz.",
        placeholderChooseDate: "Tarih seçiniz.",
        title: "Başlık",
        titleMsg: "Canlı oturumunuz için bir başlık giriniz. Programda yayının/oturumun ismi olarak görüntülenecektir.",
        startDate: "Başlangıç tarihi",
        startDateMsg: "Bu oturum için bir başlangıç tarihi belirtiniz.",
        startTime: "Başlangıç saati",
        startTimeMsg: "Bu oturum için bir başlangıç saati belirtiniz.",
        endDate: "Bitiş tarihi",
        endDateMsg: "Bu oturum için bir bitiş tarihi belirtiniz.",
        endTime: "Bitiş saati",
        endTimeMsg: "Bu oturum için bir bitiş saati belirtiniz.",
        coverImg: "Kapak resmi",
        coverImgMsg: "1120 x 500 ölçülerinde bir görsel yükleyiniz.",
        imporantInformation: "Önemli bilgilendirme",
        imporantInformationMsg: "Canlı yayın hakkında dikkat edilmesi gereken konulara göz atmak için tıklayın.",
        imporantInformationAll:
          "<p><b>Kesintisiz ve sorunsuz bir canlı yayın deneyimi için:</b></p><p>• Konuşmacılarınızın internet bağlantısının kesintisiz minimum 16 Megabit indirme ve 8 Megabit yükleme özelliklerine sahip olduğundan emin olun. Bu değerler ölçümlenmiş alt değerlerdir.</p><p>• Wi-fi üzerinden yapılan bağlantılar anlık internet problemlerine ve gecikmelere sebep olabilir. Ethernet kablosu ile yayın yapan bilgisayarların internete bağlanması tavsiye edilir.</p><p>• Kurum içi özel güvenlik prosedürleri ve kısıtlamaları olan bir internet altyapısı kullanan konuşmacılar için herhangi bir erişim problemi olmaması açısından bağlantı izinleri ve kontrollerinin önceden yapılması ve prova alınması tavsiye edilir. </p><p>• Windows üzerinden yayın yapacak konuşmacılar için önerilen tarayıcı Chrome güncel sürümdür.</p><p>• MacOS cihazlarından konuşmacı olarak yayın yapabilmek için Safari veya Chrome güncel sürüm kullanımı zorunludur.</p><p>• IOS cihazlarından konuşmacı olarak yayın yapabilmek için Safari güncel sürüm kullanımı zorunludur.</p><p>• Android cihazlarından konuşmacı olarak yayın yapabilmek için Chrome güncel sürüm kullanımı zorunludur.</p><p>• Cihazların kamera, mikrofon, ekran paylaşımı erişim yetkilerinin eksiksiz verildiğinden emin olun.</p>"
      },
      speaker: {
        add: "Ekle",
        speaker: "Konuşmacı",
        task: "Görev",
        broadcast: "Yayın"
      },
      broadcast: {
        streamFromSomething: "Yolobox, OBS, StreamYard, ReStream.io vb. kaynaklardan aktarın.",
        streamRtmp: "RTMP üzerinden yayın aktarımı",
        streamRtmpMsg: "Özel bir yayın kaynağından aktarım yapmak için odaya özel bu RTMP adresini kullanabilirsiniz. URL'i kullanabilmek için yayın kaynağını doğru girdiğinizden emin olun ve test yayınları yapmayı unutmayın.",
        preview: "Önizleme",
        title: "Başlık",
        titleMsg: "Yayın odasına eklenen kaynakların isimlerini belirtir. Örneğin: Orijinal veya çeviri",
        platform: "Platform",
        platformMsg: "Kaynağın aktarılacağı platform",
        source: "Kaynak",
        sourceMsg: "Kaynağın aktarılacağı oynatma linki",
        broadcast: "Yayın",
        broadcastMsg: "Eklenen kaynağn görüntülenme durumu",
        addSource: "Kaynak ekle",
        addSourceMsg: "Vimeo, YouTube vb. kaynakları ekleyin.",
        addOneSource: "Bir kaynak ekle",
        noSpeaker: "Hiç konuşmacı eklenmemiş."
      },
      scenes: {
        headBanner: "Üst banner",
        headBannerMsg: "1000 piksel genişlik 100 piksel yükseklik",
        bg: "Arka plan",
        bgMsg: "1920 piksel genişlik 1200 piksel yükseklik",
        footBanner: "Alt banner",
        footBannerMsg: "1000 piksel genişlik 100 piksel yükseklik",
        save: "Kaydet",
        newTemplate: "Yeni template",
        createScene: "Sahne oluştur",
        success: "Bir taslak seçiniz. Taslağı kaydettiğinizde, yayına alınır.",
        delete: "Sil",
        copy: "Kopyala"
      },
      settings: {
        view: "Görüntüleme",
        viewMsg: "Bu seçeneği kapattığınızda katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
        liveBroadcast: "Canlı yayın",
        liveBroadcastMsg: "Canlı yayın aktif edildiğinde katılımcılar yayını izleyebilirler. Yayın pasif durumda iken sadece konuşmacılar ve moderatörler bu yayına katılabilir ve prova yapabilirler.",
        showViwer: "İzleyici sayısını göster",
        showViwerMsg: "Bu özellikle aktif edildiğinde canlı yayını izleyenlerin sayısı uygulamalarda gösterilir.",
        checkpoint: "Kontrol noktası",
        checkpointMsg: "Bu canlı yayın odası için tanımlanmış bir kontrolcü bulunmuyor. Bir kontrolcü tanımlamak için “kontrol noktaları” bölümünden yeni bir kontrolcü oluşturarak canlı yayın odasına tanımlayabilirsiniz.",
        goCheckpoints: "Kontrol noktalarına git"
      },
      close: "Kapat",
      delete: "Sil",
      save: "Kaydet"
    }
  },
  registrationManagement: {
    salesConfirmations: {
      participant: "Katılımcı",
      paymentInformation: "Ödeme Bilgisi",
      amount: "Tutar",
      status: "Durum",
      paymentIdDateSource: "Ödeme ID, Tarih, Kaynak",
      amountCodePackage: "Tutar, Kod, Paket",
      free: "Ücretsiz",
      confirm: "Onayla",
      reject: "Reddet"
    },
    registrationForm: {
      createForm: "Form oluştur",
      registerationForm: "Kayıt formu",
      packages: "Paketler",
      services: "Hizmetler",
      view: "Görüntüleme",
      registerationSpecialMsg: "Kayıt formu işleme kapatılmş. Form üzerinden kayıt işlemi gerçekleştirilemez.",
      freeRegisteration: "Ücretsiz kayıt",
      currency: "Para birimi:",
      currency2: "Para birimi",
      paymentMethod: "Ödeme yöntemi",
      description: "Açıklama",

      onlinePayment: "Online ödemeler:",
      paymentBankTransfer: "Banka transferi ile ödemeler:",
      on: "Açık",
      off: "Kapalı",
      editRegisterationForm: "Kayıt formunu düzenle",
      addRegisterationForm: "Kayıt formu oluştur",
      registerFormDialog: {
        search: "Ara",
        formInformations: {
          tabName: "Form bilgileri",
          topMsg: "Etkinliğe kayıt yaptıracak davetli kitlenize özel kayıt formları oluşturabilirsiniz. Örneğin <b>Standart Katılımcılar</b> için özelleştirilmiş bilgilendirme ve içeriklerin olduğu bir kayıt formu hazırlayabilirsiniz.",
          title: "Başlık",
          titleMsg: "Belirteceğiniz başlık kayıt formunun adı olarak yayınlanır.",
          language: "Dil",
          languageMsg: "Seçeceğiniz dil kayıt formunun görüntüleneceği dili belirler. Eğer dili <b>İngilizce</b> olarak belirlediyseniz form içeriklerini de bu dile göre hazırlamanız tavsiye edilir.",
          topBanner: "Üst banner",
          topBannerRecommend: "1120 piksel genişlik ve 100 piksel yüksekliğinde bir görsel eklemeniz önerilir. Üst banner kayıt formunun en üstünde konumlanır.",
          topBannerSureRemove: "Üst banner'ı kaldırmak istediğinizden emin misiniz?",
          uploadText: "Dosyayı buraya bırakın veya <em>yüklemek için tıklayın</em>",
          topBannerMaxSize: "Maksimum 1 mb boyutunda jpg veya png görsel yükleyebilirsiniz.",
          content: "İçerik",
          contentMsg: "Belirteceğiniz içerik kayıt formu hakkında bilgilendirme metni olarak yayınlanır.",
          subBanner: "Alt banner",
          subBannerRecommend: "1120 piksel genişlik ve 100 piksel yüksekliğinde bir görsel eklemeniz önerilir. Alt banner kayıt formunun en altında konumlanır.",
          subBannerSureRemove: "Alt banner'ı kaldırmak istediğinizden emin misiniz?",
          subBannerMaxSize: "Maksimum 1 mb boyutunda jpg veya png görsel yükleyebilirsiniz."
        },
        paymentInformations: {
          tabName: "Ödeme bilgileri",
          topMsg: "Oluşturacağınız formun içinde <b>ücretli</b> ya da <b>ücretsiz</b> kayıt, refakatçi ve ek hizmetler sunabilmeniz ve kayıt alabilmeniz için gerekli ayarları yapabilirsiniz.",
          currency: "Para birimi",
          currencyMsg: "Para birimi, kayıt formu üzerinden gerçekleştirilen ücretli işlemlerin hangi para biriminden işlem göreceğini belirler.",
          taxName: "Vergi adı",
          taxSettings: "Vergi ayarları",
          taxNameMsg: "Kayıt formu üzerinden gerçekleştirilen ücretli işlemler için uygulanan vergi türünü tanımlar.",
          taxRate: "Vergi oranı",
          taxRateMsg: "Vergi oranı, kayıt formu üzerinden gerçekleştirilen ücretli işlemler için uygulanan verginin oranını hesaplar. Yüzdesel bir değer girilmelidir.",
          onlinePayment: "Online ödemeler",
          onlinePaymentMsg: "Kuruluş hesabınıza tanımlı banka poslarını bu kayıt formuna tanımlayarak kayıt işlemi ücretlerini online ödemeler halinde alabilirsiniz.",
          paymentBankTransfer: "Banka transferi ile ödeme",
          paymentBankTransferMsg: "Banka transferi (Havale / EFT) yöntemi ile ödeme alabilmek için banka hesap bilgilerinizi giriniz.",
          test: "Test çekim denemesi",
          addEditPayment: "Ödeme yöntemi ekle / düzenle",
          addPayment: "Ödeme yöntemi ekle",
          paymentMethod: "Ödeme yöntemi",
          currency: "Para birimi",
          setActive: "Aktif olarak ayarla",
          freePaymentMsg: "Bu kayıt formunun ödeme bilgileri ücretsiz olarak devam edecektir. Herhangi bir ücret girilemez."
        },
        packages: {
          tabName: "Paketler",
          topMsg: "Oluşturacağınız formun içerisinde sunulacak kayıt işlemleri için farklı opsiyonlarda <b>kombine</b> veya <b>tek günlük</b> paketler oluşturabilirsiniz. Oluşturduğunuz paketlere farklı fiyat opsiyonları ekleyebilirsiniz.",
          addPackage: "Paket ekle",
          registrationPackage: "Kayıt Paketi",
          stock: "Stok",
          price: "Fiyat",
          view: "Görüntüleme",
          free: "Ücretsiz",
          edit: "Düzenle",
          delete: "Sil",
          pleaseAddOne: "Lütfen bir adet paket ekleyiniz.",
          editPackage: "Paket düzenle",
          addPackage: "Paket ekle",
          deleteSure: "Silmek istediğinizden emin misiniz?",
          addUpdateRegisterationPackage: {
            title: "Başlık",
            titleMsg: "Belirteceğiniz başlık paket adı olarak yayınlanır.",
            segmentation: "Segmentasyon",
            segmentationMsg: "Bu paket üzerinden gerçekleştirilen kayıtlara bağlı kişileri seçtiğiniz etikete tanımlayarak segment oluşturur.",
            subSegmentation: "Alt segmentasyon",
            subSegmentationMsg: "Bu paket üzerinden gerçekleştirilen kayıtlara bağlı kişileri seçtiğiniz etikete tanımlayarak segment oluşturur.",
            stock: "Stok",
            stockMsg: "Paket için uygulanacak kayıt sınırını belirler.",
            stockControl: "Stok kontrolü",
            stockControlMsg: "Belirtilen stok limitini baz alarak kayıtların kontrolünü tercih edilen yönteme göre gerçekleştirir.",
            content: "İçerik",
            contentMsg: "Belirteceğiniz içerik paket hakkında bilgilendirme metni olarak yayınlanır.",
            pricing: "Fiyatlandırma",
            pricingMsg: "Oluşturulacak paket için çeşitli tarih aralıklarında farklı fiyat opsiyonları uygulayabilirsiniz. İlk sırada bulunan <b>Standart</b> opsiyonu paketin sabit kayıt fiyatıdır.",
            startDate: "Başlangıç tarihi",
            endDate: "Bitiş tarihi",
            price: "Fiyat",
            free: "Ücretsiz",
            chooseDate: "Tarih seçiniz",
            newPriceOption: "Yeni fiyat seçeneği",
            packageType: "Paket tipi",
            packageMsg: 'Oluşturulacak paketin katılımcı için tanımlanan katılım günlerini belirler, paket için özel gün tanımlaması yapılabilir. <b>"Tek günlük paket"</b> sadece belirli günlerden birinin seçilmesini sağlar. <b>"Kombine paket"</b> ise tüm günlerde katılım sağlar.',
            addNewDay: "Yeni gün ekle",
            settings: "Ayarlar",
            settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
            view: "Görüntüleme",
            viewMsg: "Bu seçeneği kapattığınızda katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
            situation: "Durum",
            situationMsg: 'Durum seçeneğini kapattığınızda paket kayıt esnasında kullanılamaz, kayıt ekranında <b>"Tükendi"</b> ibaresi gösterilir.',
            close: "Kapat",
            delete: "Sil",
            save: "Kaydet"
          }
        },
        additionalServices: {
          tabName: "Ek hizmetler",
          tabName2: "Ek hizmet kategorileri",
          topMsg: "Oluşturacağınız formun içerisinde sunulacak kayıt işlemlerine bağlı farklı opsiyonlarda <b>konaklama, transfer, ürün, stant alanı</b> ve benzeri hizmet ve ürünler oluşturabilirsiniz.",
          addService: "Hizmet ekle",
          addCategory: "Kategori ekle",
          editCategory: "Kategori düzenle",
          service: "Hizmet",
          stock: "Stok",
          price: "Fiyat",
          view: "Görüntüleme",
          free: "Ücretsiz",
          deleteSure: "Silmek istediğinizden emin misiniz?",
          edit: "Düzenle",
          delete: "Sil",
          specialQuestion: "Özel sorular",
          specialQuestionMsg: "Ek hizmet kayıt işlemi için özel sorular oluşturabilirsiniz.",
          addService: "Hizmet ekle",
          editService: "Hizmet düzenle",
          deleteSure: "Silmek istediğinizden emin misiniz?",
          addUpdateRegisterationServices: {
            title: "Başlık",
            titleMsg: "Belirteceğiniz başlık servis adı olarak yayınlanır.",
            titleMsg2: "Belirteceğiniz başlık kategori adı olarak yayınlanır.",
            stock: "Stok",
            stockMsg: "Ek hizmet için kayıt sınırını belirler.",
            stockControl: "Stok kontrolü",
            stockControlMsg: "Belirtilen stok limitini baz alarak kayıtların kontrolünü tercih edilen yönteme göre gerçekleştirir.",
            gallery: "Galeri",
            galleryMsg: "Minimum 800 piksel genişlik ve 500 piksel yüksekliğinde bir görsel yüklemelisiniz. Ekleyeceğiniz resimler ek hizmet kaydı esnasında görsel olarak yayınlanır.",
            uploadText: "Dosyayı buraya bırakın veya <em>yüklemek için tıklayın</em>",
            uploadTextMsg: "500 KB'den küçük boyutlu jpg/png dosyalar",
            tag: "Kategori",
            tagMsg: 'Etiketi isimlendirdikten sonra klavyede "Enter" tuşuna basarak oluşturabilirsiniz. Ekleyeceğiniz etiketler ek hizmet kaydı esnasında filtre olarak yayınlanır.',
            addTag: "+ Etiket ekle",
            info: "Bilgi",
            infoMsg: "Bu alana gireceğiniz bilgiler ek hizmet açıklaması olarak yayınlanır.",
            packageRestriction: "Paket kısıtlaması",
            packageRestrictionMsg: 'Bu seçeneği aktif ettiğinizde, ilgili  ek hizmet için sadece tanımlayacağınız paketlerde kayıt  gerçekleştirilebilir. "Zorunlu" seçeneğini tanımlamanız durumunda, sistem ilgili ek hizmet seçilmeden kayıt gerçekleştirmeye izin vermez.',
            show: "Göster",
            required: "Zorunlu",
            hide: "Gizle",
            limitSettings: "Limit ayarları",
            limitSettingsMsg: "İlgili paketten gelen bir kaydın, pakete bağlı olarak en fazla kaç adet hizmet alabileceğini belirleyebilirsiniz.",
            package: "Paket",
            limit: "Limit",
            settings: "Ayarlar",
            settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
            view: "Görüntüleme",
            viewMsg: "Bu seçeneği kapattığınızda katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
            close: "Kapat",
            delete: "Sil",
            save: "Kaydet"
          }
        },
        companionRegistration: {
          tabName: "Refakatçi kaydı",
          tabName2: "Refakatçi kayıtları",
          topMsg: "Bu özellik, etkinliğe herhangi bir paket üzerinden kayıt gerçekleştiren katılımcıların refakatçiler ile birlikte kayıt işlemi gerçekleştirebilmesini sağlar.  Özelliği kullanabilmek için sağ üstte yer alan düğmeyi aktif hale getiriniz.",
          companionRegistrationAlert: "Katılımcılarınızın refakatçi kaydı oluşturabilmesi için öncelikle herhangi bir paket satın almış olması gerekir.",
          title: "Başlık",
          titleMsg: "Belirteceğiniz başlık refakatçi kayıt işlemini isimlendirir. Örneğin <b>Refakatçiler</b> olarak isim verebilirsiniz.",
          price: "Fiyat",
          priceMsg: "Kişi kaydına eklenen her bir refakatçi için uygulanacak ek ücreti belirler.",
          free: "Ücretsiz",
          stock: "Stok",
          stockMsg: "Refakatçiler için uygulanacak kayıt sınırını belirler.",
          stockControl: "Stok kontrolü",
          stockControlMsg: "Belirtilen stok limitini baz alarak refakatçi kayıtlarının kontrolünü tercih edilen yönteme göre gerçekleştirir.",
          packageRestriction: "Paket kısıtlaması",
          packageRestrictionMsg: "Bu seçenek, refakatçi kaydını sadece belirli paketlere dahil etmenize olanak sağlar. Kısıtlama yapılmadığı durumlarda, tüm paketlerde refakatçi kaydı alınabilir.",
          show: "Göster",
          required: "Zorunlu",
          hide: "Gizle",
          limitSettings: "Limit ayarları",
          limitSettingsMsg: "Seçili paketlerde, her bir paketten gelen kayıda bağlı en fazla kaç adet hizmet alınabileceğini belirleyebilirsiniz.",
          package: "Paket",
          limit: "Limit",
          specialQuestion: "Özel sorular",
          specialQuestionMsg: "Refakatçi kayıt işlemi için özel sorular oluşturabilirsiniz."
        },
        questionsAndInformation: {
          tabName: "Sorular ve bilgiler",
          couponCodes: "Kupon kodları",
          couponCodesMsg: "Etkinliğe herhangi bir paket opsiyonuyla kayıt olan kullanıcılar için indirimler sağlayabilirsiniz, paketlere kod kısıtlamaları tanımlayabilirsiniz."
        },
        couponCodes: {
          tabName: "Kupon kodları",
          export: "Dışa Aktar",
          generateCode: "Kod oluştur",
          title: "Başlık",
          definedPackage: "Tanımlı Paket",
          attachments: "Ön / Arka ekler",
          reminderBtn: "Hatırlatma gönder",
          codeLimit: "Kod / Limit",
          show: "Görüntüleme",
          code: "kod",
          edit: "Düzenle",
          delete: "Sil",
          addEditCoupon: "Kupon Ekle/Düzenle",
          codeList: "Kupon listesi",
          noCoupon: "Kupon kodu bulunamadı.",
          addRegistrationCoupon: {
            title: "Başlık",
            titleMsg: "Belirteceğiniz başlık kupon kodunu tanımlar.",
            prefix: "Ön ek",
            prefixMsg: "Ön ek, kupon kodunun başlangıç kısmına gelen tanımlamadır. Kod grubunu ayrıştırmaya olanak sağlar.",
            suffix: "Arka ek",
            suffixMsg: "Arka ek, kupon kodunun sonuna gelen tanımlamadır. Kod grubunu ayrıştırmaya olanak sağlar.",
            note: "Not",
            noteMsg: "Oluşturacağınız kod grubuna kendiniz için not bırakabilirsiniz.",
            couponSettings: "Kupon ayarları",
            couponSettingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
            quantity: "Adet",
            quantityMsg: "Bu kod grubu içinde üretilecek kupon kodu adedini belirler.",
            limit: "Limit",
            limitMSg: "Bu kod grubu içinde üretilecek her bir kodun kullanım limitini belirler.",
            discountType: "İndirim türü",
            discountTypeMsg: "Bu kod grubu içinde üretilen her bir kodun hangi türde indirim uygulayacağını belirler.",
            discountAmount: "İndirim tutarı",
            discountAmountMsg: "Bu kod grubu içinde üretilen her bir kodun toplam tutar üzerinden ne kadar indirim sağlayacağını belirler.",
            discountPercentage: "İndirim yüzdesi",
            discountPercentageMsg: "Bu kod grubu içinde üretilen her bir kodun toplam tutar üzerinden yüzde kaç indirim sağlayacağını belirler.",
            status: "Durum",
            statusMsg: "Bu seçeneği kapattığınızda,  katılımcılar kayıt ekranında kupon kodunu kullanamaz.",
            packageRestrictions: "Paket kısıtlamaları",
            packageRestrictionsMsg: "Kısıtlama seçeneğini aktif ettiğinizde kupon kodu sadece tanımlayacağınız paketlerde çalışır. Bu seçeneği zorunlu tutarsanız,  kodun bağlı olduğu pakette kupon kodu kullanılmadan kayıt gerçekleştirilemez",
            registrationPackage: "Kayıt paketi",
            define: "Tanımla",
            required: "Zorunlu",
            show: "Göster",
            reminder: "Hatırlatıcı",
            reminderMsg: "Bu seçeneği aktif ettiğinizde kupon kodunun kullanımı için ilgili kişiye e-posta gönderilir.",
            nameSurname: "Ad & Soyad",
            nameSurnameMsg: "Bilgilendirme e-postası gönderilecek kişinin adı ve soyadı",
            email: "E-posta",
            emailMsg: "Bilgilendirme gönderilecek kişinin e-postası",
            close: "Kapat",
            delete: "Sil",
            save: "Kaydet",
            placeholderTitle: "Örn: Hoşgeldin İndirimi",
            placeholderPrefix: "Örn: HOŞGELDİN-",
            placeholderSuffix: "Örn: -2022",
            placeholderNameSurname: "Örn: John Doe",
            placeholderNote: "Örn : Bu kupon kodu özel davetliler için oluşturuldu.",
            placeholderMail: "Örn: example@hotmail.com"
          },
          registrationCouponDetails: {
            copyCode: "Kodu kopyala",
            couponCode: "Kupon Kodu",
            copyLinkMsg: "Kayıt linki kopyalandı.",
            copyCodeMsg: "Kod kopyalandı.",
            limitUsage: "Limit / Kullanım",
            remainder: "Kalan",
            quickLink: "Hızlı kayıt linki",
            copyLink: "Linki Kopyala",
            close: "Kapat",
            download: "İndir"
          }
        },
        contracts: {
          tabName: "Sözleşmeler",
          registerContract: "Kayıt Sözleşmeleri",
          registerContractMsg: "Bu alanda yapacağınız değişiklikler kayıt formundaki işlemleri etkilemektedir. Bu sebeple değişiklikleri gerçekleştirirken dikkatli olunmasını öneririz.",
          gdprContract: "KVKK Sözleşmesi",
          gdprContractMsg: "Sözleşme aktif edildiğinde kayıt ekranına eklenir ve katılımcının sözleşme onayı zorunlu hale getirilir.",
          gdprTitle: "KVKK sözleşme başlığı",
          gdprTitleMsg: "Belirteceğiniz başlık kayıt formunda sözleşme başlığı olarak yayınlanır.",
          gdprContent: "KVKK sözleşme içeriği",
          gdprContentMsg: "Belirteceğiniz içerik kayıt formunda sözleşme metni olarak yayınlanır.",

          privacyPolicy: "Gizlilik Politikası",
          privacyPolicyMsg: "Sözleşme aktif edildiğinde kayıt ekranına eklenir ve katılımcının sözleşme onayı zorunlu hale getirilir.",
          privacyPolicyTitle: "Gizlilik Politikası sözleşme başlığı",
          privacyPolicyTitleMsg: "Belirteceğiniz başlık kayıt formunda sözleşme başlığı olarak yayınlanır.",
          privacyPolicyContent: "Gizlilik Politikası sözleşme içeriği",
          privacyPolicyContentMsg: "Belirteceğiniz içerik kayıt formunda sözleşme metni olarak yayınlanır.",
          termsOfUse: "Kullanım Şartları",
          termsOfUseMsg: "Sözleşme aktif edildiğinde kayıt ekranına eklenir ve katılımcının sözleşme onayı zorunlu hale getirilir.",
          termsOfUseTitle: "Kullanım Şartları sözleşme başlığı",
          termsOfUseTitleMsg: "Belirteceğiniz başlık kayıt formunda sözleşme başlığı olarak yayınlanır.",
          termsOfUseTitleContent: "Kullanım şartları sözleşme içeriği",
          termsOfUseTitleContentMsg: "Belirteceğiniz içerik kayıt formunda sözleşme metni olarak yayınlanır.",
          distanceSalesContract: "Mesafeli Satış Sözleşmesi",
          distanceSalesContractMsg: "Sözleşme aktif edildiğinde kayıt ekranına eklenir ve katılımcının sözleşme onayı zorunlu hale getirilir.",
          distanceSalesContractTitle: "Mesafeli satış sözleşme başlığı",
          distanceSalesContractTitleMsg: "Belirteceğiniz başlık kayıt formunda sözleşme başlığı olarak yayınlanır.",
          distanceSalesContractContent: "Mesafeli satış sözleşmesi içeriği",
          distanceSalesContractContentMsg: "Belirteceğiniz içerik kayıt formunda sözleşme metni olarak yayınlanır.",
          distanceSalesContractVariables: "Mesafeli satış sözleşmesi için değişkenler",
          distanceSalesContractVariablesMsg: "Bu değişkenleri sadece mesafeli satış sözleşmesinde kullanabilirsiniz."
        },
        formSettings: {
          tabName: "Form ayarları",

          formSettings: "Form ayarları",
          formSettingsMsg: "Bu alanda yapacağınız değişiklikler kayıt formundaki işlemleri etkilemektedir. Değişiklikleri yaparken dikkatli olunmasını öneririz. ",
          groupRegistration: "Grup kaydı",
          formStock: "Limit",
          formStockMsg: "Kayıt formunun alabileceği maximum kayıt sayısını belirtiniz.",

          groupRegistrationMsg: "Katılımcıların kayıt işlemi yaparken birden fazla kişi ekleyerek grup kaydı ve bilet satın alım işlemlerini yapmalarına olanak sağlar.",
          minAttandee: "Minimum katılımcı",
          maxAttendee: "Maksimum katılımcı",

          transaction: "İşlem ve makbuz bilgileri",
          transactionMsg: "Ödemeler & Onaylar bölümünde işlemi yapan ve işlemden sorumlu katılımcı olarak kaydedilir. İşlem bilgileri kapatılırsa 1. katılımcının iletişim bilgileri işlem bilgisi olarak kaydedilir ve detaylı fatura bilgisi alınmaz. Kapatılması önerilmez.",
          automaticConfirmation: "Otomatik onay",
          automaticConfirmationMsg: "Bu seçenek aktif edildiğinde, satışlar ve bağlı kayıtlar sistem tarafından otomatik onaylanır.",
          autoVoucher: "Otomatik voucher",
          autoVoucherMsg: "Bu seçenek aktif edildiğinde, sistem tarafından kaydı otomatik onaylanan katılımcılara otomatik Voucher gönderilir.",
          status: "Durum",
          statusMsg: 'Bu seçeneği kapattığınızda, kayıt formundan yeni kayıtlar alınamaz ve ekranda <b>"Kayıtlar sonlanmıştır"</b> ibaresi gösterilir.',
          show: "Görüntüleme",
          showMsg: 'Görüntüleme seçeneğini kapattığınızda, katılımcılar bu içeriğe erişemez ve görüntüleyemez. Özel link oluşturularak gönderilen formlarda <b>"Durum"</b> seçeneği aktif olduğu sürece kayıt işlemleri gerçekleştirilebilir.'
        },

        close: "Kapat",
        delete: "Sil",
        saveContract: "Sözleşme bilgilerini kaydet",
        saveFormInfo: "Form bilgilerini kaydet",
        savePaymentInfo: "Ödeme bilgilerini kaydet",
        saveCompanionSettings: "Refakatçi ayarlarını kaydet",
        saveFormSettings: "Form ayarlarını kaydet"
      }
    },
    subeventRegistrations: {
      records: "Kayıtlar",
      createSubevent: "Alt etkinlik oluştur",
      searchFilter: "Ara / Filtrele",
      filter: "Filtrele",
      filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
      searchPlaceholder: "Ara...",

      subevents: "Alt etkinlikler",
      title: "Başlık",
      capacityMsg: "Alt etkinlik için maksimum katılımcı sayısını belirtiniz.",
      capacity: "Kontenjan",
      mobileRegisterMsg: "Bu seçenek katılımcıların alt etkinliklere uygulamalar üzerinden ücretsiz bir şekilde kayıt olmasını sağlar.",
      mobileRegister: "Mobil kayıt",
      view: "Görüntüleme",
      active: "Aktif",
      passive: "Pasif",
      notRequire: "Onay gerektirmez",
      require: "Onay gerektirir",
      subeventRegistration: "Alt etkinlik kayıtları",
      subeventAddUpdate: {
        title: "Başlık",
        titleMsg: "Bu alt etkinliğe bir isim verin.",
        content: "İçerik",
        contentMsg: "Katılımcılarınızı bu etkinlik hakkında bilgilendirecek detaylı içerik girin.",
        selectAll: "Tümünü seç",
        tagRestriction: "Etiket Kısıtlaması",
        tagRestrictionMsg: "Mobil uygulama üzerinden kayıt olabilecek segmentteki kişileri belirler, belirlenen etiketler dışındaki katılımcılar kayıt olamazlar.",
        registrationTag: "Kayıt Etiketi",
        registrationTagMsg: "Katılımcının alt etkinliğe kayıt durumunu belirler.",
        registrationQuestions: "Kayıt soruları",
        registrationQuestionsMsg: "Kayıt formuna ek sorular ekleyebilir ve katılımcılarınız için özelleştirebilirsiniz.",
        registrationAutomation: "Kayıt otomasyonu",
        registrationAutomationMsgPrd: "Kayıt otomasyon seçeneğini kullanarak, bu ürün için otomatik kayıtlar alabilirsiniz. Satış paketi veya ek hizmet tanımlamanız halinde tanımlanan paket ya da ek hizmeti satın alan katılımcıya otomatik olarak ilgili ürün tanımlanır.",
        registrationAutomationMsg: "Kayıt otomasyon seçeneğini kullanarak, bu alt etkinlik için otomatik kayıtlar alabilirsiniz. Satış paketi veya ek hizmet tanımlamanız halinde tanımlanan paket ya da ek hizmeti satın alan katılımcı otomatik olarak ilgili alt etkinliğe kayıt edilir.",
        packaceBased: "Pakete bağlı",
        additionalServiceBased: "Ek hizmete bağlı",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Bu seçeneği kapattığınızda katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
        limit: "Limit",
        limitMsg: "Bu seçenek alt etkinlik için gelen kayıtları sınırlandırmanızı sağlar.  Katılım limiti dolduğunda gelen kayıtlar otomatik olarak reddedilir.",
        limitMsgPrd: "Bu seçenek ürün için gelen kayıtları sınırlandırmanızı sağlar.  Katılım limiti dolduğunda gelen kayıtlar otomatik olarak reddedilir.",
        stock: "Kontenjan",
        stockMsg: "Alt etkinlik için katılım kontenjanı belirler.",
        stockControl: "Katılım kontrolü",
        stockControlMsg: "Belirtilen kontenjan limitini baz alarak tercih edilen giriş kontrol yöntemine göre kayıtların kontrolünü gerçekleştirir.",
        mobileRegisters: "Mobil kayıtlar",
        mobileRegistersMsg: "Mobil kayıt seçeneği aktif edildiğinde katılımcılar etkinlik programı üzerinden ücretsiz bir şekilde alt etkinliğe kayıt olabilirler.",
        automaticConfirmation: "Otomatik onay",
        automaticConfirmationMsg: "Bu seçeneği aktif ettiğinizde, mobil uygulama üzerinden gelen kayıtlar otomatik olarak onaylanır.",
        controlCenter: "Kontrol noktası",
        controlCenterMsg: "Bu alt etkinlik için tanımlanmış bir kontrolcü bulunmuyor. Bir kontrolcü tanımlamak için “Kontrol noktaları” kısmından yeni bir kontrolcü oluşturarak alt etkinliği tanımlayabilirsiniz.",
        goControlCenter: "Kontrol noktalarına git",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      }
    },
    additionalProducts: {
      records: "Kayıtlar",
      createProduct: "Ürün oluştur",
      searchFilter: "Ara / Filtrele",
      filter: "Filtrele",
      filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
      searchPlaceholder: "Ara...",

      title: "Ürünler",
      capacityMsg: "Ürünler için maksimum satış miktarını belirtiniz.",
      capacity: "Kontenjan",
      view: "Görüntüleme",
      headerTitle: "Başlık",
      productRecords: "Ürün kayıtları",
      dialog: {
        content: "Not",
        contentMsg: "Örnek yazı."
      }
    }
  },
  participantManagament: {
    registrationSearch: {
      detailsParticipant: {
        warning: "Uyarı",
        cancel: "Vazgeç",
        deleteYes: "Evet, sil",
        deleteCancel: "Silme iptal edildi.",
        deleteParticipant: "Kaydı silmek istediğinizden emin misiniz?",
        activationCodeRefresh: "Aktivasyon kodunuz sıfırlanmıştır.",
        unBlockParticipant: "Engeli kaldırmak istediğinizden emin misiniz ?",
        additionalProduct: "Ürün",
        additionalProductName: "Ürün Adı",
        free: "Ücretsiz",
        update: "Güncelle",
        useCam: "Kamera kullan",
        updatePhoto: "Fotoğraf yükle",
        submission: "Gönderim",
        sendVoucher: "Voucher gönder",
        sendCertificate: "Sertifika gönder",
        edit: "Düzenle",
        operations: "İşlemler",
        printCard: "Kart bas",
        checkin: "Check-in",
        addProxy: "Vekil ekle",
        block: "Engelle",
        unblock: "Engeli kaldır",
        editInformation: "Bilgileri düzenle",
        deleteRegistration: "Kaydı sil",
        paymentPendingConfirmation: "Ödeme onay bekliyor",
        paymentPendingConfirmationMsg: "Bu katılımcıya ait bir veya birden fazla ödeme kaydı onay bekliyor. Onaylanmadığı durumda ödeme kayıtlarına bağlı haklardan faydalanamaz.",
        free: "Ücretsiz",
        confirm: "Onayla",
        proxyAppointed: "Vekil ataması yapılmış",
        proxyAppointedMsg: "Bu katılımcıya vekil ataması yapıldığı için, hakları vekile devredilmiştir. Kart yazdırma, check-in vb. kayıt ile ilgili işlemler yapılamaz ve kişi etkinlik alanlarına giriş yapamaz. Yerine vekil olarak atanan kişi bu hakları kullanabilir ve giriş yapabilir.",
        assignedBy: "tarafından atanmıştır",
        dayRestriction: "Gün kısıtlaması",
        dayRestrictionMsg: "Katılımcının kaydı bu günden farklı bir gün olduğu için check-in işlemi yapılamaz. Kart baskı işlemi gerçekleştirildiyse, kontrol noktalarından geçiş sağlayamaz.",
        participationDays: "Katılım günleri :",
        participantBlocked: "Katılımcı engellenmiş",
        participantBlockedMsg: "Katılımcı engellendiği için kart yazdırma ve check-in işlemleri yapılamaz. Katılımcı etkinlik alanındaki kontrol noktalarından geçiş yapamaz.",
        paymentPending: "Ödeme bekliyor",
        paymentPendingMsg: "Katılımcıya ait bir veya birden fazla ürün için ödeme kaydının tanımlanması bekleniyor. Ödeme kaydı tanımlanmadan ilgili haklar tanımanlanmaz.",
        addPayment: "Ödeme ekle",
        watingForApporval: "Onay bekliyor",
        watingForApporvalMsg: "Katılımcının kaydına bağlı bir veya birden fazla ek hizmet onay bekliyor. Onaylanmadığı durumda katılımcı ilgili hizmetlerden faydalanamayacaktır.",
        accompany: "Refakatçi",
        additionalServices: "Ek hizmet",
        paymentsDeclined: "Ödemeler reddedildi",
        paymentsDeclinedMsg: "Bu katılımcının ödemeleri reddedilmiş. Etkinlik alanına giriş için bir paketi bulunmadığı için kart yazdırma ve check-in işlemleri yapılamaz ve katılımcı etkinlik alanına giriş yapamaz.",
        declined: "Reddedildi",
        subeventRegistration: "Alt etkinlik kaydı",
        subeventRegistrationMsg: "Katılımcının kaydına bağlı bir veya birden fazla alt etkinlik kaydı onay bekliyor. Kayıtlar onaylanmadığı durumda katılımcı ilgili alt etkinliğe giriş yapamayacaktır.",
        waitingAbstractApproval: "Abstract onayı bekleniyor",
        waitingAbstractApprovalMsg: "Katılımcının sonuçlandırılmamış bildirileri mevcut. Gerekli kontrollerin sağlandığından emin olun.",
        review: "İncele",
        activationCode: "Aktivasyon kodu",
        activationNotUse: "Bu kod henüz kullanılmamıştır.",
        activeDate: "{0} tarihinde aktif edildi.",
        activationCodeSure: "Aktivasyon kodunu yenilemek istediğinize emin misiniz?",
        participantInformation: "Katılımcı bilgileri",
        yesRefreshBtn: "Evet, yenile",
        cancelBtn: "Vazgeç",
        registrationInformation: "Kayıt bilgileri",
        registrationInfo: {
          registrationForm: "Kayıt formu",
          registrationDate: "Kayıt Tarihi",
          registrationPackage: "Kayıt paketi",
          price: "Fiyat",
          daysOfParticipation: "Katılım günleri",
          noRestrictions: "Kısıtlama yok",
          registrationDate: "Kayıt tarihi"
        },
        subEvent: "Alt etkinlik",
        attendeeSubEventRegistration: {
          subEvent: "Alt etkinlik",
          source: "Kaynak",
          package: "Paket: <b>Standart katılım paketi</b>",
          registrationDate: "Kayıt tarihi",
          confirmationStatus: "Onay durumu",
          confirm: "Onayla",
          reject: "Reddet",
          noSubEventRegistration: "Alt etkinlik kaydı bulunmamaktadır.",
          seeDetails: "Alt etkinlik detaylarını görüntüle",
          edit: "Düzenle",
          delete: "Sil",
          deleteSure: "Bu kaydı silmek istediğinize emin misiniz?"
        },
        attendeeProductRegistration: {
          noProduct: "Ürün kaydı bulunmamaktadır."
        },
        accompany: "Refakatçi",

        attendeeAccom: {
          nameSurname: "İsim, soyisim",
          price: "Fiyat",
          registrationDate: "Kayıt tarihi",
          linkedPayment: "Bağlı ödeme",
          noAffiliatePayments: "Bağlı ödeme yok",
          confirmationStatus: "Onay durumu",
          confirm: "Onayla",
          reject: "Reddet",
          deleteSure: "Bu kaydı silmek istediğinize emin misiniz?",
          deleteYes: "Evet, sil",
          cancel: "Vazgeç",
          noAttendee: "Refakatçi kaydı bulunmamaktadır.",
          seeDetails: "Refakatçi detaylarını görüntüle",
          edit: "Düzenle",
          delete: "Sil",
          deleteSure: "Bu kaydı silmek istediğinizden emin misiniz?"
        },
        attendeeServices: {
          service: "Hizmet",
          price: "Fiyat",
          registrationDate: "Kayıt tarihi",
          linkedPayment: "Bağlı ödeme",
          confirmationStatus: "Onay durumu",
          confirm: "Onayla",
          reject: "Reddet",
          seeDetails: "Ek hizmet detaylarını görüntüle",

          noRegistration: "Ek hizmet kaydınız bulunmamaktadır."
        },

        notices: "Bildiriler",
        add: "Ekle",
        AttendeeAbstract: {
          a: "b",
          waitingDecision: "Karar bekliyor",
          accept: "Kabul et",
          conditionalAccept: "Koşullu kabul et",
          reject: "Reddet",
          deleteSure: "Bu kaydı silmek istediğinize emin misiniz?",
          deleteYes: "Evet, sil",
          cancel: "Vazgeç"
        },
        pendingPayments: "Bekleyen ödemeler",
        addPayment: "Ödeme ekle",
        a: "b",
        attendeeAwaitingPayments: {
          createProforma: "Proforma oluştur"
        },
        payments: "Ödemeler",
        attendeePayments: {
          paymentId: "Ödeme ID",
          paymentMethod: "Ödeme şekli",
          amount: "Tutar",
          registrationDate: "Kayıt tarihi",
          paymentStatus: "Ödeme durumu",
          confirm: "Onayla",
          reject: "Reddet",
          noRegistration: "Ödeme kaydı bulunmamaktadır.",
          seeDetails: "Ödeme detaylarını görüntüle"
        },
        actions: "İşlemler",
        attendeeActions: {
          messages: "İletiler",
          checkin: "Check-in",
          cardPrinting: "Kart baskı",
          certificates: "Sertifikalar",
          promotion: "Promosyon",
          title: "Başlık",
          status: "Durum",
          registrationDate: "Kayıt tarihi",
          dateByWho: "{0} tarafından gerçekleştirildi.",
          system: "Sistem",
          noVouchers: "Bu katılımcıya hiç voucher gönderilmedi.",
          description: "Açıklama",
          standName: "Stant adı",
          noCheckinRegistration: "Check-in kaydı bulunmamaktadır.",
          card: "Kart",
          pressCard: "Basın kartı",
          description: "Açıklama",
          noCards: "Katılımcıya kart bastırılmamış.",
          certificate: "Sertifika",
          firstPlaceCertificate: "Birincilik sertifikası",
          noCertifacete: "Bu katılımcıya sertifika gönderilmedi.",
          show: "Görüntüle",
          promotion: "Promosyon",
          piece: "adet",
          noPromotion: "Bu katılımcı hiç promosyon almadı."
        },
        notes: "Notlar",
        attendeeNotes: {
          note: "Not",
          registrationDate: "Kayıt tarihi",
          noNote: "Not eklenmemiş.",
          createBy: "{0} tarafından oluşturuldu."
        },
        cardPrint: "Kart baskı",
        printCardComp: {
          cardDesign: "Kart tasarımı",
          description: "Açıklama",
          lostCard: "Kayıp kart",
          printerError: "Yazıcı hatası",
          problemTag: "Sorunlu etiket",
          incorrectRegistration: "Hatalı kayıt",
          informationUpdate: "Bilgi güncelleme",
          close: "Kapat",
          print: "Yazdır",
          checkAndPrint: "Yazdır ve check-in yap",
          infoMsg: "Kart yazdırma işlemi başlamıştır",
          moreThanOne: "En az bir katılımcı seçmelisiniz"
        },

        addNote: "Not ekle",
        addParticipantNote: {
          yourNote: "Notunuz"
        },
        takePhoto: "Fotoğraf çek",
        editParticipant: "Katılımcı düzenle",
        addProxyParticipant: "Vekil katılımcı ekle"
      }
    },
    attendeeList: {
      participant: {
        choose: "Seçili {0} kayıt için işlem",
        sendVoucher: "Voucher gönder",
        sendCertificate: "Sertifika gönder",

        batchPrint: "Toplu kart baskı",
        clearSelected: "Seçilenleri temizle",
        deleteSelected: "Seçilenleri sil",
        export: "{0} taslağı indir",
        addAttendee: "Katılımcı Ekle",
        editAttendee: "Katılımcı Düzenle",
        detailsAttendee: "Katılımcı detayları",
        close: "Kapat",
        AttendeeNumber: "Katılımcı No",
        nameSurname: "Ad & Soyad",
        registrationDate: "Kayıt Tarihi",
        filterMsg: "Filtre seçenekleri ile aramanızı daraltın.",
        questions: "Sorular",
        search: {
          searchMsg: "Bağlayacağınız printer için yazıcı numarasını yazdırma aracısından kopyalayabilirsiniz.",
          addRegistrationCoupon: "Kayıt ekle",
          search: "Ara",
          addParticipant: "Katılımcı ekle",
          editParticipant: "Katılımcı düzenle",
          printerId: "Yazıcı ID",
          noFound: "Aranan katılımcı bulunamadı.",
          searchRegister: "Kayıt arama"
        },
        addUpdateParticipant: {
          shoppingCardInfo: "Sadece bilgilendirme amaçlıdır.",
          registrationType: "Kayıt tipi",
          registrationTypeMsg: "Yeni bir katılımcı eklemek için kayıt tipini belirlemelisiniz.",
          registrationForm: "Kayıt formu",
          registrationFormMsg: "Katılımcıyı eklemek istediğiniz kayıt formunu seçiniz. Kayıt formu seçimi yapmadan kayıt tiplerini görüntüleyemezsiniz.",
          registrationPackage: "Kayıt paketi",
          registrationPackageMsg: 'Katılımcıyı eklemek istediğiniz paketi seçiniz. Paketlerden bağımsız olarak katılımcı eklemek için <b>"Manuel"</b> seçeneğini kullanabilirsiniz.',
          participationDay: "Katılım günü",
          participationDayMsg: 'Seçtiğiniz paket <b>"Tek günlük"</b> katılım paketidir. Katılımcının katılması planlanan günü seçiniz.',
          segmentation: "Segmentasyon",
          segmentationMsg: "Katılımcıyı dahil edeceğiniz etiketi seçiniz. Pakete tanımlı bir etiket var ise bu kısım değiştirilemez.",
          attendeeInformation: "Katılımcı bilgileri",
          attendeeInformationMsg: "Yeni bir katılımcı eklemek için kayıt bilgilerini eksiksiz bir şekilde girmelisiniz.",
          photo: "Fotoğraf",
          takePhoto: "Fotoğraf çek",
          photoDragMsg: "Yüklemek için sürükle veya <em>tıkla.</em>",
          photoSizeMsg: "<b>5 mb</b> boyutundan küçük <b>png veya jpg</b> formatında dosya yükleyiniz.",
          subEvents: "Alt etkinlikler",
          subEventsMsg: "Katılımcıyı herhangi bir alt etkinliğe kayıt edebilirsiniz.",
          addRegistration: "Kayıt ekle",
          subEvent: "Alt etkinlik",
          summary: "Özet",
          summaryMsg: "Katılımcının kayıt özetini görebilirsiniz. Katılımcıya refakatçi ve ek hizmet ekleyebilirsiniz.",
          addCompanion: "Refakatçi ekle",
          addService: "Hizmet ekle",
          serviceName: "Hizmet adı",
          unitPrice: "Birim fiyat",
          piece: "Adet",
          amount: "Tutar",
          registration: "Kayıt",
          companion: "Refakatçi",
          additionalService: "Ek hizmet",
          additionalProduct: "Ürünler",
          additionalProductMsg: "Katılımcıya herhangi bir ürün ekleyebilirsiniz.",
          close: "Kapat",
          save: "Kaydet",
          titlesNoSubEventMsg: "Alt etkinlik kaydı eklenmemiş.",
          titlesNoProductMsg: "Ürün kaydı eklenmemiş.",
          productName: "Ürün adı",
          titlesAddEditSubEvent: "Alt etkinlik ekle / düzenle",
          titlesAddEditProduct: "Ürün ekle / düzenle",
          titlesAddEditCompanion: "Refakatçi ekle / düzenle",
          titlesAddEditServices: "Hizmet ekle / düzenle",
          addDialogs: {
            subEvent: "Alt etkinlik",
            close: "Kapat",
            delete: "Sil",
            save: "Kaydet",
            selectService: "Hizmet Seçiniz"
          }
        }
      }
    },
    segmentations: {
      addGroup: "Grup ekle",
      editTag: "Etiketi düzenle",
      deleteTag: "Etiketi sil",
      addTag: "Etiket ekle",
      tagAddUpdate: {
        selectGroup: "Grup seçiniz",
        selectGroupMsg: "Seçeceğiniz grup etiketin dahil olacağı katılımcı grubunu tanımlar.",
        updateGroupList: "Grup listesini günceller.",
        title: "Başlık",
        titleMsg: "Etiketinize bir isim belirleyiniz.",
        color: "Renk",
        stock: "Stok",
        stockMsg: "Bu segmente ait katılımcı limitini belirtebilirsiniz. Sıfır ise limitsiz demektir.",
        colorMsg: "Bu etiket için bir renk belirleyiniz.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Bu seçeneği kapattığınızda katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
        cardPrinting: "Kart baskı",
        cardPrintingMsg: "Bu seçeneği kapattığınızda bu etikete dahil katılımcılar kayıt deskine geldiğinde basılı kart alamazlar.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet",
        titlePlaceholder: "ÖRN: Özel davetliler",
        chooseLabelColorPlaceholder: "Etiket rengi seçiniz"
      },
      groupAddUpdate: {
        title: "Başlık",
        titleMsg: "Grup için bir başlık giriniz.",
        titlePlaceholder: "ÖRN: Özel davetliler",
        color: "Renk",
        colorMsg: "Bu grup için bir renk belirleyiniz.",
        colorPlaceholder: "Grup rengi seçiniz",
        note: "Not",
        noteMsg: "Kendiniz ve ekibiniz için not oluşturabilirsiniz.",
        notePlaceholder: "Notunuzu giriniz...",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklikler yapabilirsiniz.",
        view: "Görüntüleme",
        viewMsg: "Bu seçeneği kapattığınızda katılımcılar uygulamalar ve diğer dijital platformlarda bu içeriği görüntüleyemez.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      }
    }
  },
  components: {
    abstract: {
      tabs: {
        dialog: {
          presentationType: {
            title: "Başlık",
            details: "Detaylar",
            delete: "Sil",
            close: "Kapat",
            save: "Kaydet"
          },
          submissionDialog: {
            title: "Başlık",
            details: "Detaylar",
            delete: "Sil",
            close: "Kapat",
            save: "Kaydet"
          }
        },
        abstractAuthors: {
          instruction: "Yazarlar için talimatlar",
          instructionMsg: "Yazarlar için kısa bir bildiri kılavuzu sağlayın.",
          instructionMsgSpecial: "Talimat sadece bildiri göndermek isteyenler için görüntülenecektir.",
          authors: "Yazarlar",
          authorsMsg: "Yazarlar için kısa bir bildiri kılavuzu sağlayın.",
          title: "Başlık",
          save: "Kaydet"
        },
        abstractDetailSettings: {
          abstractTitle: "Bildiri başlık",
          abstractTitleMsg: "Bildiri başlığı zorunlu bir alandır ve özet gönderirken doldurulmalıdır.",
          title: "Başlık",
          maxWordLimit: "Maks. kelime sınırı",
          keywords: "Anahtar kelimeler",
          keywordsMsg: "Yazarların anahtar kelime eklemesine izin ver.",
          limit: "Limit",
          references: "Referanslar",
          referencesMsg: "Yazarların referans eklemesine izin ver.",
          save: "Kaydet"
        },
        abstractEvaluationSettings: {
          guide: "Yorumcular için yönergeler",
          guideMsg: "İnceleyenlere bir değerlendirme kılavuzu sağlayın.",
          scoreFormat: "Hakem puanlama yöntemi",
          scoreFormatMsg: "İnceleyenlerin bildirimleri değerlendirmesi için bir puanlama yöntemi seçin.",
          accepted: "Kabul edildi.",
          conditionallyAccepted: "Şartlı kabul edildi.",
          reject: "Reddet",
          reviewSettings: "Hakem değerlendirmesi ayarları",
          reviewSettingsMsg: "İnceleyenlerin bildirileri değerlendirmesi için bir inceleme ayarı seçin.",
          enablePeerReview: "Kapalı incelemeyi etkinleştir.",
          enablePeerReviewMsg: "Hakemlerin ve yazarların başvuran kişinin kimlik bilgilerine erişimini engelle.",
          otherReviewersScore: "Diğer yorumcuların puanlarını göster",
          otherReviewersScoreMsg: "Yorumcuların diğer yorumcuların puanlarını görmesine izin ver.",
          sendReminder: "İnceleyenlere değerlendirme hatırlatıcısı gönder",
          sendReminderMsg: "Değerlendirilmeyi bekleyen başvurular olduğunda, inceleyene hatırlatma e-postası gönderilecektir.",
          lockAbstract: "Özet değerlendirme sistemini kilitle",
          lockAbstractMsg: "Hakemlerin özetleri değerlendirmesini engelle.",
          save: "Kaydet"
        },
        abstractGeneralSettings: {
          notificationCollect: "Bildiri toplama yöntemi",
          notificationCollectMsg: "Bildirileri nasıl toplamak istediğinizi seçiniz.",
          textUpload: "Metin yükleme",
          fileUpload: "Dosya yükleme",
          label: "Başlık",
          placeholder: "Placeholder",
          hint: "İpucu",
          wordLimit: "Kelime sınırı",
          wordLimitMsg: "Minimum ve maksimum kelime sınırlarını tanımlayın.",
          minChar: "İzin verilen min. karakter",
          maxChar: "İzin verilen maks. karakter",
          allowImageUpload: "Resim yüklemeye izin ver.",
          allowImageUploadMsg: "Minimum ve maksimum kelime sınırı belirleyiniz..",
          maxSize: "Maks. dosya boyutu(mb)",
          allowFile: "İzin verilen dosya türleri",
          imgFile: "Görüntü dosyaları",
          textFile: "Metin dosyaları",
          spreadsheetFile: "Elektronik tablo dosyaları",
          presentationFile: "Sunum dosyaları",
          compressedFile: "Sıkıştırılmış dosyalar",
          save: "Kaydet"
        },
        abstractPackages: {
          abstractPackages: "Bildiri paketleri",
          abstractPackagesMsg: "Bildiri sisteminin devreye gireceği kayıt formunu ve paketleri seçiniz. Katılım kaydı alındıktan sonra bildiri girişi için ayrı bir yönlendirme gönderilecektir.",
          save: "Kaydet"
        },
        abstractRules: {
          limitSubmisson: "Bildiri süresini sınırla",
          limitSubmissonMsg: "Başlangıç tarihi ve son teslim tarihi belirterek bildiri süresini sınırlayın.",
          startDate: "Başlangıç tarihi",
          endDate: "Bitiş tarihi",
          limitNumberSubmission: "Bildiri limiti",
          limitNumberSubmissionMsg: "Kayıt veya sunum türlerine göre bildiri sayısını sınırlayın.",
          maxValueParticipant: "Katılımcı başına maksimum değer",
          maxValueParticipantMsg: "Kayıt türü başına bildiri sayısını sınırlayın veya gizlemek için 0 girin.",
          presentationType: "Sunum türü",
          limitNumber: "Limit",
          save: "Kaydet",
          pickDay: "Bir gün seç"
        },
        abstractSubmission: {
          submission: "Bildiri konuları",
          submissionMsg: "Konferans konularını tanımlayın ve yazarların özetlerini bu konulara göre göndermelerini sağlayın.",
          title: "Başlık",
          topicsTracks: "Konular",
          addTopicTrack: "Konu/parça ekle",
          presentationType: "Sunum türleri",
          presentationTypeMsg: '"Sözlü" veya "Poster" gibi sunum türleri oluşturun ve yazarların özetlerini bu formatlarda göndermelerini sağlayın.',
          title: "Başlık",
          presentationType: "Sunum türleri",
          show: "Görüntüleme",
          addPresentationType: "Sunum türü ekle",
          topicTrackDetails: "Konu ayrıntıları",
          presentationTypesDetails: "Sunum türleri ayrıntıları",
          save: "Kaydet"
        }
      }
    },
    automatedmessages: {
      automatedLogs: {
        filter: "Filtrele",
        search: "Arama",
        draft: "Taslak",
        status: "Durum",
        close: "Kapat",
        reset: "Sıfırla",
        participant: "Katılımcı",
        messageNameTypeSubject: "İleti adı, tür, konu",
        postMessageStatusAction: "Gönderi, ileti durumu, işlem",
        participantNo: "Katılımcı no",
        all: "Tümü"
      },
      controlPointLogs: {
        filter: "Filtrele",
        search: "Arama",
        controlType: "Kontrol tipi",
        status: "Durum",
        close: "Kapat",
        reset: "Sıfırla",
        participant: "Katılımcı",
        controlType: "Kontrol tipi",
        checkpoint: "Kontrol noktası",
        status: "Durum",
        date: "Tarih",
        download: "İndir",
        participantNo: "Katılımcı no",
        all: "Tümü"
      },
      programReminder: {
        defaultEn: "Varsayılan (İngilizce)",
        tr: "Türkçe",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklik yapabilirsiniz.",
        show: "Görüntüleme",
        showMsg: "Görüntüleme seçeneğini kapattığınızda, katılımcılar mobil uygulama ve diğer dijital platformlar üzerinden bu içeriklere erişemez ve görüntüleyemez.",
        close: "Kapat",
        save: "Kaydet",
        subject: "Konu",
        variables: "Kullanılabilir değişkenler",
        notification: "Bildirim"
      },
      voucherAddUpdate: {
        defaultEn: "Varsayılan (İngilizce)",
        tr: "Türkçe",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklik yapabilirsiniz.",
        show: "Görüntüleme",
        showMsg: "Görüntüleme seçeneğini kapattığınızda, katılımcılar mobil uygulama ve diğer dijital platformlar üzerinden bu içeriklere erişemez ve görüntüleyemez.",
        submission: "Gönderim",
        submissionMsg: "Gönderim seçeneğini kapattığınızda kullanıcılar işlem menüleri üzerinde bu içeriği görüntüleyemez.",
        showQr: "QR kodu göster",
        showQrMsg: "Bu seçenek gizlendiğinde, QR kod ile hızlı giriş seçenekleri kapatılır. Bu işlem onsite etkinlikler için tavsiye edilmez.",
        showLocation: "Konum ve adres bilgilerini göster",
        showLocationMsg: "Konum ve adres bilgilerini gizlediğinizde katılımcılar etkinlik konumu ile ilgili bilgiye erişemez. Onsite etkinlikler için bu işlem önerilmez.",
        showMobileDownload: "Mobil uygulama indirme bağlantılarını göster",
        showMobileDownloadMsg: "Mobil uygulama indirme bağlantılarını gizlediğinizde katılımcılar etkinlik mobil uygulamalarını indirmekte sorun yaşayabilir. Etkileşimli bir etkinlik deneyimi için  bu seçeneği açık tutmanız önerilir.",
        showWebLogin: "Web uygulama giriş bağlantılarını göster",
        showWebLoginMsg: "Web uygulama giriş bağlantılarını gizlediğinizde katılımcılar etkinliğe web üzerinden giriş yapmakta sorun yaşayabilir. Etkileşimli bir etkinlik deneyimi için bu seçeneği açık tutmanız önerilir.",
        showActivation: "Aktivasyon kodunu göster",
        showActivationMsg: "Aktivasyon kodunu gizlediğinizde katılımcılar online etkinliklere katılamazlar. Onsite etkinliklerde ise katılımcılar mobil uygulamaları kullanamazlar.",
        showQuicklogin: "Hızlı giriş bağlantılarını göster",
        showQuickloginMsg: "Hızlı giriş bağlantısını gizlediğinizde katılımcılar otomatik aktivasyon seçeneğini kullanamaz. Online etkinlikler için bu seçeneği kapatmanız önerilmez.",
        showOrganizerInfo: "Organizator bilgilerini göster",
        showOrganizerInfoMsg: "Kuruluş bilgilerini gösterir / gizler.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet",

        title: "Başlık",
        titleMsg: "Mesaj başlığı olarak görüntülenir",
        replyEmail: "Yanıtlama e-postası",
        replyEmailMsg: "Gireceğiniz e-posta adresi “gönderen” e-postası olarak görüntülenir.",
        subject: "Konu",
        subjectMsg: "İletinizin konusu olarak görüntülenir.",
        variables: "Kullanılabilir değişkenler",
        variablesMsg: "İletide sabit kullanmak istediğiniz ve katılımcıya göre özelleştirilen değişkenleri belirleyebilirsiniz.",
        message: "Mesaj",
        messageMsg: "Göndereceğiniz iletinizin içeriğini ve mesajınızı oluşturun."
      }
    },
    dashboard: {
      summary: "Özet",
      abstract: {
        notice: "Bildiri",
        accepted: "Kabul edildi.",
        conditionally: "Şartlı kabul edildi",
        rejected: "Reddedildi",
        waiting: "Bekliyor"
      },
      certificate: {
        digitalCertificate: "Dijital sertifika analizi",
        certificateExpiry: "Sertifika son geçerlilik tarihi:",
        certificate: "Sertifika",
        submitted: "Gönderildi",
        forwarded: "İletildi",
        readed: "Okundu",
        queue: "Gönderim sırasında",
        error: "Hata"
      },
      content: {
        cantAccess: "Bu özelliğe erişemezsiniz.",
        cantAccessMsg: "Aboneliğiniz bu özelliği desteklemiyor.Uygun bir paket tercih ederek planınızı yükseltebilirsiniz ve erişebilirsiniz.",
        upgrade: "Yükselt",
        posts: "Gönderiler",
        sessionReview: "Oturum değerlendirmeleri",
        review: "inceleme",
        contents: "İçerikler",
        networkingRooms: "Networking odaları",
        subActivity: "Alt etkinlik analizi",
        productActivity: "Ürün analizi",
        postType: "Gönderi türü",
        sharing: "Paylaşım",
        comment: "Yorum",
        like: "Beğeni",
        program: "Program",
        average: "Ortalama",
        review: "İnceleme",
        speakers: "Konuşmacılar",
        content: "İçerik",
        room: "Oda",
        reports: "Raporlar",
        subEvent: "Alt etkinlik",
        product: "Ürünler",
        confirmation: "Onay",
        waiting: "Bekliyor",
        rejection: "Red",
        total: "Katılımcılar",
        seeLess: "Daha az gör",
        seeAll: "Tümünü gör"
      },
      live: {
        hall: "Salon",
        onlineMeasurement: "Online",
        watchTime: "İzlenme süresi",
        broadcastTime: "Süre",
        minute: "dk.",
        recordingMessage: "Kayıtlı dosyalar 30 gün sonra otomatik olarak silinir.",
        totalFiles: "{0} adet dosya kaydedildi"
      },
      notification: {
        voucherEmails: "Voucher e-postaları",
        voucherSms: "Voucher SMS'ler",
        automaticEmails: "Otomatik ileti e-postaları",
        notificationEmails: "Bilgilendirme e-postaları"
      },
      onsite: {
        total: "toplam",
        unique: "tekil",
        checkin: "Check-in analizi",
        automaticCheckin: "Otomatik check-in analizi",
        standCheckin: "Stant check-in analizi",
        accessControl: "Geçiş kontrol analizi",
        cardPrinting: "Kart baskı analizi",
        promotionalDistribution: "Promosyon dağıtım analizi",
        placeholderAll: "Tümü"
      },
      overview: {
        participantSegmentation: "Katılımcı segmentasyonu",
        labelTotal: "{0} etiket, toplam {1} katılımcı"
      },
      registration: {
        piece: "adet",
        seeLess: "Daha az gör",
        seeAll: "Tümünü gör",
        paymentAnalysis: "Ödeme analizi",
        packages: "Paketler",
        additionalServices: "Ek hizmetler",
        couponCodes: "Kupon kodları",
        expectedParticipation: "Beklenen katılım analizi",

        paymentType: "Ödeme türü",
        today: "Bu gün",
        last1: "Son 1 ay",
        last3: "Son 3 ay",
        allTime: "Tüm zamanlar",
        package: "Paket",
        stockUsage: "Stok / Kullanım",
        amount: "Tutar",
        service: "Hizmet",
        reminder: "Kalan",
        codeGroup: "Kod grubu",
        totalDiscont: "Toplam indirim",
        day: "Gün"
      }
    },
    eventinfo: {
      pageModuleUpdate: {
        defaultEn: "Varsayılan (İngilizce)",
        tr: "Türkçe",
        content: "İçerik",
        contentMsg: "Modül içeriğini tanımlar.",
        settings: "Ayarlar",
        settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklik yapabilirsiniz.",
        show: "Görüntüleme",
        showMsg: "Görüntüleme seçeneğini kapattığınızda katılımcılar ve ziyaretçiler içeriğe erişemez ve görüntüleyemez.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      }
    },
    eventprogram: {
      eventProgramRate: {
        filter: "Filtrele",
        search: "Arama",
        searchPlaceholder: "Arama...",
        participantNumber: "Katılımcı no",
        participantNumberPlaceholder: "Katılımcı no",
        reset: "Sıfırla",
        participant: "Katılımcı",
        evaluation: "Değerlendirme",
        status: "Durum",
        confirm: "Onayla",
        reject: "Reddet",
        close: "Kapat"
      }
    },
    participants: {
      addPictureCamera: {
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet",
        take: "Çek",
        again: "Yeniden çek"
      },
      sendVoucher: {
        draftSelection: "Taslak seçimi",
        certificateSelection: "Sertifika seçimi",
        voucherType: "Voucher tipi",
        sendingStart: "Voucher gönderimi başladı",
        sendingCertificateStart: "Sertifika gönderimi başladı",
        sendingStartInfo: "Lütfen işlem süresince bu ekranı kapatmayınız.",
        sendingEnd: "Voucher gönderim işlemi tamamlanmıştır.",
        sendingCertificateEnd: "Sertifika gönderim işlemi tamamlanmıştır.",
        startSending: "Gönderimi başlat"
      }
    },

    registerForm: {
      questionEdit: {
        dateFormat: "Tarih Formatı",
        label: "Başlık",
        tag: "Etiket",
        defineQuestion: "Soruyu tanımlar.",
        placeholder: "Örnek metin",
        placeholderMsg: "Sorunun cevap giriş kısmındaki örneklem metnini tanımlar.",
        hint: "İpucu",
        hintMsg: "Sorunun cevap alanındaki uyarı metnini tanımlar.",
        initialValue: "Başlangıç değeri",
        initialValueMsg: "Sorunun rakamsal başlangıç değerini tanımlar.",
        minValue: "En az değer",
        minValueMsg: "Sorunun en az alabileceği rakamsal değeri tanımlar.",
        maxValue: "En fazla değer",
        maxValueMsg: "Sorunun en fazla alabileceği rakamsal değeri tanımlar.",
        step: "Adım",
        stepMsg: "Sorunun her bir adımda rakamsal olarak kaç değer artırılıp azaltılabileceğini tanımlar.",
        textTransform: "Formata göre düzenle",
        textTransformMsg: "Soruya verilen cevap metninin belirlenen formata göre düzenlenme işlemini tanımlar.",
        minCharAllowed: "En az izin verilen karakter",
        minCharAllowedMsg: "Sorunun alabileceği minimum kelime sayısını tanımlar.",
        maxCharAllowed: "İzin verilen maksimum karakter",
        maxCharAllowedMsg: "Sorunun maksimum alabileceği kelime sayısını tanımlar.",
        minLineAllowed: "İzin verilen minimum satır",
        minLineAllowedMsg: "Soruya verilen cevap metninin maksimum kaç satır olabileceğini tanımlar.",
        color: "Renk",
        colorMsg: "Soru için belirlenen rengi tanımlar.",
        domainRestriction: "Alan adı kısıtlaması",
        domainRestrictionMsg: 'Sorunun e-posta alan adı kısıtlamalarını tanımlar. Örneğin <b>"@holacon.com"</b> alan adı kısıtlaması tanımlandığında sadece tanımlı alan adından gelecek cevapları kabul eder.',
        countryCodeRestriction: "Ülke kodu kısıtlaması",
        countryCodeRestrictionMsg: 'Sorunun telefon ülke kodu kısıtlamalarını tanımlar. Örneğin <b>"+90"</b> kod kısıtlaması tanımlandığında sadece Türkiye ülke kodunu içeren numaralı cevapları kabul eder.',
        maxFileSize: "Maksimum boyut",
        maxFileSizeMsg: 'Sorunun alabileceği cevabın <b>"Megabayt"</b> cinsinden dosya yükleme limitini tanımlar.',
        addSearchBox: "Arama kutusu ekle",
        multipleSelection: "Çoklu seçime izin ver",
        fileType: "İzin verilen dosya türleri",
        fileTypeMsg: "Soruya verilecek cevabın dosya formatını tanımlar.",
        imageFiles: "Görüntü dosyaları",
        textFiles: "Metin dosyaları",
        spreadsheetFiles: "Elektronik tablo dosyaları",
        presentationFiles: "Sunum dosyaları",
        compressedFiles: "Sıkıştırılmış dosyalar",
        showOptions: "Görüntüleme seçenekleri",
        showOptionsMsg: "Bu sorunun görüntülenme seçeneklerini paketlere göre düzenleyebilirsiniz.",
        show: "Göster",
        required: "Zorunlu",
        hide: "Gizle",
        showOptions: "Görüntüleme seçenekleri",
        showOptionsMsg: "Bu sorunun görüntülenme seçeneklerini hizmetlere göre düzenleyebilirsiniz.",
        close: "Kapat",
        delete: "Sil",
        save: "Kaydet"
      },
      questionLibrary: {
        addQuestion: "Soru ekle",
        label: "Etiket",
        questionType: "Soru tipi",
        required: "Zorunlu",
        show: "Göster",
        singleLineText: "Tek satır metin",
        singleLineTextMsg: "Yanıtları tek satır metin olarak alır.",
        informationBanner: "Bilgi kutusu",
        informationBannerMsg: "Herhangi bir ek bilgi verebilirsiniz.",
        multiLineText: "Çok satırlı metin",
        multiLineTextMsg: "Yanıtları çok satırlı metin olarak alır.",
        multipleChoiceQuestion: "Çoktan seçmeli soru",
        multipleChoiceQuestionMsg: "Yanıtlar için birden fazla seçenek seçilebilir.",
        singleChoiceQuestion: "Tek seçenekli soru",
        singleChoiceQuestionMsg: "Yanıtlar için tek bir yanıt seçilebilir. ",
        predefinedQuestions: "Ön tanımlı sorular",
        photo: "Fotoğraf",
        title: "Unvan",
        instituon: "Kurum",
        company: "Şirket",
        department: "Bölüm",
        school: "Okul",
        mobilePhone: "Cep telefonu",
        workPhone: "İş telefonu",
        country: "Ülke",
        state: "Devlet",
        city: "Şehir",
        postalCode: "Posta kodu",
        addressLine: "Adres satırı",
        hesCode: "HES kodu",
        customQuestions: "Özel sorular",
        email: "E-posta",
        phoneNumber: "Telefon numarası",
        fileUpload: "Dosya yükleme",
        number: "Sayı",
        selectDropdown: "Açılır menü",
        datepicker: "Tarih seçimi",
        timepicker: "Saat seçimi",
        richTextEditor: "Metin editörü",
        informationQuestions: "Bilgi soruları",
        slider: "Slider",
        rate: "Değerlendirme",
        emotionRate: "Duygu derecelendirme ölçeği",
        infoBlock: "Bilgi kutusu"
      },
      recursiveQuestion: {
        deleteSure: "Silmek istediğinizden emin misiniz?",
        copySure: "Kopyalamak istediğinizden emin misiniz?",
        editQuestion: "Soruyu düzenle",
        deleteQuestion: "Sil",
        copyQuestion: "Soruyu kopyala",
        yes: "Evet",
        cancel: "Vazgeç",
        addSubQuestion: "Alt soru ekle",
        deleteOption: "Sil",
        discardSubQuestion: "Alt soruları sil",
        editQuestion: "Düzenle",
        addQuestion: "Ekle",
        addOption: "Seçenek ekle",

        questions: "Sorular",
        options: "Seçenekler",
        expand: "Genişlet",
        collapse: "Daralt",
        label: "Başlık",
        questionType: "Soru türü",
        required: "Zorunlu",
        show: "Görüntüleme",

        customLineQuestion: "Özel sorular",
        singleLineText: "Tek satır metin",
        multiLineText: "Çok satırlı Metin",
        email: "E-posta",
        phoneNumber: "Telefon numarası",
        fileUpload: "Dosya yükleme",
        number: "Numara",
        multipleChoiceQuestion: "Çoktan seçmeli soru",
        singleChoiceQuestion: "Tek seçenekli soru",
        selectDropdown: "Açılır menü",
        datePicker: "Tarih seçimi",
        timePicker: "Zaman seçimi",
        richTextEditor: "Metin editörü",
        informationQuestions: "Bilgi soruları",
        slider: "Slider",
        rate: "Değerlendirme",
        emotionRate: "Duygu derecelendirme ölçeği",
        infoBlock: "Bilgi kutusu"
      }
    },
    socialhub: {
      comment: {
        openContatRegistration: "Kişi kaydını aç",
        editComment: "Yorumu düzenle",
        deleteComment: "Yorumu sil",
        cancel: "Vazgeç",
        comment: "Yorum",
        reply: "Yanıtla",
        noMoreLikes: "Başka beğeni yok",
        noLikes: "Henüz beğeni yok",
        like: "Beğeni",
        justEdited: "az önce düzenlendi.",
        openContactRecord: "Kişi kaydını aç",
        editReply: "Yanıtı düzenle",
        deleteReply: "Yanıtı sil",
        justNow: "az önce",
        loadOldComments: "Eski yorumları yükle"
      },
      createPost: {
        post: "Gönderi",
        picMsg: "Lütfen 640x480 ölçülerinde bir fotoğraf yükleyiniz.",
        createsContent: "İçerik ve duyuru türünde gönderi oluşturur.",
        vote: "Oylama",
        createVote: "İçerisinde oylama bulunan bir gönderi oluşturur.",
        survey: "Anket",
        createSurvey: "İçerisinde anket bulunan bir gönderi oluşturur.",
        subject: "Konu",
        defineSubjectContent: "Yayınlanacak içerik için bir konu tanımlar.",
        liveSession: "Canlı oturum",
        allowsPost: "Gönderinin belirli bir canlı oturumda paylaşılmasını sağlar. Paylaşılan içerik sadece ilgili canlı oturuma katılan kişilerin akışında görünür.",
        sendNotification: "Bildirim gönder",
        contentNotification: "Paylaşılan içerik uygulama kullanıcılarının telefonlarına bildirim olarak gönderilir.",
        draft: "Taslak",
        savePost: "Gönderiyi daha sonra düzenleyebilmek ve paylaşabilmek için taslak olarak kaydeder.",
        title: "Başlık",
        defineTitle: "Oluşturulacak anketin başlığını tanımlar.",
        save: "Kaydet",
        share: "Paylaş",
        placeholderSelect: "Seçiniz...",
        announcementError: "Duyuru ve bildirim gönderilicek postlar, taslak olarak kaydedilemez."
      },
      postCard: {
        edited: "düzenlendi",
        draft: "Taslak",
        rejected: "Reddedildi",
        waiting: "Bekliyor",
        openContactRegistration: "Kişi kaydını aç",
        publishDraft: "Taslağı yayınla",
        confirmShipment: "Gönderiyi onayla",
        rejectPost: "Gönderiyi reddet",
        reflectVoting: "Oylamayı yansıt",
        stopvoting: "Yansıtmayı durdur",
        downloadResult: "Sonuçları indir",
        endVoting: "Oylamayı sonlandır",
        endPoll: "Anketi sonlandır",
        restartVoting: "Oylamayı tekrar başlat",
        restartPoll: "Anketi tekrar başlat",
        sendReminderNotification: "Hatırlatma bildirimi gönder",
        editPost: "Düzenle",
        deletePost: "Sil",
        subject: "Konu:",
        bigSubject: "KONU",
        almostTwelveQuestion: "Yaklaşık 12 sorudan oluşmaktadır.",
        next: "Sonraki",
        joinedPeopleVoting: "kişi oylamaya katıldı.",
        joinedPeoplePoll: "kişi ankete katıldı.",
        peopleTalkingAboutIt: "kişi bu konuda konuşuyor.",
        comment: "Yorum",
        doComment: "Yorum yap",
        deleteComment: "Yorumu sil",
        youAndPeopleLiked: "Siz ve {0} kişi beğendi.",
        peopleLiked: "kişi beğendi.",
        noMoreComment: "Başka yorum yok.",
        noComment: "Henüz yorum paylaşılmamış.",
        hideComment: "Yorumları gizle",
        hideReply: "Yanıtları gizle",
        pollEnded: "Oylama tamamlandı.",
        vote: "Oyla",
        youJoinedPoll: "Bu ankete katıldınız.",
        join: "Katıl",
        cancel: "Vazgeç",
        reply: "Yanıtla",
        youLikedIt: "Beğendiniz",
        like: "Beğen",
        continueReading: "Devamını oku",
        votingEnded: "Oylama sonlanmıştır.",
        surveyQuestionNumber: "Anket yaklaşık {0} sorudan oluşmaktadır.",
        loadMore: "Daha fazla yükle",
        pleaseWrite: "Lütfen yorum kutucuğunu doldurunuz.",
        pleaseSelectToDelete: "Lütfen silinecek içerik türü belirtiniz",
        likeListUploadMsg: "Beğeni Listesi Yüklendi"
      },
      socialHub: {
        stream: "Akış",
        drafts: "Taslaklar",
        settings: "Ayarlar"
      },
      socialHubDrafts: {
        noMorePosts: "Başka gönderi yok.",
        noPostShared: "Henüz gönderi paylaşılmamış."
      },
      socialHubFeed: {
        newPost: "Yeni gönderi",
        search: "Arama",
        sort: "Sıralama",
        postType: "Gönderi türü",
        subject: "Konu",
        status: "Durum",
        clearFilter: "Filtreyi temizle",
        noMorePosts: "Başka gönderi yok.",
        noPostShared: "Henüz gönderi paylaşılmamış.",

        placeholderSearch: "Ara...",
        placeholderSelect: "Seçiniz..."
      },
      socialHubSettings: {
        subjects: "Konular",
        addSubject: "Konu ekle",
        color: "Renk",
        show: "Görüntüleme",
        deleteTopic: "Konuyu sil",
        socialHubSettings: "Sosyal akış ayarları",
        autoPublish: "Gönderiler otomatik onaylansın",
        autoApproval: "Gönderiler onaya gönderilsin",
        closeNew: "Yeni gönderilere kapat",
        otherTransactions: "Diğer işlemler",
        clearSocialHub: "Sosyal akışı temizle<span>Sosyal akışta paylaşılan tüm içerikleri temizleyebilirsiniz. Bu işlem geri alınamaz.",
        deleteSelected: "Seçili içerikleri sil",

        enterTopicTitle: "Konu başlığı yazınız...",
        placeholderSelect: "Seçiniz...",
        deleteSure: "Silmek istediğinize emin misiniz?"
      }
    },
    eventWrapper: {
      createPost: "Gönderi oluştur",
      socialHub: "Sosyal hub",
      createPost: "Gönderi oluştur",
      export: "Dışa aktar",
      import: "İçe aktar",
      sendVoucher: "Voucher gönder",
      paymentDetail: "Ödeme detayı",
      participantDetails: "Katılımcı detayları",
      close: "Kapat"
    },
    excelImportAndExport: {
      registrationForm: "Kayıt Formu",
      placeholderSelect: "Seçiniz...",
      transferCompleted: "Aktarım işlemi tamamlanmıştır.",
      errorList: "Hata listesi",
      close: "Kapat",
      clear: "Temizle",
      save: "Kaydet",
      infoMsg1: "Verileri dışa aktarmak üzeresiniz",
      infoMsg2: "Lütfen işlem boyunca bu ekranı kapatmayınız...",
      total: "Toplam",
      start: "Aktarımı başlat"
    },
    homeMenu: {
      createOrganization: "Kuruluş oluştur",
      organizationType: "Kuruluş türü"
    },
    itemInfo: {
      lastUser: "Son işlem yapan kullanıcı",
      creation: "Oluşturulma:",
      update: "Güncellenme: "
    },
    liveSessionAddUpdate: {
      close: "Kapat",
      delete: "Sil",
      save: "Kaydet"
    },
    participantAddOrUpdate: {
      auths: "Yetkili kullanıcılar",
      authsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklik yapabilirsiniz.",
      addAuth: "Yeni bir yetkili kullanıcı ekleyin",
      add: "Ekle",
      speaker: "Konuşmacı",
      task: "Görev",
      show: "Görüntüleme",
      settings: "Ayarlar",
      settingsMsg: "İçerik ile ilgili mevcut ayarlarda değişiklik yapabilirsiniz.",
      show: "Görüntüleme",
      showMsg: "Bu seçeneği kapattığınızda, kullanıcılar mobil uygulama ve diğer dijital platformlar üzerinden bu içeriği görüntüleyemez ve erişemez.",
      accessControl: "Geçiş kontrol otomasyonu",
      accessControlMsg: "Bu salon için geçiş kontrol otomasyonunu aktif ettiğinizde, dijital kontrol noktalarında giriş kontrol işlemlerini gerçekleştirebilirsiniz.",
      noController: "Bu networking odası için tanımlanmış bir kontrolcü bulunmuyor. Kontrolcü tanımlamak için “Kontrol noktaları” kısmından yeni bir kontrolcü oluşturarak networking odasına tanımlayabilirsiniz.",
      goControlCenter: "Kontrol noktalarına git",

      placeholderSelectAuth: "Yetkili kullanıcı seçiniz"
    },
    seatingManagement: {
      placeholderSearchAttendee: "Katılımcı ara...",
      noOther: "Başka katılımcı yok",
      noFound: "Hiç katılımcı bulunamadı.",
      tableNumbers: "{0} masaya {1} kişi yerleştirildi",
      updating: "Güncelleniyor",
      createTable: "Masa oluştur",
      person: "Kişi",
      delete: "Sil",
      table: "Masa"
    },
    subEventRecords: {
      filter: "Filtrele",
      subEvents: "Alt etkinlikler",
      status: "Durum",
      participant: "Katılımcı",
      subEventRecords: "Alt etkinlik kayıtları",
      confirm: "Onayla",
      reject: "Reddet",

      placeholderAll: "Tümü"
    },
    vimeoLiveSessionAddUpdate: {
      coverPhoto: "Kapak fotoğrafı",
      photoSize: "500x135 px ölçülerinde bir fotoğraf kullanabilirsiniz.",
      manage: " Sahneleri yönet",
      manage: "Sahneleri Yönet"
    },
    userMini: {
      userNotFound: "Kullanıcı Bulunamadı"
    }
  },
  pages: {
    event: {
      abstractManagement: {
        abstractSettings: "Bildiri ayarları"
      },
      eventDashboard: {
        overview: "Genel bakış",
        registrationSale: "Kayıt & Satış",
        notices: "Bildiriler",
        liveEvent: "Sanal etkinlik",
        contentAnalysis: "İçerik analizi",
        certificate: "Sertifika",
        messageAnalysis: "İleti analizi",
        onsiteAnalysis: "Onsite analizi",
        updateTime: "Veriler {0} güncellendi.",
        overview: "Genel bakış",
        excelDownload: "Raporlar",
        notices: "Bildiriler",
        liveEventExperience: "Sanal etkinlik",
        contentAnalysis: "İçerik analizi",
        digitalCertificate: "Dijital sertifika",
        onsiteAnalysis: "Onsite analizi"
      }
    },
    newAccount: {
      welcome: "Hoşgeldiniz",
      cantCreate: "Daha önce bir etkinlik oluşturmadınız.",
      createFirstEvenet: "İlk etkinliğinizi oluşturun.",
      create: "OLUŞTUR",
      activateCouponCode: "Eğer bir kupon kodunuz varsa kullanabilirsiniz.",
      activate: "AKTİFLEŞTİR",
      placeholderTypeEvent: "Etkinlik adını giriniz.",
      placeholderTypeCoupon: "Kupon kodunuzu giriniz."
    },
    organisationAttendees: {
      attendees: "Katılımcılar",
      pleaseSelectEvent: "Lütfen bir etkinlik seçiniz",
      attendee: "Katılımcı",
      uniqValue: "Eşsiz değer"
    }
  },
  archiveModal: {
    fileName: "Dosya adı",
    fileSize: "Boyutu",
    session: "Oturum",
    date: "Tarih",
    close: "Kapat"
  },
  redeemModal: {
    title: "Kampanya kodu",
    text: "Kampanya kodlarıyla hesabınızı bir üst pakete taşıyabilirsiniz!",
    buttonText: "Kaydet",
    placeHolder: "Kampanya kodunuz"
  },
  commonMessages: {
    changesNeedsToSave: "Kaydedilmeyi bekleyen değişiklikleriniz var."
  },
  b2b: {
    start_time: "Başlangıç saati",
    end_time: "Bitiş saati",
    appointmentMinute: "Görüşme süresi (dakika)",
    minute: "dakika",
    text: "B2B eşleşme özelliğini aktif ederek katılımcıların randevu oluşturmasını sağlayabilirsiniz."
  },
  // generic messages could be added here
  generic: {
    standard: "Standart",
    uploadText: "Dosyayı buraya bırakın veya <em>yüklemek için tıklayın</em>",
    sendCertificate: "Sertifika gönder",
    newOption: "Yeni Seçenek",
    status: "Durum",
    generatingPleaseWait: "Oluşturuluyor, lütfen bekleyiniz.",
    recaptcha: "Lütfen recaptcha doğrulamasını tamamlayınız.",
    picMsg: "500x500 fotoğraf yükle",
    nothingFound: "Herhangi bir kayıt bulunamadı.",
    deleteSure: "Silmek istediğinize emin misiniz?",
    deleteYes: "Evet, sil",
    operationCancel: "Vazgeç",
    hide: "Gizle"
  }
};
export default tr;



// WEBPACK FOOTER //
// ./src/language/tr.js